"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const hits = [
    {
        type: 0,
        address: { street: "Комендантский проспект", houseNumber: 58 },
        position: { lat: 60.0337712, lng: 30.2267828 },
        date: new Date(1943, 9, 4),
        description: "Пробито чердачное перекрытие 3 этажа.",
    },
    {
        type: 0,
        address: { street: "Большеохтинский проспект", houseNumber: 6 },
        position: { lat: 59.9498604, lng: 30.4093541 },
        date: new Date(1944, 5, 3),
        description: "Пробито чердачное перекрытие 3 этажа.",
    },
    {
        type: 1,
        address: { street: "Лыжный переулок", houseNumber: 3 },
        position: { lat: 59.9967435, lng: 30.2029889 },
        date: new Date(1944, 0, 6),
        description: "Пробито чердачное перекрытие 3 этажа.",
    },
    {
        type: 1,
        address: { street: "проспект Маршака", houseNumber: 4 },
        position: { lat: 60.0355405, lng: 30.4462918 },
        date: new Date(1945, 4, 0),
        description: "Пробито чердачное перекрытие 3 этажа.",
    },
    {
        type: 2,
        address: { street: "Садовая улица", houseNumber: 29 },
        position: { lat: 59.9292128, lng: 30.3224727 },
        date: new Date(1943, 1, 1),
        description: "Пробито чердачное перекрытие 3 этажа.",
    },
    {
        type: 1,
        address: { street: "Эриванская улица", houseNumber: 1 },
        position: { lat: 60.0428236, lng: 30.3146572 },
        date: new Date(1944, 9, 6),
        description: "Пробито чердачное перекрытие 3 этажа.",
    },
    {
        type: 1,
        address: { street: "улица Косинова", houseNumber: 16 },
        position: { lat: 59.895616, lng: 30.2729095 },
        date: new Date(1945, 1, 5),
        description: "Пробито чердачное перекрытие 3 этажа.",
    },
    {
        type: 0,
        address: { street: "площадь Труда", houseNumber: 6 },
        position: { lat: 59.9311518, lng: 30.2939512 },
        date: new Date(1942, 10, 6),
        description: "Пробито чердачное перекрытие 3 этажа.",
    },
    {
        type: 1,
        address: { street: "Среднеохтинский проспект", houseNumber: 22 },
        position: { lat: 59.9510746, lng: 30.4144196 },
        date: new Date(1942, 0, 4),
        description: "Пробито чердачное перекрытие 3 этажа.",
    },
    {
        type: 2,
        address: { street: "Боровая улица", houseNumber: 2 },
        position: { lat: 59.9231949, lng: 30.3488458 },
        date: new Date(1945, 4, 2),
        description: "Пробито чердачное перекрытие 3 этажа.",
    },
    {
        type: 1,
        address: { street: "Кирочная улица", houseNumber: 23 },
        position: { lat: 59.9434662, lng: 30.3620758 },
        date: new Date(1943, 9, 2),
        description: "Пробито чердачное перекрытие 3 этажа.",
    },
    {
        type: 1,
        address: { street: "Невский проспект", houseNumber: 76 },
        position: { lat: 59.933157, lng: 30.3468738 },
        date: new Date(1943, 9, 4),
        description: "Пробито чердачное перекрытие 3 этажа.",
    },
    {
        type: 2,
        address: { street: "Дорога Жизни", houseNumber: 11 },
        position: { lat: 60.0331854, lng: 30.6307357 },
        date: new Date(1945, 6, 2),
        description: "Пробито чердачное перекрытие 3 этажа.",
    },
    {
        type: 0,
        address: { street: "улица Калинина", houseNumber: 53 },
        position: { lat: 59.8950828, lng: 30.2501162 },
        date: new Date(1944, 11, 6),
        description: "Пробито чердачное перекрытие 3 этажа.",
    },
    {
        type: 0,
        address: { street: "набережная реки Фонтанки", houseNumber: 177 },
        position: { lat: 59.9164501, lng: 30.2904186 },
        date: new Date(1945, 4, 6),
        description: "Пробито чердачное перекрытие 3 этажа.",
    },
    {
        type: 1,
        address: { street: "улица Куйбышева", houseNumber: 21 },
        position: { lat: 59.9563754, lng: 30.3315655 },
        date: new Date(1944, 0, 5),
        description: "Пробито чердачное перекрытие 3 этажа.",
    },
    {
        type: 1,
        address: { street: "проспект Просвещения", houseNumber: 36 },
        position: { lat: 60.0528567, lng: 30.3370662 },
        date: new Date(1942, 3, 5),
        description: "Пробито чердачное перекрытие 3 этажа.",
    },
    {
        type: 0,
        address: { street: "улица Ефимова", houseNumber: 3 },
        position: { lat: 59.9257316, lng: 30.3196361 },
        date: new Date(1945, 2, 0),
        description: "Пробито чердачное перекрытие 3 этажа.",
    },
    {
        type: 0,
        address: { street: "Карельский переулок", houseNumber: 8 },
        position: { lat: 59.9880944, lng: 30.294481 },
        date: new Date(1943, 6, 4),
        description: "Пробито чердачное перекрытие 3 этажа.",
    },
    {
        type: 2,
        address: { street: "Александровский парк", houseNumber: 4 },
        position: { lat: 59.9553899, lng: 30.3115246 },
        date: new Date(1944, 1, 2),
        description: "Пробито чердачное перекрытие 3 этажа.",
    },
    {
        type: 1,
        address: { street: "Свечной переулок", houseNumber: 11 },
        position: { lat: 59.9245262, lng: 30.3500714 },
        date: new Date(1944, 8, 3),
        description: "Пробито чердачное перекрытие 3 этажа.",
    },
    {
        type: 2,
        address: { street: "Шуваловский проспект", houseNumber: 41 },
        position: { lat: 60.0300894, lng: 30.2418704 },
        date: new Date(1945, 5, 3),
        description: "Пробито чердачное перекрытие 3 этажа.",
    },
    {
        type: 2,
        address: { street: "улица Косинова", houseNumber: 19 },
        position: { lat: 59.8955789, lng: 30.2720656 },
        date: new Date(1942, 1, 2),
        description: "Пробито чердачное перекрытие 3 этажа.",
    },
    {
        type: 1,
        address: { street: "Лифляндская улица", houseNumber: 10 },
        position: { lat: 59.9058509, lng: 30.2633803 },
        date: new Date(1945, 6, 3),
        description: "Пробито чердачное перекрытие 3 этажа.",
    },
    {
        type: 1,
        address: { street: "улица Аккуратова", houseNumber: 21 },
        position: { lat: 60.016118, lng: 30.3110978 },
        date: new Date(1945, 7, 3),
        description: "Пробито чердачное перекрытие 3 этажа.",
    },
    {
        type: 1,
        address: { street: "Трудовой переулок", houseNumber: 11 },
        position: { lat: 60.0134509, lng: 30.0273561 },
        date: new Date(1941, 9, 4),
        description: "Пробито чердачное перекрытие 3 этажа.",
    },
    {
        type: 0,
        address: { street: "Пражская улица", houseNumber: 12 },
        position: { lat: 59.9073724, lng: 30.5190374 },
        date: new Date(1943, 10, 1),
        description: "Пробито чердачное перекрытие 3 этажа.",
    },
    {
        type: 1,
        address: { street: "улица Победы", houseNumber: 15 },
        position: { lat: 59.8607513, lng: 30.3199466 },
        date: new Date(1944, 11, 4),
        description: "Пробито чердачное перекрытие 3 этажа.",
    },
    {
        type: 1,
        address: { street: "Гатчинская улица", houseNumber: 17 },
        position: { lat: 59.962211, lng: 30.2994767 },
        date: new Date(1943, 0, 4),
        description: "Пробито чердачное перекрытие 3 этажа.",
    },
    {
        type: 1,
        address: { street: "улица Бабушкина", houseNumber: 82 },
        position: { lat: 59.864055, lng: 30.4630761 },
        date: new Date(1942, 1, 2),
        description: "Пробито чердачное перекрытие 3 этажа.",
    },
    {
        type: 1,
        address: { street: "Капитанская улица", houseNumber: 4 },
        position: { lat: 59.955085, lng: 30.2169916 },
        date: new Date(1942, 7, 5),
        description: "Пробито чердачное перекрытие 3 этажа.",
    },
    {
        type: 1,
        address: { street: "Карельский переулок", houseNumber: 2 },
        position: { lat: 59.986062, lng: 30.2950264 },
        date: new Date(1944, 9, 6),
        description: "Пробито чердачное перекрытие 3 этажа.",
    },
    {
        type: 1,
        address: { street: "Свеаборгская улица", houseNumber: 6 },
        position: { lat: 59.8757629, lng: 30.3310485 },
        date: new Date(1942, 4, 3),
        description: "Пробито чердачное перекрытие 3 этажа.",
    },
    {
        type: 0,
        address: { street: "улица Печатника Григорьева", houseNumber: 18 },
        position: { lat: 59.9181117, lng: 30.3474976 },
        date: new Date(1941, 9, 3),
        description: "Пробито чердачное перекрытие 3 этажа.",
    },
    {
        type: 2,
        address: { street: "Гражданский проспект", houseNumber: 76 },
        position: { lat: 60.014425, lng: 30.3976241 },
        date: new Date(1944, 2, 3),
        description: "Пробито чердачное перекрытие 3 этажа.",
    },
    {
        type: 2,
        address: { street: "Графский переулок", houseNumber: 9 },
        position: { lat: 59.9302607, lng: 30.3468498 },
        date: new Date(1945, 3, 2),
        description: "Пробито чердачное перекрытие 3 этажа.",
    },
    {
        type: 1,
        address: { street: "Невский проспект", houseNumber: 54 },
        position: { lat: 59.9344378, lng: 30.3365036 },
        date: new Date(1944, 0, 6),
        description: "Пробито чердачное перекрытие 3 этажа.",
    },
    {
        type: 1,
        address: { street: "Яхтенная улица", houseNumber: 34 },
        position: { lat: 60.0041395, lng: 30.2232366 },
        date: new Date(1945, 5, 4),
        description: "Пробито чердачное перекрытие 3 этажа.",
    },
    {
        type: 2,
        address: { street: "Школьная улица", houseNumber: 128 },
        position: { lat: 59.991548, lng: 30.1989059 },
        date: new Date(1941, 9, 1),
        description: "Пробито чердачное перекрытие 3 этажа.",
    },
    {
        type: 0,
        address: { street: "Английская набережная", houseNumber: 50 },
        position: { lat: 59.9325973, lng: 30.2884412 },
        date: new Date(1943, 4, 3),
        description: "Пробито чердачное перекрытие 3 этажа.",
    },
    {
        type: 1,
        address: { street: "Дибуновская улица", houseNumber: 40 },
        position: { lat: 59.9848591, lng: 30.2672492 },
        date: new Date(1943, 9, 5),
        description: "Пробито чердачное перекрытие 3 этажа.",
    },
    {
        type: 1,
        address: { street: "Севастопольская улица", houseNumber: 7 },
        position: { lat: 59.8963595, lng: 30.2643711 },
        date: new Date(1943, 4, 5),
        description: "Пробито чердачное перекрытие 3 этажа.",
    },
    {
        type: 0,
        address: { street: "улица Трефолева", houseNumber: 4 },
        position: { lat: 59.8874939, lng: 30.280388 },
        date: new Date(1943, 9, 6),
        description: "Пробито чердачное перекрытие 3 этажа.",
    },
    {
        type: 1,
        address: { street: "Манежный переулок", houseNumber: 5 },
        position: { lat: 59.9431285, lng: 30.3550716 },
        date: new Date(1944, 4, 5),
        description: "Пробито чердачное перекрытие 3 этажа.",
    },
    {
        type: 1,
        address: { street: "улица Пестеля", houseNumber: 10 },
        position: { lat: 59.9427838, lng: 30.3450271 },
        date: new Date(1945, 1, 0),
        description: "Пробито чердачное перекрытие 3 этажа.",
    },
    {
        type: 1,
        address: { street: "Тракторная улица", houseNumber: 1 },
        position: { lat: 59.8980672, lng: 30.2774852 },
        date: new Date(1944, 10, 2),
        description: "Пробито чердачное перекрытие 3 этажа.",
    },
    {
        type: 0,
        address: { street: "Средний проспект В.О.", houseNumber: 28 },
        position: { lat: 59.9431809, lng: 30.2795453 },
        date: new Date(1941, 7, 0),
        description: "Пробито чердачное перекрытие 3 этажа.",
    },
    {
        type: 1,
        address: { street: "Большой проспект В.О.", houseNumber: 56 },
        position: { lat: 59.9341467, lng: 30.2673905 },
        date: new Date(1942, 7, 3),
        description: "Пробито чердачное перекрытие 3 этажа.",
    },
    {
        type: 1,
        address: { street: "проспект Королёва", houseNumber: 21 },
        position: { lat: 60.0118639, lng: 30.2790408 },
        date: new Date(1944, 9, 4),
        description: "Пробито чердачное перекрытие 3 этажа.",
    },
    {
        type: 0,
        address: { street: "Лиговский проспект", houseNumber: 87 },
        position: { lat: 59.9243966, lng: 30.3553461 },
        date: new Date(1943, 0, 5),
        description: "Пробито чердачное перекрытие 3 этажа.",
    },
    {
        type: 1,
        address: { street: "Белоостровская улица", houseNumber: 23 },
        position: { lat: 59.9873249, lng: 30.317064 },
        date: new Date(1944, 0, 5),
        description: "Пробито чердачное перекрытие 3 этажа.",
    },
    {
        type: 2,
        address: { street: "Конногвардейский бульвар", houseNumber: 23 },
        position: { lat: 59.93227, lng: 30.2939348 },
        date: new Date(1945, 7, 0),
        description: "Пробито чердачное перекрытие 3 этажа.",
    },
    {
        type: 0,
        address: { street: "Индустриальный проспект", houseNumber: 25 },
        position: { lat: 59.9466597, lng: 30.4772768 },
        date: new Date(1944, 8, 3),
        description: "Пробито чердачное перекрытие 3 этажа.",
    },
    {
        type: 1,
        address: { street: "Конногвардейский переулок", houseNumber: 10 },
        position: { lat: 59.9302979, lng: 30.2979757 },
        date: new Date(1944, 0, 3),
        description: "Пробито чердачное перекрытие 3 этажа.",
    },
    {
        type: 1,
        address: { street: "Перекопская улица", houseNumber: 2 },
        position: { lat: 59.9018273, lng: 30.2713795 },
        date: new Date(1945, 4, 3),
        description: "Пробито чердачное перекрытие 3 этажа.",
    },
    {
        type: 2,
        address: { street: "Гагаринская улица", houseNumber: 10 },
        position: { lat: 59.9464389, lng: 30.3427222 },
        date: new Date(1943, 1, 4),
        description: "Пробито чердачное перекрытие 3 этажа.",
    },
    {
        type: 1,
        address: { street: "Полозова улица", houseNumber: 26 },
        position: { lat: 59.9644814, lng: 30.3000698 },
        date: new Date(1944, 5, 5),
        description: "Пробито чердачное перекрытие 3 этажа.",
    },
    {
        type: 2,
        address: { street: "Загородный проспект", houseNumber: 33 },
        position: { lat: 59.9235337, lng: 30.3354217 },
        date: new Date(1944, 8, 4),
        description: "Пробито чердачное перекрытие 3 этажа.",
    },
    {
        type: 1,
        address: { street: "1-я Советская улица", houseNumber: 4 },
        position: { lat: 59.9317098, lng: 30.3630172 },
        date: new Date(1943, 0, 3),
        description: "Пробито чердачное перекрытие 3 этажа.",
    },
    {
        type: 2,
        address: { street: "Менделеевская линия", houseNumber: 9 },
        position: { lat: 59.943179, lng: 30.2976186 },
        date: new Date(1945, 1, 4),
        description: "Пробито чердачное перекрытие 3 этажа.",
    },
    {
        type: 0,
        address: { street: "Гаванская улица", houseNumber: 10 },
        position: { lat: 59.9301718, lng: 30.2403056 },
        date: new Date(1945, 4, 0),
        description: "Пробито чердачное перекрытие 3 этажа.",
    },
    {
        type: 1,
        address: { street: "Шпалерная улица", houseNumber: 41 },
        position: { lat: 59.9487789, lng: 30.3665859 },
        date: new Date(1945, 6, 1),
        description: "Пробито чердачное перекрытие 3 этажа.",
    },
    {
        type: 1,
        address: { street: "набережная реки Фонтанки", houseNumber: 197 },
        position: { lat: 59.9167176, lng: 30.2840841 },
        date: new Date(1942, 5, 5),
        description: "Пробито чердачное перекрытие 3 этажа.",
    },
    {
        type: 2,
        address: { street: "улица Марата", houseNumber: 14 },
        position: { lat: 59.9294426, lng: 30.354512 },
        date: new Date(1942, 6, 0),
        description: "Пробито чердачное перекрытие 3 этажа.",
    },
    {
        type: 2,
        address: { street: "Литовская улица", houseNumber: 15 },
        position: { lat: 59.978364, lng: 30.3550528 },
        date: new Date(1944, 0, 3),
        description: "Пробито чердачное перекрытие 3 этажа.",
    },
    {
        type: 1,
        address: { street: "набережная канала Грибоедова", houseNumber: 11 },
        position: { lat: 59.9375291, lng: 30.3268611 },
        date: new Date(1944, 6, 1),
        description: "Пробито чердачное перекрытие 3 этажа.",
    },
    {
        type: 0,
        address: { street: "Конногвардейский переулок", houseNumber: 5 },
        position: { lat: 59.930182, lng: 30.2976456 },
        date: new Date(1944, 9, 2),
        description: "Пробито чердачное перекрытие 3 этажа.",
    },
    {
        type: 0,
        address: { street: "Невский проспект", houseNumber: 37 },
        position: { lat: 59.9340256, lng: 30.3356286 },
        date: new Date(1943, 2, 3),
        description: "Пробито чердачное перекрытие 3 этажа.",
    },
    {
        type: 1,
        address: { street: "Малый проспект В.О.", houseNumber: 35 },
        position: { lat: 59.9451995, lng: 30.2673461 },
        date: new Date(1944, 9, 4),
        description: "Пробито чердачное перекрытие 3 этажа.",
    },
    {
        type: 1,
        address: { street: "Дальневосточный проспект", houseNumber: 63 },
        position: { lat: 59.8789894, lng: 30.4714195 },
        date: new Date(1942, 2, 1),
        description: "Пробито чердачное перекрытие 3 этажа.",
    },
    {
        type: 1,
        address: { street: "Гагаринская улица", houseNumber: 32 },
        position: { lat: 59.9433886, lng: 30.343319 },
        date: new Date(1945, 0, 4),
        description: "Пробито чердачное перекрытие 3 этажа.",
    },
    {
        type: 1,
        address: { street: "Лесной проспект", houseNumber: 94 },
        position: { lat: 59.9923187, lng: 30.3383454 },
        date: new Date(1945, 1, 4),
        description: "Пробито чердачное перекрытие 3 этажа.",
    },
    {
        type: 1,
        address: { street: "Курляндская улица", houseNumber: 48 },
        position: { lat: 59.9111976, lng: 30.2674173 },
        date: new Date(1943, 2, 4),
        description: "Пробито чердачное перекрытие 3 этажа.",
    },
    {
        type: 1,
        address: { street: "Невский проспект", houseNumber: 76 },
        position: { lat: 59.933157, lng: 30.3468738 },
        date: new Date(1941, 9, 1),
        description: "Пробито чердачное перекрытие 3 этажа.",
    },
    {
        type: 1,
        address: { street: "Суворовский проспект", houseNumber: 2 },
        position: { lat: 59.9314019, lng: 30.3665302 },
        date: new Date(1941, 10, 6),
        description: "Пробито чердачное перекрытие 3 этажа.",
    },
    {
        type: 2,
        address: { street: "проспект Энергетиков", houseNumber: 53 },
        position: { lat: 59.9646696, lng: 30.4442488 },
        date: new Date(1944, 3, 0),
        description: "Пробито чердачное перекрытие 3 этажа.",
    },
    {
        type: 1,
        address: { street: "Колокольная улица", houseNumber: 14 },
        position: { lat: 59.9285849, lng: 30.3519292 },
        date: new Date(1944, 2, 5),
        description: "Пробито чердачное перекрытие 3 этажа.",
    },
    {
        type: 2,
        address: { street: "улица Правды", houseNumber: 22 },
        position: { lat: 59.9209936, lng: 30.3391074 },
        date: new Date(1945, 5, 1),
        description: "Пробито чердачное перекрытие 3 этажа.",
    },
    {
        type: 0,
        address: { street: "Моховая улица", houseNumber: 30 },
        position: { lat: 59.9410328, lng: 30.3466279 },
        date: new Date(1944, 0, 6),
        description: "Пробито чердачное перекрытие 3 этажа.",
    },
    {
        type: 2,
        address: { street: "площадь Ломоносова", houseNumber: 2 },
        position: { lat: 59.9293386, lng: 30.3348985 },
        date: new Date(1942, 11, 2),
        description: "Пробито чердачное перекрытие 3 этажа.",
    },
    {
        type: 2,
        address: { street: "Греческий проспект", houseNumber: 13 },
        position: { lat: 59.9353423, lng: 30.3667879 },
        date: new Date(1943, 2, 5),
        description: "Пробито чердачное перекрытие 3 этажа.",
    },
    {
        type: 2,
        address: { street: "Большой проспект П.С.", houseNumber: 58 },
        position: { lat: 59.9611899, lng: 30.3037781 },
        date: new Date(1943, 7, 2),
        description: "Пробито чердачное перекрытие 3 этажа.",
    },
    {
        type: 1,
        address: { street: "проспект Медиков", houseNumber: 9 },
        position: { lat: 59.9707868, lng: 30.316457 },
        date: new Date(1942, 0, 0),
        description: "Пробито чердачное перекрытие 3 этажа.",
    },
    {
        type: 2,
        address: { street: "Карельский переулок", houseNumber: 8 },
        position: { lat: 59.9880944, lng: 30.294481 },
        date: new Date(1944, 9, 2),
        description: "Пробито чердачное перекрытие 3 этажа.",
    },
    {
        type: 0,
        address: { street: "Торговый проспект", houseNumber: 74 },
        position: { lat: 60.0079132, lng: 30.6641958 },
        date: new Date(1945, 1, 0),
        description: "Пробито чердачное перекрытие 3 этажа.",
    },
    {
        type: 1,
        address: { street: "Невский проспект", houseNumber: 54 },
        position: { lat: 59.9344378, lng: 30.3365036 },
        date: new Date(1943, 1, 3),
        description: "Пробито чердачное перекрытие 3 этажа.",
    },
    {
        type: 2,
        address: { street: "улица Кораблестроителей", houseNumber: 36 },
        position: { lat: 59.9550574, lng: 30.2184868 },
        date: new Date(1943, 1, 2),
        description: "Пробито чердачное перекрытие 3 этажа.",
    },
    {
        type: 1,
        address: { street: "Гороховая улица", houseNumber: 32 },
        position: { lat: 59.9298191, lng: 30.3213075 },
        date: new Date(1944, 5, 5),
        description: "Пробито чердачное перекрытие 3 этажа.",
    },
    {
        type: 1,
        address: { street: "переулок Декабристов", houseNumber: 14 },
        position: { lat: 59.9525537, lng: 30.2484492 },
        date: new Date(1944, 6, 4),
        description: "Пробито чердачное перекрытие 3 этажа.",
    },
    {
        type: 2,
        address: { street: "улица 2-й Луч", houseNumber: 14 },
        position: { lat: 59.9124914, lng: 30.3967816 },
        date: new Date(1944, 2, 2),
        description: "Пробито чердачное перекрытие 3 этажа.",
    },
    {
        type: 1,
        address: { street: "набережная реки Фонтанки", houseNumber: 81 },
        position: { lat: 59.9255991, lng: 30.3261275 },
        date: new Date(1944, 9, 0),
        description: "Пробито чердачное перекрытие 3 этажа.",
    },
    {
        type: 1,
        address: { street: "Московский проспект", houseNumber: 8 },
        position: { lat: 59.9243171, lng: 30.31885 },
        date: new Date(1944, 5, 3),
        description: "Пробито чердачное перекрытие 3 этажа.",
    },
    {
        type: 0,
        address: { street: "Садовая улица", houseNumber: 21 },
        position: { lat: 60.0427784, lng: 30.4512987 },
        date: new Date(1943, 8, 4),
        description: "Пробито чердачное перекрытие 3 этажа.",
    },
    {
        type: 0,
        address: { street: "набережная реки Карповки", houseNumber: 6 },
        position: { lat: 59.9676269, lng: 30.3145035 },
        date: new Date(1944, 10, 4),
        description: "Пробито чердачное перекрытие 3 этажа.",
    },
    {
        type: 1,
        address: { street: "Полюстровский проспект", houseNumber: 47 },
        position: { lat: 59.9695389, lng: 30.3869784 },
        date: new Date(1942, 10, 3),
        description: "Пробито чердачное перекрытие 3 этажа.",
    },
    {
        type: 0,
        address: { street: "улица Марата", houseNumber: 49 },
        position: { lat: 59.9240028, lng: 30.3505301 },
        date: new Date(1945, 6, 4),
        description: "Пробито чердачное перекрытие 3 этажа.",
    },
    {
        type: 1,
        address: { street: "улица Зодчего Росси", houseNumber: 1 },
        position: { lat: 59.9311932, lng: 30.3357736 },
        date: new Date(1943, 10, 4),
        description: "Пробито чердачное перекрытие 3 этажа.",
    },
    {
        type: 2,
        address: { street: "Большая Озёрная улица", houseNumber: 42 },
        position: { lat: 60.0347463, lng: 30.3100455 },
        date: new Date(1944, 1, 2),
        description: "Пробито чердачное перекрытие 3 этажа.",
    },
    {
        type: 0,
        address: { street: "набережная реки Мойки", houseNumber: 17 },
        position: { lat: 59.9422569, lng: 30.3229748 },
        date: new Date(1941, 9, 4),
        description: "Пробито чердачное перекрытие 3 этажа.",
    },
    {
        type: 0,
        address: { street: "Английская набережная", houseNumber: 66 },
        position: { lat: 59.9318719, lng: 30.2853797 },
        date: new Date(1944, 4, 3),
        description: "Пробито чердачное перекрытие 3 этажа.",
    },
    {
        type: 1,
        address: { street: "улица Ефимова", houseNumber: 3 },
        position: { lat: 59.9257316, lng: 30.3196361 },
        date: new Date(1944, 7, 1),
        description: "Пробито чердачное перекрытие 3 этажа.",
    },
    {
        type: 2,
        address: { street: "Пушкарский переулок", houseNumber: 7 },
        position: { lat: 59.9592854, lng: 30.3079817 },
        date: new Date(1941, 5, 1),
        description: "Пробито чердачное перекрытие 3 этажа.",
    },
    {
        type: 1,
        address: { street: "набережная канала Грибоедова", houseNumber: 77 },
        position: { lat: 59.9265064, lng: 30.3094474 },
        date: new Date(1945, 5, 3),
        description: "Пробито чердачное перекрытие 3 этажа.",
    },
    {
        type: 1,
        address: { street: "улица Правды", houseNumber: 11 },
        position: { lat: 59.9225786, lng: 30.3407593 },
        date: new Date(1944, 8, 4),
        description: "Пробито чердачное перекрытие 3 этажа.",
    },
    {
        type: 0,
        address: { street: "Промышленная улица", houseNumber: 19 },
        position: { lat: 59.8967872, lng: 30.2573457 },
        date: new Date(1943, 7, 1),
        description: "Пробито чердачное перекрытие 3 этажа.",
    },
    {
        type: 1,
        address: { street: "Никольская улица", houseNumber: 5 },
        position: { lat: 60.0449842, lng: 30.3025831 },
        date: new Date(1941, 10, 0),
        description: "Пробито чердачное перекрытие 3 этажа.",
    },
    {
        type: 2,
        address: { street: "проспект Энгельса", houseNumber: 34 },
        position: { lat: 60.007204, lng: 30.3252239 },
        date: new Date(1943, 5, 1),
        description: "Пробито чердачное перекрытие 3 этажа.",
    },
    {
        type: 2,
        address: { street: "улица Ленсовета", houseNumber: 19 },
        position: { lat: 59.8498354, lng: 30.3294186 },
        date: new Date(1943, 0, 6),
        description: "Пробито чердачное перекрытие 3 этажа.",
    },
    {
        type: 2,
        address: { street: "улица Аккуратова", houseNumber: 13 },
        position: { lat: 60.0161064, lng: 30.3109936 },
        date: new Date(1942, 4, 2),
        description: "Пробито чердачное перекрытие 3 этажа.",
    },
    {
        type: 1,
        address: { street: "Кожевенная линия", houseNumber: 42 },
        position: { lat: 59.9254774, lng: 30.2406038 },
        date: new Date(1945, 4, 2),
        description: "Пробито чердачное перекрытие 3 этажа.",
    },
    {
        type: 0,
        address: { street: "Московский проспект", houseNumber: 86 },
        position: { lat: 59.902872, lng: 30.3195507 },
        date: new Date(1945, 0, 2),
        description: "Пробито чердачное перекрытие 3 этажа.",
    },
    {
        type: 2,
        address: { street: "Коломенская улица", houseNumber: 23 },
        position: { lat: 59.9237329, lng: 30.3531544 },
        date: new Date(1941, 8, 3),
        description: "Пробито чердачное перекрытие 3 этажа.",
    },
    {
        type: 2,
        address: { street: "улица Композиторов", houseNumber: 7 },
        position: { lat: 60.0521515, lng: 30.3172704 },
        date: new Date(1944, 1, 5),
        description: "Пробито чердачное перекрытие 3 этажа.",
    },
    {
        type: 1,
        address: { street: "улица Профессора Качалова", houseNumber: 7 },
        position: { lat: 59.9142897, lng: 30.3963045 },
        date: new Date(1943, 1, 3),
        description: "Пробито чердачное перекрытие 3 этажа.",
    },
    {
        type: 1,
        address: { street: "Социалистическая улица", houseNumber: 20 },
        position: { lat: 59.921528, lng: 30.3446607 },
        date: new Date(1943, 8, 0),
        description: "Пробито чердачное перекрытие 3 этажа.",
    },
    {
        type: 2,
        address: { street: "Комендантский проспект", houseNumber: 67 },
        position: { lat: 60.037269, lng: 30.2263937 },
        date: new Date(1945, 4, 6),
        description: "Пробито чердачное перекрытие 3 этажа.",
    },
    {
        type: 1,
        address: { street: "Екатерининский проспект", houseNumber: 11 },
        position: { lat: 59.9828517, lng: 30.440617 },
        date: new Date(1944, 11, 3),
        description: "Пробито чердачное перекрытие 3 этажа.",
    },
    {
        type: 0,
        address: { street: "Зверинская улица", houseNumber: 26 },
        position: { lat: 59.9535333, lng: 30.3007017 },
        date: new Date(1941, 11, 4),
        description: "Пробито чердачное перекрытие 3 этажа.",
    },
    {
        type: 2,
        address: { street: "Весёлая улица", houseNumber: 8 },
        position: { lat: 60.0474658, lng: 30.4440071 },
        date: new Date(1944, 11, 2),
        description: "Пробито чердачное перекрытие 3 этажа.",
    },
    {
        type: 2,
        address: { street: "улица Полярников", houseNumber: 21 },
        position: { lat: 59.8758878, lng: 30.4352214 },
        date: new Date(1943, 10, 0),
        description: "Пробито чердачное перекрытие 3 этажа.",
    },
    {
        type: 2,
        address: { street: "улица Белоусова", houseNumber: 13 },
        position: { lat: 59.8900051, lng: 30.2648001 },
        date: new Date(1942, 2, 6),
        description: "Пробито чердачное перекрытие 3 этажа.",
    },
    {
        type: 1,
        address: { street: "Московский проспект", houseNumber: 75 },
        position: { lat: 59.903127, lng: 30.3181471 },
        date: new Date(1944, 11, 0),
        description: "Пробито чердачное перекрытие 3 этажа.",
    },
    {
        type: 1,
        address: { street: "улица Маршала Казакова", houseNumber: 35 },
        position: { lat: 59.8621236, lng: 30.2084481 },
        date: new Date(1943, 2, 4),
        description: "Пробито чердачное перекрытие 3 этажа.",
    },
    {
        type: 1,
        address: { street: "Большая Подьяческая улица", houseNumber: 36 },
        position: { lat: 59.9192945, lng: 30.3053349 },
        date: new Date(1942, 9, 0),
        description: "Пробито чердачное перекрытие 3 этажа.",
    },
    {
        type: 0,
        address: { street: "улица Мира", houseNumber: 1 },
        position: { lat: 59.9588013, lng: 30.3127708 },
        date: new Date(1942, 8, 1),
        description: "Пробито чердачное перекрытие 3 этажа.",
    },
    {
        type: 0,
        address: { street: "Сердобольская улица", houseNumber: 64 },
        position: { lat: 59.9871035, lng: 30.3148114 },
        date: new Date(1943, 7, 2),
        description: "Пробито чердачное перекрытие 3 этажа.",
    },
    {
        type: 2,
        address: { street: "Конюшенная площадь", houseNumber: 2 },
        position: { lat: 59.9405705, lng: 30.326938 },
        date: new Date(1941, 7, 3),
        description: "Пробито чердачное перекрытие 3 этажа.",
    },
    {
        type: 0,
        address: { street: "улица Лабутина", houseNumber: 26 },
        position: { lat: 59.9173278, lng: 30.2893386 },
        date: new Date(1942, 10, 5),
        description: "Пробито чердачное перекрытие 3 этажа.",
    },
    {
        type: 1,
        address: { street: "набережная Обводного канала", houseNumber: 199 },
        position: { lat: 59.909693, lng: 30.2850189 },
        date: new Date(1945, 7, 6),
        description: "Пробито чердачное перекрытие 3 этажа.",
    },
    {
        type: 2,
        address: { street: "Звенигородская улица", houseNumber: 14 },
        position: { lat: 59.9204449, lng: 30.3389956 },
        date: new Date(1942, 2, 2),
        description: "Пробито чердачное перекрытие 3 этажа.",
    },
    {
        type: 2,
        address: { street: "Свечной переулок", houseNumber: 13 },
        position: { lat: 59.9244412, lng: 30.3505475 },
        date: new Date(1944, 5, 3),
        description: "Пробито чердачное перекрытие 3 этажа.",
    },
    {
        type: 0,
        address: { street: "набережная реки Фонтанки", houseNumber: 157 },
        position: { lat: 59.9170696, lng: 30.2956871 },
        date: new Date(1945, 5, 0),
        description: "Пробито чердачное перекрытие 3 этажа.",
    },
    {
        type: 0,
        address: { street: "набережная Обводного канала", houseNumber: 93 },
        position: { lat: 59.9157788, lng: 30.3384482 },
        date: new Date(1945, 6, 0),
        description: "Пробито чердачное перекрытие 3 этажа.",
    },
    {
        type: 1,
        address: { street: "Москательный переулок", houseNumber: 1 },
        position: { lat: 59.9307232, lng: 30.3222723 },
        date: new Date(1942, 10, 6),
        description: "Пробито чердачное перекрытие 3 этажа.",
    },
    {
        type: 2,
        address: { street: "Загородный проспект", houseNumber: 9 },
        position: { lat: 59.92681, lng: 30.3436428 },
        date: new Date(1943, 10, 0),
        description: "Пробито чердачное перекрытие 3 этажа.",
    },
    {
        type: 1,
        address: { street: "Каменноостровский проспект", houseNumber: 27 },
        position: { lat: 59.9643529, lng: 30.3135367 },
        date: new Date(1942, 8, 4),
        description: "Пробито чердачное перекрытие 3 этажа.",
    },
    {
        type: 0,
        address: { street: "Лахтинский проспект", houseNumber: 77 },
        position: { lat: 59.9924444, lng: 30.1510097 },
        date: new Date(1945, 7, 3),
        description: "Пробито чердачное перекрытие 3 этажа.",
    },
    {
        type: 1,
        address: { street: "улица Щербакова", houseNumber: 11 },
        position: { lat: 60.0287963, lng: 30.2959207 },
        date: new Date(1942, 3, 2),
        description: "Пробито чердачное перекрытие 3 этажа.",
    },
    {
        type: 1,
        address: { street: "улица Льва Толстого", houseNumber: 19 },
        position: { lat: 59.9643646, lng: 30.3215502 },
        date: new Date(1943, 8, 5),
        description: "Пробито чердачное перекрытие 3 этажа.",
    },
    {
        type: 2,
        address: { street: "Невский проспект", houseNumber: 52 },
        position: { lat: 59.9344567, lng: 30.3358579 },
        date: new Date(1943, 8, 6),
        description: "Пробито чердачное перекрытие 3 этажа.",
    },
    {
        type: 1,
        address: { street: "Байконурская улица", houseNumber: 15 },
        position: { lat: 60.0029461, lng: 30.2752606 },
        date: new Date(1944, 1, 6),
        description: "Пробито чердачное перекрытие 3 этажа.",
    },
    {
        type: 2,
        address: { street: "Социалистическая улица", houseNumber: 12 },
        position: { lat: 59.9226228, lng: 30.3427138 },
        date: new Date(1943, 4, 3),
        description: "Пробито чердачное перекрытие 3 этажа.",
    },
    {
        type: 0,
        address: { street: "Академический переулок", houseNumber: 2 },
        position: { lat: 59.9377685, lng: 30.2879304 },
        date: new Date(1944, 4, 5),
        description: "Пробито чердачное перекрытие 3 этажа.",
    },
    {
        type: 1,
        address: { street: "проспект Маршала Блюхера", houseNumber: 4 },
        position: { lat: 59.9859127, lng: 30.3640443 },
        date: new Date(1945, 0, 4),
        description: "Пробито чердачное перекрытие 3 этажа.",
    },
    {
        type: 1,
        address: { street: "улица Ленсовета", houseNumber: 38 },
        position: { lat: 59.8466547, lng: 30.3305832 },
        date: new Date(1942, 8, 2),
        description: "Пробито чердачное перекрытие 3 этажа.",
    },
    {
        type: 2,
        address: { street: "Воскресенская набережная", houseNumber: 34 },
        position: { lat: 59.9497245, lng: 30.3495921 },
        date: new Date(1943, 3, 2),
        description: "Пробито чердачное перекрытие 3 этажа.",
    },
    {
        type: 1,
        address: { street: "Липовая аллея", houseNumber: 15 },
        position: { lat: 59.9870827, lng: 30.2567714 },
        date: new Date(1945, 1, 6),
        description: "Пробито чердачное перекрытие 3 этажа.",
    },
    {
        type: 2,
        address: { street: "улица Фучика", houseNumber: 9 },
        position: { lat: 59.8757265, lng: 30.36793 },
        date: new Date(1942, 7, 0),
        description: "Пробито чердачное перекрытие 3 этажа.",
    },
    {
        type: 0,
        address: { street: "проспект Ударников", houseNumber: 42 },
        position: { lat: 59.9539866, lng: 30.4808904 },
        date: new Date(1943, 5, 2),
        description: "Пробито чердачное перекрытие 3 этажа.",
    },
    {
        type: 0,
        address: { street: "Бухарестская улица", houseNumber: 112 },
        position: { lat: 59.8500717, lng: 30.403725 },
        date: new Date(1944, 7, 4),
        description: "Пробито чердачное перекрытие 3 этажа.",
    },
    {
        type: 2,
        address: { street: "Разъезжая улица", houseNumber: 12 },
        position: { lat: 59.924706, lng: 30.3462048 },
        date: new Date(1942, 6, 3),
        description: "Пробито чердачное перекрытие 3 этажа.",
    },
    {
        type: 1,
        address: { street: "улица Решетникова", houseNumber: 3 },
        position: { lat: 59.8786861, lng: 30.3222021 },
        date: new Date(1941, 11, 5),
        description: "Пробито чердачное перекрытие 3 этажа.",
    },
    {
        type: 2,
        address: { street: "Парголовская улица", houseNumber: 7 },
        position: { lat: 59.9846951, lng: 30.3462325 },
        date: new Date(1944, 7, 2),
        description: "Пробито чердачное перекрытие 3 этажа.",
    },
    {
        type: 0,
        address: { street: "Торговый переулок", houseNumber: 2 },
        position: { lat: 59.9289072, lng: 30.3336287 },
        date: new Date(1944, 8, 3),
        description: "Пробито чердачное перекрытие 3 этажа.",
    },
    {
        type: 0,
        address: { street: "Малый проспект В.О.", houseNumber: 13 },
        position: { lat: 59.9475994, lng: 30.2758582 },
        date: new Date(1942, 0, 5),
        description: "Пробито чердачное перекрытие 3 этажа.",
    },
    {
        type: 1,
        address: { street: "улица Адмирала Трибуца", houseNumber: 5 },
        position: { lat: 59.8538902, lng: 30.1462949 },
        date: new Date(1942, 4, 5),
        description: "Пробито чердачное перекрытие 3 этажа.",
    },
    {
        type: 2,
        address: { street: "проспект Королёва", houseNumber: 7 },
        position: { lat: 60.0106671, lng: 30.2899581 },
        date: new Date(1942, 2, 4),
        description: "Пробито чердачное перекрытие 3 этажа.",
    },
    {
        type: 1,
        address: { street: "улица Нахимова", houseNumber: 11 },
        position: { lat: 59.9412474, lng: 30.2227733 },
        date: new Date(1944, 6, 6),
        description: "Пробито чердачное перекрытие 3 этажа.",
    },
    {
        type: 1,
        address: { street: "набережная Адмиралтейского канала", houseNumber: 25 },
        position: { lat: 59.9301287, lng: 30.2874342 },
        date: new Date(1941, 7, 3),
        description: "Пробито чердачное перекрытие 3 этажа.",
    },
    {
        type: 0,
        address: { street: "набережная канала Грибоедова", houseNumber: 63 },
        position: { lat: 59.927285, lng: 30.3148139 },
        date: new Date(1942, 10, 0),
        description: "Пробито чердачное перекрытие 3 этажа.",
    },
    {
        type: 1,
        address: { street: "Промышленная улица", houseNumber: 6 },
        position: { lat: 59.899013, lng: 30.2732395 },
        date: new Date(1943, 10, 4),
        description: "Пробито чердачное перекрытие 3 этажа.",
    },
    {
        type: 1,
        address: { street: "улица Вавиловых", houseNumber: 19 },
        position: { lat: 60.0244566, lng: 30.3955342 },
        date: new Date(1945, 8, 3),
        description: "Пробито чердачное перекрытие 3 этажа.",
    },
    {
        type: 2,
        address: { street: "улица Нахимова", houseNumber: 1 },
        position: { lat: 59.9441711, lng: 30.2352494 },
        date: new Date(1944, 0, 1),
        description: "Пробито чердачное перекрытие 3 этажа.",
    },
    {
        type: 2,
        address: { street: "Большая Морская улица", houseNumber: 12 },
        position: { lat: 59.9367358, lng: 30.3177967 },
        date: new Date(1943, 7, 6),
        description: "Пробито чердачное перекрытие 3 этажа.",
    },
    {
        type: 2,
        address: { street: "Петроградская набережная", houseNumber: 20 },
        position: { lat: 59.95996, lng: 30.33439 },
        date: new Date(1945, 1, 6),
        description: "Пробито чердачное перекрытие 3 этажа.",
    },
    {
        type: 2,
        address: { street: "Большой Сампсониевский проспект", houseNumber: 33 },
        position: { lat: 59.9665802, lng: 30.3431405 },
        date: new Date(1941, 8, 2),
        description: "Пробито чердачное перекрытие 3 этажа.",
    },
    {
        type: 1,
        address: { street: "набережная реки Фонтанки", houseNumber: 54 },
        position: { lat: 59.9299221, lng: 30.3403736 },
        date: new Date(1943, 9, 4),
        description: "Пробито чердачное перекрытие 3 этажа.",
    },
    {
        type: 0,
        address: { street: "Московский проспект", houseNumber: 136 },
        position: { lat: 59.8873673, lng: 30.3202914 },
        date: new Date(1943, 7, 2),
        description: "Пробито чердачное перекрытие 3 этажа.",
    },
    {
        type: 1,
        address: { street: "Английская набережная", houseNumber: 52 },
        position: { lat: 59.9324776, lng: 30.2879359 },
        date: new Date(1941, 11, 0),
        description: "Пробито чердачное перекрытие 3 этажа.",
    },
    {
        type: 1,
        address: { street: "Малая Посадская улица", houseNumber: 2 },
        position: { lat: 59.9581299, lng: 30.3198872 },
        date: new Date(1943, 6, 5),
        description: "Пробито чердачное перекрытие 3 этажа.",
    },
    {
        type: 0,
        address: { street: "Свечной переулок", houseNumber: 13 },
        position: { lat: 59.9244412, lng: 30.3505475 },
        date: new Date(1944, 4, 6),
        description: "Пробито чердачное перекрытие 3 этажа.",
    },
    {
        type: 2,
        address: { street: "проспект Просвещения", houseNumber: 43 },
        position: { lat: 60.0467384, lng: 30.3608144 },
        date: new Date(1945, 3, 3),
        description: "Пробито чердачное перекрытие 3 этажа.",
    },
    {
        type: 2,
        address: { street: "набережная реки Мойки", houseNumber: 83 },
        position: { lat: 59.932607, lng: 30.3119811 },
        date: new Date(1943, 0, 2),
        description: "Пробито чердачное перекрытие 3 этажа.",
    },
    {
        type: 2,
        address: { street: "Казанская улица", houseNumber: 28 },
        position: { lat: 59.9303335, lng: 30.3168173 },
        date: new Date(1945, 2, 6),
        description: "Пробито чердачное перекрытие 3 этажа.",
    },
    {
        type: 1,
        address: { street: "Большая Разночинная улица", houseNumber: 14 },
        position: { lat: 59.9589788, lng: 30.2913496 },
        date: new Date(1945, 2, 2),
        description: "Пробито чердачное перекрытие 3 этажа.",
    },
    {
        type: 2,
        address: { street: "Уральская улица", houseNumber: 17 },
        position: { lat: 59.953691, lng: 30.2602444 },
        date: new Date(1942, 3, 5),
        description: "Пробито чердачное перекрытие 3 этажа.",
    },
    {
        type: 0,
        address: { street: "Лахтинский проспект", houseNumber: 79 },
        position: { lat: 59.9926177, lng: 30.1504938 },
        date: new Date(1942, 0, 0),
        description: "Пробито чердачное перекрытие 3 этажа.",
    },
    {
        type: 1,
        address: { street: "набережная реки Фонтанки", houseNumber: 162 },
        position: { lat: 59.9155034, lng: 30.2776144 },
        date: new Date(1941, 11, 0),
        description: "Пробито чердачное перекрытие 3 этажа.",
    },
    {
        type: 2,
        address: { street: "улица Оружейника Фёдорова", houseNumber: 11 },
        position: { lat: 59.9458601, lng: 30.3407972 },
        date: new Date(1942, 2, 5),
        description: "Пробито чердачное перекрытие 3 этажа.",
    },
    {
        type: 1,
        address: { street: "улица Декабристов", houseNumber: 27 },
        position: { lat: 59.9265334, lng: 30.2955346 },
        date: new Date(1943, 10, 0),
        description: "Пробито чердачное перекрытие 3 этажа.",
    },
    {
        type: 1,
        address: { street: "Лиговский проспект", houseNumber: 69 },
        position: { lat: 59.9265352, lng: 30.3577907 },
        date: new Date(1943, 5, 1),
        description: "Пробито чердачное перекрытие 3 этажа.",
    },
    {
        type: 2,
        address: { street: "ПТУ-56", houseNumber: 5 },
        position: { lat: 59.9024831, lng: 30.6829159 },
        date: new Date(1943, 8, 2),
        description: "Пробито чердачное перекрытие 3 этажа.",
    },
    {
        type: 2,
        address: { street: "улица Зодчего Росси", houseNumber: 1 },
        position: { lat: 59.9311932, lng: 30.3357736 },
        date: new Date(1943, 11, 0),
        description: "Пробито чердачное перекрытие 3 этажа.",
    },
    {
        type: 0,
        address: { street: "проспект Луначарского", houseNumber: 46 },
        position: { lat: 60.0444545, lng: 30.3269756 },
        date: new Date(1945, 5, 3),
        description: "Пробито чердачное перекрытие 3 этажа.",
    },
    {
        type: 2,
        address: { street: "улица Савушкина", houseNumber: 85 },
        position: { lat: 59.9866714, lng: 30.2499313 },
        date: new Date(1941, 9, 4),
        description: "Пробито чердачное перекрытие 3 этажа.",
    },
    {
        type: 1,
        address: { street: "Сортировочная-Московская улица", houseNumber: 32 },
        position: { lat: 59.8663675, lng: 30.4306349 },
        date: new Date(1942, 1, 2),
        description: "Пробито чердачное перекрытие 3 этажа.",
    },
    {
        type: 1,
        address: { street: "Севастопольская улица", houseNumber: 24 },
        position: { lat: 59.8925935, lng: 30.2669582 },
        date: new Date(1945, 6, 0),
        description: "Пробито чердачное перекрытие 3 этажа.",
    },
    {
        type: 0,
        address: { street: "улица Жуковского", houseNumber: 1 },
        position: { lat: 59.9358848, lng: 30.3487206 },
        date: new Date(1943, 10, 3),
        description: "Пробито чердачное перекрытие 3 этажа.",
    },
    {
        type: 1,
        address: { street: "Большая Подьяческая улица", houseNumber: 35 },
        position: { lat: 59.9211164, lng: 30.3050881 },
        date: new Date(1942, 4, 0),
        description: "Пробито чердачное перекрытие 3 этажа.",
    },
    {
        type: 2,
        address: { street: "Ораниенбаумская улица", houseNumber: 29 },
        position: { lat: 59.9620033, lng: 30.2946767 },
        date: new Date(1943, 3, 4),
        description: "Пробито чердачное перекрытие 3 этажа.",
    },
    {
        type: 1,
        address: { street: "Малая Десятинная улица", houseNumber: 11 },
        position: { lat: 60.0330627, lng: 30.2948614 },
        date: new Date(1943, 5, 6),
        description: "Пробито чердачное перекрытие 3 этажа.",
    },
    {
        type: 1,
        address: { street: "5-я Советская улица", houseNumber: 44 },
        position: { lat: 59.9326227, lng: 30.3758203 },
        date: new Date(1942, 11, 5),
        description: "Пробито чердачное перекрытие 3 этажа.",
    },
    {
        type: 1,
        address: { street: "набережная реки Мойки", houseNumber: 101 },
        position: { lat: 59.9309248, lng: 30.3040682 },
        date: new Date(1944, 7, 3),
        description: "Пробито чердачное перекрытие 3 этажа.",
    },
    {
        type: 1,
        address: { street: "Чистяковская улица", houseNumber: 11 },
        position: { lat: 60.0407868, lng: 30.2960845 },
        date: new Date(1941, 9, 2),
        description: "Пробито чердачное перекрытие 3 этажа.",
    },
    {
        type: 1,
        address: { street: "Московский проспект", houseNumber: 111 },
        position: { lat: 59.8890606, lng: 30.3188488 },
        date: new Date(1943, 2, 5),
        description: "Пробито чердачное перекрытие 3 этажа.",
    },
    {
        type: 0,
        address: { street: "Железнодорожная улица", houseNumber: 19 },
        position: { lat: 59.8372332, lng: 30.0766502 },
        date: new Date(1943, 3, 4),
        description: "Пробито чердачное перекрытие 3 этажа.",
    },
    {
        type: 1,
        address: { street: "бульвар Красных Зорь", houseNumber: 1 },
        position: { lat: 59.8731917, lng: 30.4466106 },
        date: new Date(1943, 2, 3),
        description: "Пробито чердачное перекрытие 3 этажа.",
    },
    {
        type: 1,
        address: { street: "Афанасьевская улица", houseNumber: 1 },
        position: { lat: 60.0336685, lng: 30.296072 },
        date: new Date(1943, 9, 1),
        description: "Пробито чердачное перекрытие 3 этажа.",
    },
    {
        type: 1,
        address: { street: "Моховая улица", houseNumber: 31 },
        position: { lat: 59.9409533, lng: 30.3449765 },
        date: new Date(1944, 11, 6),
        description: "Пробито чердачное перекрытие 3 этажа.",
    },
    {
        type: 1,
        address: { street: "шоссе Революции", houseNumber: 69 },
        position: { lat: 59.9623246, lng: 30.46562 },
        date: new Date(1945, 5, 3),
        description: "Пробито чердачное перекрытие 3 этажа.",
    },
    {
        type: 1,
        address: { street: "Прачечный переулок", houseNumber: 12 },
        position: { lat: 59.9282568, lng: 30.302056 },
        date: new Date(1942, 5, 5),
        description: "Пробито чердачное перекрытие 3 этажа.",
    },
    {
        type: 0,
        address: { street: "Кронверкский проспект", houseNumber: 23 },
        position: { lat: 59.9569182, lng: 30.3190598 },
        date: new Date(1945, 8, 3),
        description: "Пробито чердачное перекрытие 3 этажа.",
    },
    {
        type: 2,
        address: { street: "улица Ватутина", houseNumber: 12 },
        position: { lat: 59.96263, lng: 30.3780676 },
        date: new Date(1945, 0, 1),
        description: "Пробито чердачное перекрытие 3 этажа.",
    },
    {
        type: 2,
        address: { street: "Большой Казачий переулок", houseNumber: 11 },
        position: { lat: 59.9219587, lng: 30.3286966 },
        date: new Date(1942, 9, 2),
        description: "Пробито чердачное перекрытие 3 этажа.",
    },
    {
        type: 2,
        address: { street: "Малый проспект В.О.", houseNumber: 52 },
        position: { lat: 59.9427192, lng: 30.2599748 },
        date: new Date(1943, 4, 6),
        description: "Пробито чердачное перекрытие 3 этажа.",
    },
    {
        type: 1,
        address: { street: "улица Нахимова", houseNumber: 11 },
        position: { lat: 59.9412474, lng: 30.2227733 },
        date: new Date(1944, 0, 0),
        description: "Пробито чердачное перекрытие 3 этажа.",
    },
    {
        type: 2,
        address: { street: "Большой проспект П.С.", houseNumber: 18 },
        position: { lat: 59.9553613, lng: 30.2948227 },
        date: new Date(1941, 6, 4),
        description: "Пробито чердачное перекрытие 3 этажа.",
    },
    {
        type: 1,
        address: { street: "Мошков переулок", houseNumber: 2 },
        position: { lat: 59.9436888, lng: 30.3215164 },
        date: new Date(1943, 4, 2),
        description: "Пробито чердачное перекрытие 3 этажа.",
    },
    {
        type: 1,
        address: { street: "проспект Девятого Января", houseNumber: 3 },
        position: { lat: 59.8464603, lng: 30.4360043 },
        date: new Date(1945, 4, 0),
        description: "Пробито чердачное перекрытие 3 этажа.",
    },
    {
        type: 1,
        address: { street: "Большая Пушкарская улица", houseNumber: 60 },
        position: { lat: 59.9637197, lng: 30.3113876 },
        date: new Date(1942, 11, 4),
        description: "Пробито чердачное перекрытие 3 этажа.",
    },
    {
        type: 0,
        address: { street: "Партизанская улица", houseNumber: 10 },
        position: { lat: 59.9483373, lng: 30.4438602 },
        date: new Date(1944, 10, 1),
        description: "Пробито чердачное перекрытие 3 этажа.",
    },
    {
        type: 1,
        address: { street: "Удельный проспект", houseNumber: 27 },
        position: { lat: 60.0180536, lng: 30.3147132 },
        date: new Date(1944, 11, 4),
        description: "Пробито чердачное перекрытие 3 этажа.",
    },
    {
        type: 0,
        address: { street: "Балтийская улица", houseNumber: 4 },
        position: { lat: 59.8977516, lng: 30.2799144 },
        date: new Date(1944, 4, 3),
        description: "Пробито чердачное перекрытие 3 этажа.",
    },
    {
        type: 1,
        address: { street: "Лахтинский проспект", houseNumber: 98 },
        position: { lat: 59.99155, lng: 30.1450746 },
        date: new Date(1942, 7, 3),
        description: "Пробито чердачное перекрытие 3 этажа.",
    },
    {
        type: 0,
        address: { street: "Перекупной переулок", houseNumber: 3 },
        position: { lat: 59.9275772, lng: 30.3767537 },
        date: new Date(1943, 10, 5),
        description: "Пробито чердачное перекрытие 3 этажа.",
    },
    {
        type: 0,
        address: { street: "Большой Сампсониевский проспект", houseNumber: 33 },
        position: { lat: 59.9665802, lng: 30.3431405 },
        date: new Date(1943, 1, 2),
        description: "Пробито чердачное перекрытие 3 этажа.",
    },
    {
        type: 1,
        address: { street: "Бумажная улица", houseNumber: 16 },
        position: { lat: 59.9059254, lng: 30.2669155 },
        date: new Date(1943, 0, 2),
        description: "Пробито чердачное перекрытие 3 этажа.",
    },
    {
        type: 1,
        address: { street: "улица Маяковского", houseNumber: 21 },
        position: { lat: 59.9391674, lng: 30.3554848 },
        date: new Date(1944, 3, 0),
        description: "Пробито чердачное перекрытие 3 этажа.",
    },
    {
        type: 1,
        address: { street: "Турбинная улица", houseNumber: 17 },
        position: { lat: 59.8927323, lng: 30.2697029 },
        date: new Date(1944, 7, 6),
        description: "Пробито чердачное перекрытие 3 этажа.",
    },
    {
        type: 0,
        address: { street: "Большой Сампсониевский проспект", houseNumber: 92 },
        position: { lat: 59.9879512, lng: 30.3332918 },
        date: new Date(1942, 5, 1),
        description: "Пробито чердачное перекрытие 3 этажа.",
    },
    {
        type: 1,
        address: { street: "улица Седова", houseNumber: 21 },
        position: { lat: 59.8925279, lng: 30.415053 },
        date: new Date(1945, 0, 2),
        description: "Пробито чердачное перекрытие 3 этажа.",
    },
    {
        type: 1,
        address: { street: "площадь Победы", houseNumber: 2 },
        position: { lat: 59.8428685, lng: 30.3251842 },
        date: new Date(1943, 1, 1),
        description: "Пробито чердачное перекрытие 3 этажа.",
    },
    {
        type: 1,
        address: { street: "улица Тельмана", houseNumber: 56 },
        position: { lat: 59.8928792, lng: 30.4894482 },
        date: new Date(1943, 11, 2),
        description: "Пробито чердачное перекрытие 3 этажа.",
    },
    {
        type: 1,
        address: { street: "Адмиралтейский проспект", houseNumber: 8 },
        position: { lat: 59.9359424, lng: 30.3092465 },
        date: new Date(1945, 2, 6),
        description: "Пробито чердачное перекрытие 3 этажа.",
    },
    {
        type: 0,
        address: { street: "Свечной переулок", houseNumber: 14 },
        position: { lat: 59.9244163, lng: 30.3513732 },
        date: new Date(1943, 10, 5),
        description: "Пробито чердачное перекрытие 3 этажа.",
    },
    {
        type: 1,
        address: { street: "улица Савушкина", houseNumber: 61 },
        position: { lat: 59.9841919, lng: 30.2687721 },
        date: new Date(1941, 9, 1),
        description: "Пробито чердачное перекрытие 3 этажа.",
    },
    {
        type: 0,
        address: { street: "площадь Ленина", houseNumber: 6 },
        position: { lat: 59.9555537, lng: 30.356196 },
        date: new Date(1945, 5, 3),
        description: "Пробито чердачное перекрытие 3 этажа.",
    },
    {
        type: 1,
        address: { street: "Лахтинский проспект", houseNumber: 79 },
        position: { lat: 59.9926177, lng: 30.1504938 },
        date: new Date(1945, 4, 3),
        description: "Пробито чердачное перекрытие 3 этажа.",
    },
    {
        type: 1,
        address: { street: "проспект Медиков", houseNumber: 9 },
        position: { lat: 59.9707868, lng: 30.316457 },
        date: new Date(1944, 4, 6),
        description: "Пробито чердачное перекрытие 3 этажа.",
    },
    {
        type: 0,
        address: { street: "Вербная улица", houseNumber: 10 },
        position: { lat: 60.0232798, lng: 30.2850602 },
        date: new Date(1945, 2, 5),
        description: "Пробито чердачное перекрытие 3 этажа.",
    },
    {
        type: 2,
        address: { street: "проспект Энгельса", houseNumber: 21 },
        position: { lat: 60.0027536, lng: 30.3281667 },
        date: new Date(1945, 0, 4),
        description: "Пробито чердачное перекрытие 3 этажа.",
    },
    {
        type: 2,
        address: { street: "улица Академика Крылова", houseNumber: 4 },
        position: { lat: 59.9858721, lng: 30.3004986 },
        date: new Date(1943, 1, 6),
        description: "Пробито чердачное перекрытие 3 этажа.",
    },
    {
        type: 2,
        address: { street: "улица Оптиков", houseNumber: 4 },
        position: { lat: 59.9918709, lng: 30.2527329 },
        date: new Date(1941, 9, 4),
        description: "Пробито чердачное перекрытие 3 этажа.",
    },
    {
        type: 1,
        address: { street: "проспект Художников", houseNumber: 13 },
        position: { lat: 60.0367821, lng: 30.3454484 },
        date: new Date(1944, 1, 2),
        description: "Пробито чердачное перекрытие 3 этажа.",
    },
    {
        type: 1,
        address: { street: "Боткинская улица", houseNumber: 1 },
        position: { lat: 59.9578452, lng: 30.3555214 },
        date: new Date(1945, 2, 6),
        description: "Пробито чердачное перекрытие 3 этажа.",
    },
    {
        type: 0,
        address: { street: "Кирпичный переулок", houseNumber: 3 },
        position: { lat: 59.9354694, lng: 30.3159163 },
        date: new Date(1945, 6, 5),
        description: "Пробито чердачное перекрытие 3 этажа.",
    },
    {
        type: 1,
        address: { street: "Чкаловский проспект", houseNumber: 58 },
        position: { lat: 59.9683647, lng: 30.302436 },
        date: new Date(1944, 4, 2),
        description: "Пробито чердачное перекрытие 3 этажа.",
    },
    {
        type: 1,
        address: { street: "Севастопольская улица", houseNumber: 24 },
        position: { lat: 59.8925935, lng: 30.2669582 },
        date: new Date(1941, 7, 6),
        description: "Пробито чердачное перекрытие 3 этажа.",
    },
    {
        type: 1,
        address: { street: "Дворцовая набережная", houseNumber: 20 },
        position: { lat: 59.9439028, lng: 30.3211045 },
        date: new Date(1941, 9, 1),
        description: "Пробито чердачное перекрытие 3 этажа.",
    },
    {
        type: 0,
        address: { street: "Ковенский переулок", houseNumber: 1 },
        position: { lat: 59.9368022, lng: 30.3555536 },
        date: new Date(1945, 1, 4),
        description: "Пробито чердачное перекрытие 3 этажа.",
    },
    {
        type: 2,
        address: { street: "Полевая Сабировская улица", houseNumber: 54 },
        position: { lat: 59.9972967, lng: 30.2688847 },
        date: new Date(1945, 3, 6),
        description: "Пробито чердачное перекрытие 3 этажа.",
    },
    {
        type: 0,
        address: { street: "Московский проспект", houseNumber: 75 },
        position: { lat: 59.903127, lng: 30.3181471 },
        date: new Date(1944, 7, 5),
        description: "Пробито чердачное перекрытие 3 этажа.",
    },
    {
        type: 2,
        address: { street: "набережная канала Грибоедова", houseNumber: 39 },
        position: { lat: 59.9314512, lng: 30.3215802 },
        date: new Date(1944, 9, 6),
        description: "Пробито чердачное перекрытие 3 этажа.",
    },
    {
        type: 1,
        address: { street: "Замятин переулок", houseNumber: 5 },
        position: { lat: 59.9337171, lng: 30.2960266 },
        date: new Date(1943, 4, 2),
        description: "Пробито чердачное перекрытие 3 этажа.",
    },
    {
        type: 0,
        address: { street: "Марсово поле", houseNumber: 3 },
        position: { lat: 59.9429243, lng: 30.3292828 },
        date: new Date(1945, 0, 1),
        description: "Пробито чердачное перекрытие 3 этажа.",
    },
    {
        type: 2,
        address: { street: "улица Академика Крылова", houseNumber: 4 },
        position: { lat: 59.9858721, lng: 30.3004986 },
        date: new Date(1944, 4, 0),
        description: "Пробито чердачное перекрытие 3 этажа.",
    },
    {
        type: 2,
        address: { street: "площадь Островского", houseNumber: 1 },
        position: { lat: 59.9339108, lng: 30.3361254 },
        date: new Date(1943, 7, 0),
        description: "Пробито чердачное перекрытие 3 этажа.",
    },
    {
        type: 2,
        address: { street: "Большая Пороховская улица", houseNumber: 12 },
        position: { lat: 59.9536659, lng: 30.4134924 },
        date: new Date(1944, 2, 0),
        description: "Пробито чердачное перекрытие 3 этажа.",
    },
    {
        type: 1,
        address: { street: "Гаванская улица", houseNumber: 10 },
        position: { lat: 59.9301718, lng: 30.2403056 },
        date: new Date(1944, 9, 2),
        description: "Пробито чердачное перекрытие 3 этажа.",
    },
    {
        type: 1,
        address: { street: "улица Белоусова", houseNumber: 12 },
        position: { lat: 59.8894807, lng: 30.2657673 },
        date: new Date(1942, 9, 1),
        description: "Пробито чердачное перекрытие 3 этажа.",
    },
    {
        type: 1,
        address: { street: "Таможенный переулок", houseNumber: 2 },
        position: { lat: 59.9412454, lng: 30.3033562 },
        date: new Date(1945, 3, 3),
        description: "Пробито чердачное перекрытие 3 этажа.",
    },
    {
        type: 0,
        address: { street: "Большая Пушкарская улица", houseNumber: 41 },
        position: { lat: 59.9631911, lng: 30.3109409 },
        date: new Date(1941, 9, 0),
        description: "Пробито чердачное перекрытие 3 этажа.",
    },
    {
        type: 2,
        address: { street: "набережная реки Фонтанки", houseNumber: 157 },
        position: { lat: 59.9170696, lng: 30.2956871 },
        date: new Date(1941, 7, 6),
        description: "Пробито чердачное перекрытие 3 этажа.",
    },
    {
        type: 1,
        address: { street: "Малый проспект П.С.", houseNumber: 89 },
        position: { lat: 59.9670849, lng: 30.3082848 },
        date: new Date(1942, 4, 0),
        description: "Пробито чердачное перекрытие 3 этажа.",
    },
    {
        type: 2,
        address: { street: "Кондратьевский проспект", houseNumber: 22 },
        position: { lat: 59.9640872, lng: 30.3802952 },
        date: new Date(1944, 6, 2),
        description: "Пробито чердачное перекрытие 3 этажа.",
    },
    {
        type: 1,
        address: { street: "улица Оружейника Фёдорова", houseNumber: 1 },
        position: { lat: 59.9453575, lng: 30.3388977 },
        date: new Date(1943, 3, 4),
        description: "Пробито чердачное перекрытие 3 этажа.",
    },
    {
        type: 1,
        address: { street: "Политехническая улица", houseNumber: 9 },
        position: { lat: 59.9923895, lng: 30.3566593 },
        date: new Date(1942, 8, 4),
        description: "Пробито чердачное перекрытие 3 этажа.",
    },
    {
        type: 0,
        address: { street: "2-й Муринский проспект", houseNumber: 14 },
        position: { lat: 60.0021577, lng: 30.3394396 },
        date: new Date(1941, 9, 4),
        description: "Пробито чердачное перекрытие 3 этажа.",
    },
    {
        type: 0,
        address: { street: "Сердобольская улица", houseNumber: 64 },
        position: { lat: 59.9871035, lng: 30.3148114 },
        date: new Date(1942, 6, 0),
        description: "Пробито чердачное перекрытие 3 этажа.",
    },
    {
        type: 1,
        address: { street: "Загородный проспект", houseNumber: 66 },
        position: { lat: 59.9177426, lng: 30.3215499 },
        date: new Date(1945, 3, 3),
        description: "Пробито чердачное перекрытие 3 этажа.",
    },
    {
        type: 1,
        address: { street: "Малодетскосельский проспект", houseNumber: 3 },
        position: { lat: 59.9145531, lng: 30.3300353 },
        date: new Date(1944, 2, 4),
        description: "Пробито чердачное перекрытие 3 этажа.",
    },
    {
        type: 1,
        address: { street: "Казанская улица", houseNumber: 7 },
        position: { lat: 59.9324074, lng: 30.3214261 },
        date: new Date(1943, 0, 5),
        description: "Пробито чердачное перекрытие 3 этажа.",
    },
    {
        type: 1,
        address: { street: "Павлоградский переулок", houseNumber: 6 },
        position: { lat: 59.917077, lng: 30.3542092 },
        date: new Date(1943, 10, 1),
        description: "Пробито чердачное перекрытие 3 этажа.",
    },
    {
        type: 1,
        address: { street: "Малый проспект П.С.", houseNumber: 48 },
        position: { lat: 59.9604618, lng: 30.2974439 },
        date: new Date(1943, 7, 5),
        description: "Пробито чердачное перекрытие 3 этажа.",
    },
    {
        type: 1,
        address: { street: "Софийская улица", houseNumber: 57 },
        position: { lat: 59.8671394, lng: 30.4115625 },
        date: new Date(1942, 8, 1),
        description: "Пробито чердачное перекрытие 3 этажа.",
    },
    {
        type: 1,
        address: { street: "Лермонтовский проспект", houseNumber: 48 },
        position: { lat: 59.9131428, lng: 30.2978427 },
        date: new Date(1945, 7, 3),
        description: "Пробито чердачное перекрытие 3 этажа.",
    },
    {
        type: 1,
        address: { street: "Захарьевская улица", houseNumber: 20 },
        position: { lat: 59.9478435, lng: 30.3624683 },
        date: new Date(1942, 11, 4),
        description: "Пробито чердачное перекрытие 3 этажа.",
    },
    {
        type: 1,
        address: { street: "проспект Королёва", houseNumber: 61 },
        position: { lat: 60.0309127, lng: 30.2443109 },
        date: new Date(1942, 6, 1),
        description: "Пробито чердачное перекрытие 3 этажа.",
    },
    {
        type: 1,
        address: { street: "Гражданский проспект", houseNumber: 36 },
        position: { lat: 60.0113861, lng: 30.3945728 },
        date: new Date(1944, 4, 6),
        description: "Пробито чердачное перекрытие 3 этажа.",
    },
    {
        type: 1,
        address: { street: "Репищева улица", houseNumber: 20 },
        position: { lat: 60.031874, lng: 30.2849197 },
        date: new Date(1942, 5, 1),
        description: "Пробито чердачное перекрытие 3 этажа.",
    },
    {
        type: 0,
        address: { street: "Вознесенский проспект", houseNumber: 19 },
        position: { lat: 59.9277595, lng: 30.3080225 },
        date: new Date(1943, 6, 4),
        description: "Пробито чердачное перекрытие 3 этажа.",
    },
    {
        type: 0,
        address: { street: "Новоорловская улица", houseNumber: 46 },
        position: { lat: 60.0491886, lng: 30.2939525 },
        date: new Date(1944, 2, 0),
        description: "Пробито чердачное перекрытие 3 этажа.",
    },
    {
        type: 0,
        address: { street: "набережная реки Фонтанки", houseNumber: 147 },
        position: { lat: 59.9178146, lng: 30.2989135 },
        date: new Date(1942, 11, 4),
        description: "Пробито чердачное перекрытие 3 этажа.",
    },
    {
        type: 1,
        address: { street: "улица Савушкина", houseNumber: 15 },
        position: { lat: 59.9857988, lng: 30.2911258 },
        date: new Date(1942, 4, 3),
        description: "Пробито чердачное перекрытие 3 этажа.",
    },
    {
        type: 1,
        address: { street: "Moskovskiy Prospekt", houseNumber: 198 },
        position: { lat: 59.861511, lng: 30.3223163 },
        date: new Date(1941, 8, 2),
        description: "Пробито чердачное перекрытие 3 этажа.",
    },
    {
        type: 2,
        address: { street: "Большой проспект В.О.", houseNumber: 41 },
        position: { lat: 59.9377815, lng: 30.276624 },
        date: new Date(1944, 4, 3),
        description: "Пробито чердачное перекрытие 3 этажа.",
    },
    {
        type: 1,
        address: { street: "Загородный проспект", houseNumber: 66 },
        position: { lat: 59.9177426, lng: 30.3215499 },
        date: new Date(1941, 11, 1),
        description: "Пробито чердачное перекрытие 3 этажа.",
    },
    {
        type: 1,
        address: { street: "1-й проезд", houseNumber: 10 },
        position: { lat: 59.8435936, lng: 30.7058487 },
        date: new Date(1945, 4, 0),
        description: "Пробито чердачное перекрытие 3 этажа.",
    },
    {
        type: 1,
        address: { street: "набережная реки Фонтанки", houseNumber: 151 },
        position: { lat: 59.9174783, lng: 30.2974896 },
        date: new Date(1941, 8, 3),
        description: "Пробито чердачное перекрытие 3 этажа.",
    },
    {
        type: 2,
        address: { street: "проспект Луначарского", houseNumber: 76 },
        position: { lat: 60.0371189, lng: 30.3628959 },
        date: new Date(1943, 9, 6),
        description: "Пробито чердачное перекрытие 3 этажа.",
    },
    {
        type: 1,
        address: { street: "проспект Луначарского", houseNumber: 76 },
        position: { lat: 60.0371189, lng: 30.3628959 },
        date: new Date(1943, 0, 6),
        description: "Пробито чердачное перекрытие 3 этажа.",
    },
    {
        type: 1,
        address: { street: "улица Восстания", houseNumber: 46 },
        position: { lat: 59.9436715, lng: 30.3605386 },
        date: new Date(1942, 3, 3),
        description: "Пробито чердачное перекрытие 3 этажа.",
    },
    {
        type: 2,
        address: { street: "Киришская улица", houseNumber: 4 },
        position: { lat: 60.0329861, lng: 30.425884 },
        date: new Date(1943, 7, 1),
        description: "Пробито чердачное перекрытие 3 этажа.",
    },
    {
        type: 1,
        address: { street: "Адмиралтейский проспект", houseNumber: 8 },
        position: { lat: 59.9359424, lng: 30.3092465 },
        date: new Date(1942, 10, 6),
        description: "Пробито чердачное перекрытие 3 этажа.",
    },
    {
        type: 1,
        address: { street: "Шпалерная улица", houseNumber: 56 },
        position: { lat: 59.9494977, lng: 30.3760995 },
        date: new Date(1943, 3, 3),
        description: "Пробито чердачное перекрытие 3 этажа.",
    },
    {
        type: 1,
        address: { street: "улица Марата", houseNumber: 14 },
        position: { lat: 59.9294426, lng: 30.354512 },
        date: new Date(1944, 1, 6),
        description: "Пробито чердачное перекрытие 3 этажа.",
    },
    {
        type: 2,
        address: { street: "Севастопольская улица", houseNumber: 24 },
        position: { lat: 59.8925935, lng: 30.2669582 },
        date: new Date(1941, 6, 0),
        description: "Пробито чердачное перекрытие 3 этажа.",
    },
    {
        type: 0,
        address: { street: "набережная реки Фонтанки", houseNumber: 185 },
        position: { lat: 59.9165785, lng: 30.2871888 },
        date: new Date(1943, 6, 2),
        description: "Пробито чердачное перекрытие 3 этажа.",
    },
    {
        type: 1,
        address: { street: "Биржевая линия", houseNumber: 14 },
        position: { lat: 59.9438156, lng: 30.2956703 },
        date: new Date(1944, 1, 6),
        description: "Пробито чердачное перекрытие 3 этажа.",
    },
    {
        type: 1,
        address: { street: "Богатырский проспект", houseNumber: 54 },
        position: { lat: 60.0065357, lng: 30.2099745 },
        date: new Date(1944, 4, 2),
        description: "Пробито чердачное перекрытие 3 этажа.",
    },
    {
        type: 1,
        address: { street: "улица Васи Алексеева", houseNumber: 14 },
        position: { lat: 59.8798421, lng: 30.2702987 },
        date: new Date(1942, 9, 5),
        description: "Пробито чердачное перекрытие 3 этажа.",
    },
    {
        type: 0,
        address: { street: "Менделеевская линия", houseNumber: 9 },
        position: { lat: 59.943179, lng: 30.2976186 },
        date: new Date(1941, 11, 4),
        description: "Пробито чердачное перекрытие 3 этажа.",
    },
    {
        type: 1,
        address: { street: "проспект Авиаконструкторов", houseNumber: 20 },
        position: { lat: 60.0201613, lng: 30.2337199 },
        date: new Date(1944, 2, 3),
        description: "Пробито чердачное перекрытие 3 этажа.",
    },
    {
        type: 2,
        address: { street: "Серебряков переулок", houseNumber: 5 },
        position: { lat: 59.9849034, lng: 30.2705697 },
        date: new Date(1945, 1, 5),
        description: "Пробито чердачное перекрытие 3 этажа.",
    },
    {
        type: 2,
        address: { street: "Уральская улица", houseNumber: 17 },
        position: { lat: 59.953691, lng: 30.2602444 },
        date: new Date(1941, 7, 6),
        description: "Пробито чердачное перекрытие 3 этажа.",
    },
    {
        type: 0,
        address: { street: "Московский проспект", houseNumber: 192 },
        position: { lat: 59.8642681, lng: 30.3212906 },
        date: new Date(1945, 3, 4),
        description: "Пробито чердачное перекрытие 3 этажа.",
    },
    {
        type: 0,
        address: { street: "улица Зои Космодемьянской", houseNumber: 16 },
        position: { lat: 59.8928263, lng: 30.2671657 },
        date: new Date(1945, 3, 2),
        description: "Пробито чердачное перекрытие 3 этажа.",
    },
    {
        type: 0,
        address: { street: "проспект Испытателей", houseNumber: 31 },
        position: { lat: 60.0076477, lng: 30.2686005 },
        date: new Date(1942, 11, 4),
        description: "Пробито чердачное перекрытие 3 этажа.",
    },
    {
        type: 0,
        address: { street: "Центральная улица", houseNumber: 42 },
        position: { lat: 60.0457181, lng: 30.4492903 },
        date: new Date(1942, 0, 0),
        description: "Пробито чердачное перекрытие 3 этажа.",
    },
    {
        type: 0,
        address: { street: "Невский проспект", houseNumber: 24 },
        position: { lat: 59.935876, lng: 30.3243166 },
        date: new Date(1945, 0, 3),
        description: "Пробито чердачное перекрытие 3 этажа.",
    },
    {
        type: 2,
        address: { street: "Аптекарская набережная", houseNumber: 20 },
        position: { lat: 59.9783064, lng: 30.3154008 },
        date: new Date(1944, 9, 6),
        description: "Пробито чердачное перекрытие 3 этажа.",
    },
    {
        type: 2,
        address: { street: "набережная Крюкова канала", houseNumber: 6 },
        position: { lat: 59.926963, lng: 30.2947042 },
        date: new Date(1942, 7, 1),
        description: "Пробито чердачное перекрытие 3 этажа.",
    },
    {
        type: 2,
        address: { street: "Большая Конюшенная улица", houseNumber: 14 },
        position: { lat: 59.9363118, lng: 30.322702 },
        date: new Date(1942, 9, 1),
        description: "Пробито чердачное перекрытие 3 этажа.",
    },
    {
        type: 1,
        address: { street: "Исаакиевская площадь", houseNumber: 4 },
        position: { lat: 59.9321672, lng: 30.3097433 },
        date: new Date(1944, 0, 2),
        description: "Пробито чердачное перекрытие 3 этажа.",
    },
    {
        type: 2,
        address: { street: "Воскресенская набережная", houseNumber: 22 },
        position: { lat: 59.9496388, lng: 30.3569667 },
        date: new Date(1943, 1, 4),
        description: "Пробито чердачное перекрытие 3 этажа.",
    },
    {
        type: 1,
        address: { street: "Пушкинская улица", houseNumber: 5 },
        position: { lat: 59.9304355, lng: 30.3566936 },
        date: new Date(1944, 1, 0),
        description: "Пробито чердачное перекрытие 3 этажа.",
    },
    {
        type: 2,
        address: { street: "Боровая улица", houseNumber: 2 },
        position: { lat: 59.9231949, lng: 30.3488458 },
        date: new Date(1943, 11, 5),
        description: "Пробито чердачное перекрытие 3 этажа.",
    },
    {
        type: 2,
        address: { street: "Гороховая улица", houseNumber: 61 },
        position: { lat: 59.9238987, lng: 30.328645 },
        date: new Date(1943, 7, 1),
        description: "Пробито чердачное перекрытие 3 этажа.",
    },
    {
        type: 2,
        address: { street: "Тележная улица", houseNumber: 24 },
        position: { lat: 59.9255937, lng: 30.3760862 },
        date: new Date(1942, 8, 0),
        description: "Пробито чердачное перекрытие 3 этажа.",
    },
    {
        type: 1,
        address: { street: "улица Ленсовета", houseNumber: 42 },
        position: { lat: 59.8453023, lng: 30.3306917 },
        date: new Date(1945, 7, 0),
        description: "Пробито чердачное перекрытие 3 этажа.",
    },
    {
        type: 1,
        address: { street: "Московский проспект", houseNumber: 37 },
        position: { lat: 59.86138, lng: 30.3188926 },
        date: new Date(1941, 9, 1),
        description: "Пробито чердачное перекрытие 3 этажа.",
    },
    {
        type: 1,
        address: { street: "набережная канала Грибоедова", houseNumber: 39 },
        position: { lat: 59.9314512, lng: 30.3215802 },
        date: new Date(1942, 0, 0),
        description: "Пробито чердачное перекрытие 3 этажа.",
    },
    {
        type: 0,
        address: { street: "улица Всеволода Вишневского", houseNumber: 3 },
        position: { lat: 59.9666267, lng: 30.3036028 },
        date: new Date(1944, 0, 0),
        description: "Пробито чердачное перекрытие 3 этажа.",
    },
    {
        type: 1,
        address: { street: "улица Бабушкина", houseNumber: 82 },
        position: { lat: 59.864055, lng: 30.4630761 },
        date: new Date(1943, 5, 6),
        description: "Пробито чердачное перекрытие 3 этажа.",
    },
    {
        type: 2,
        address: { street: "улица Савушкина", houseNumber: 48 },
        position: { lat: 59.9846225, lng: 30.2810236 },
        date: new Date(1943, 2, 1),
        description: "Пробито чердачное перекрытие 3 этажа.",
    },
    {
        type: 1,
        address: { street: "улица Ярослава Гашека", houseNumber: 26 },
        position: { lat: 59.8399711, lng: 30.4161823 },
        date: new Date(1944, 4, 0),
        description: "Пробито чердачное перекрытие 3 этажа.",
    },
    {
        type: 2,
        address: { street: "Графский переулок", houseNumber: 3 },
        position: { lat: 59.9308588, lng: 30.3440274 },
        date: new Date(1943, 0, 0),
        description: "Пробито чердачное перекрытие 3 этажа.",
    },
    {
        type: 1,
        address: { street: "Кузнецовская улица", houseNumber: 23 },
        position: { lat: 59.8714873, lng: 30.3184219 },
        date: new Date(1942, 6, 5),
        description: "Пробито чердачное перекрытие 3 этажа.",
    },
    {
        type: 1,
        address: { street: "набережная реки Фонтанки", houseNumber: 142 },
        position: { lat: 59.9157442, lng: 30.2951635 },
        date: new Date(1942, 8, 1),
        description: "Пробито чердачное перекрытие 3 этажа.",
    },
    {
        type: 2,
        address: { street: "Лифляндская улица", houseNumber: 2 },
        position: { lat: 59.9084064, lng: 30.2639142 },
        date: new Date(1945, 1, 3),
        description: "Пробито чердачное перекрытие 3 этажа.",
    },
    {
        type: 1,
        address: { street: "Менделеевская улица", houseNumber: 6 },
        position: { lat: 59.9768516, lng: 30.3601868 },
        date: new Date(1943, 4, 6),
        description: "Пробито чердачное перекрытие 3 этажа.",
    },
    {
        type: 1,
        address: { street: "Большая Пушкарская улица", houseNumber: 30 },
        position: { lat: 59.9595242, lng: 30.3035191 },
        date: new Date(1944, 1, 5),
        description: "Пробито чердачное перекрытие 3 этажа.",
    },
    {
        type: 0,
        address: { street: "Парашютная улица", houseNumber: 60 },
        position: { lat: 60.0388203, lng: 30.2393449 },
        date: new Date(1941, 11, 4),
        description: "Пробито чердачное перекрытие 3 этажа.",
    },
    {
        type: 1,
        address: { street: "Английская набережная", houseNumber: 30 },
        position: { lat: 59.933929, lng: 30.2934893 },
        date: new Date(1942, 4, 3),
        description: "Пробито чердачное перекрытие 3 этажа.",
    },
    {
        type: 2,
        address: { street: "Рижская улица", houseNumber: 1 },
        position: { lat: 59.9223819, lng: 30.4183717 },
        date: new Date(1943, 6, 2),
        description: "Пробито чердачное перекрытие 3 этажа.",
    },
    {
        type: 0,
        address: { street: "Аптекарская набережная", houseNumber: 20 },
        position: { lat: 59.9783064, lng: 30.3154008 },
        date: new Date(1943, 6, 5),
        description: "Пробито чердачное перекрытие 3 этажа.",
    },
    {
        type: 2,
        address: { street: "8-я Советская улица", houseNumber: 2 },
        position: { lat: 59.938053, lng: 30.3701496 },
        date: new Date(1944, 1, 1),
        description: "Пробито чердачное перекрытие 3 этажа.",
    },
    {
        type: 2,
        address: { street: "Малый проспект В.О.", houseNumber: 7 },
        position: { lat: 59.9481017, lng: 30.2775097 },
        date: new Date(1942, 7, 6),
        description: "Пробито чердачное перекрытие 3 этажа.",
    },
    {
        type: 1,
        address: { street: "Приморский проспект", houseNumber: 52 },
        position: { lat: 59.9829459, lng: 30.2371397 },
        date: new Date(1942, 6, 4),
        description: "Пробито чердачное перекрытие 3 этажа.",
    },
    {
        type: 1,
        address: { street: "улица Трефолева", houseNumber: 28 },
        position: { lat: 59.8912962, lng: 30.2675972 },
        date: new Date(1943, 8, 2),
        description: "Пробито чердачное перекрытие 3 этажа.",
    },
    {
        type: 1,
        address: { street: "Вознесенский проспект", houseNumber: 13 },
        position: { lat: 59.9291594, lng: 30.308093 },
        date: new Date(1944, 8, 5),
        description: "Пробито чердачное перекрытие 3 этажа.",
    },
    {
        type: 0,
        address: { street: "Невский проспект", houseNumber: 64 },
        position: { lat: 59.9338861, lng: 30.3400657 },
        date: new Date(1945, 0, 0),
        description: "Пробито чердачное перекрытие 3 этажа.",
    },
    {
        type: 2,
        address: { street: "Суворовский проспект", houseNumber: 22 },
        position: { lat: 59.9365243, lng: 30.3725101 },
        date: new Date(1943, 1, 2),
        description: "Пробито чердачное перекрытие 3 этажа.",
    },
    {
        type: 0,
        address: { street: "Английская набережная", houseNumber: 10 },
        position: { lat: 59.9353779, lng: 30.2979215 },
        date: new Date(1943, 9, 3),
        description: "Пробито чердачное перекрытие 3 этажа.",
    },
    {
        type: 1,
        address: { street: "улица Типанова", houseNumber: 8 },
        position: { lat: 59.8519048, lng: 30.3308948 },
        date: new Date(1944, 7, 6),
        description: "Пробито чердачное перекрытие 3 этажа.",
    },
    {
        type: 1,
        address: { street: "Апраксин переулок", houseNumber: 2 },
        position: { lat: 59.9293645, lng: 30.3244318 },
        date: new Date(1941, 11, 2),
        description: "Пробито чердачное перекрытие 3 этажа.",
    },
    {
        type: 0,
        address: { street: "улица Маршала Казакова", houseNumber: 35 },
        position: { lat: 59.8621236, lng: 30.2084481 },
        date: new Date(1942, 7, 3),
        description: "Пробито чердачное перекрытие 3 этажа.",
    },
    {
        type: 0,
        address: { street: "переулок Пирогова", houseNumber: 1 },
        position: { lat: 59.9299513, lng: 30.3079554 },
        date: new Date(1941, 10, 0),
        description: "Пробито чердачное перекрытие 3 этажа.",
    },
    {
        type: 1,
        address: { street: "Малый проспект В.О.", houseNumber: 17 },
        position: { lat: 59.9468959, lng: 30.2733642 },
        date: new Date(1945, 2, 3),
        description: "Пробито чердачное перекрытие 3 этажа.",
    },
    {
        type: 1,
        address: { street: "набережная канала Грибоедова", houseNumber: 18 },
        position: { lat: 59.934513, lng: 30.3264872 },
        date: new Date(1944, 9, 2),
        description: "Пробито чердачное перекрытие 3 этажа.",
    },
    {
        type: 0,
        address: { street: "набережная реки Мойки", houseNumber: 6 },
        position: { lat: 59.9417361, lng: 30.3227354 },
        date: new Date(1941, 5, 0),
        description: "Пробито чердачное перекрытие 3 этажа.",
    },
    {
        type: 1,
        address: { street: "улица Рылеева", houseNumber: 31 },
        position: { lat: 59.9423258, lng: 30.3602044 },
        date: new Date(1942, 10, 1),
        description: "Пробито чердачное перекрытие 3 этажа.",
    },
    {
        type: 1,
        address: { street: "Литейный проспект", houseNumber: 30 },
        position: { lat: 59.9407651, lng: 30.3499612 },
        date: new Date(1942, 4, 0),
        description: "Пробито чердачное перекрытие 3 этажа.",
    },
    {
        type: 0,
        address: { street: "набережная реки Фонтанки", houseNumber: 66 },
        position: { lat: 59.9285127, lng: 30.3371036 },
        date: new Date(1941, 8, 2),
        description: "Пробито чердачное перекрытие 3 этажа.",
    },
    {
        type: 2,
        address: { street: "улица Беринга", houseNumber: 30 },
        position: { lat: 59.9438138, lng: 30.2381453 },
        date: new Date(1943, 6, 6),
        description: "Пробито чердачное перекрытие 3 этажа.",
    },
    {
        type: 1,
        address: { street: "Лахтинский проспект", houseNumber: 85 },
        position: { lat: 59.9946866, lng: 30.1470988 },
        date: new Date(1944, 0, 2),
        description: "Пробито чердачное перекрытие 3 этажа.",
    },
    {
        type: 1,
        address: { street: "Миллионная улица", houseNumber: 31 },
        position: { lat: 59.942111, lng: 30.3198329 },
        date: new Date(1943, 11, 0),
        description: "Пробито чердачное перекрытие 3 этажа.",
    },
    {
        type: 1,
        address: { street: "Большая Морская улица", houseNumber: 4 },
        position: { lat: 59.9374344, lng: 30.317986 },
        date: new Date(1944, 3, 2),
        description: "Пробито чердачное перекрытие 3 этажа.",
    },
    {
        type: 1,
        address: { street: "Вязовая улица", houseNumber: 8 },
        position: { lat: 59.9677799, lng: 30.2768299 },
        date: new Date(1941, 6, 1),
        description: "Пробито чердачное перекрытие 3 этажа.",
    },
    {
        type: 1,
        address: { street: "улица Коллонтай", houseNumber: 18 },
        position: { lat: 59.918821, lng: 30.4635777 },
        date: new Date(1945, 7, 4),
        description: "Пробито чердачное перекрытие 3 этажа.",
    },
    {
        type: 1,
        address: { street: "Кирпичный переулок", houseNumber: 6 },
        position: { lat: 59.9354315, lng: 30.3163255 },
        date: new Date(1945, 6, 0),
        description: "Пробито чердачное перекрытие 3 этажа.",
    },
    {
        type: 2,
        address: { street: "набережная Кутузова", houseNumber: 4 },
        position: { lat: 59.9494071, lng: 30.3463456 },
        date: new Date(1945, 2, 2),
        description: "Пробито чердачное перекрытие 3 этажа.",
    },
    {
        type: 1,
        address: { street: "Невский проспект", houseNumber: 47 },
        position: { lat: 59.9325995, lng: 30.3470924 },
        date: new Date(1942, 5, 0),
        description: "Пробито чердачное перекрытие 3 этажа.",
    },
    {
        type: 1,
        address: { street: "проспект Просвещения", houseNumber: 75 },
        position: { lat: 60.0384081, lng: 30.4024563 },
        date: new Date(1944, 0, 5),
        description: "Пробито чердачное перекрытие 3 этажа.",
    },
    {
        type: 0,
        address: { street: "проспект Энгельса", houseNumber: 58 },
        position: { lat: 60.0149338, lng: 30.3226437 },
        date: new Date(1944, 8, 0),
        description: "Пробито чердачное перекрытие 3 этажа.",
    },
    {
        type: 1,
        address: { street: "улица Степана Разина", houseNumber: 9 },
        position: { lat: 59.9123327, lng: 30.2662164 },
        date: new Date(1942, 5, 4),
        description: "Пробито чердачное перекрытие 3 этажа.",
    },
    {
        type: 2,
        address: { street: "Малый проспект В.О.", houseNumber: 73 },
        position: { lat: 59.9379266, lng: 30.2366429 },
        date: new Date(1942, 5, 5),
        description: "Пробито чердачное перекрытие 3 этажа.",
    },
    {
        type: 1,
        address: { street: "Коломенская улица", houseNumber: 19 },
        position: { lat: 59.9242952, lng: 30.3536778 },
        date: new Date(1943, 6, 3),
        description: "Пробито чердачное перекрытие 3 этажа.",
    },
    {
        type: 1,
        address: { street: "улица Восстания", houseNumber: 40 },
        position: { lat: 59.9430281, lng: 30.3601097 },
        date: new Date(1944, 9, 5),
        description: "Пробито чердачное перекрытие 3 этажа.",
    },
    {
        type: 2,
        address: { street: "Краснопутиловская улица", houseNumber: 21 },
        position: { lat: 59.8709724, lng: 30.2677708 },
        date: new Date(1945, 5, 5),
        description: "Пробито чердачное перекрытие 3 этажа.",
    },
    {
        type: 1,
        address: { street: "Академический переулок", houseNumber: 2 },
        position: { lat: 59.9377685, lng: 30.2879304 },
        date: new Date(1942, 4, 6),
        description: "Пробито чердачное перекрытие 3 этажа.",
    },
    {
        type: 0,
        address: { street: "набережная Крюкова канала", houseNumber: 8 },
        position: { lat: 59.9266564, lng: 30.294887 },
        date: new Date(1942, 7, 2),
        description: "Пробито чердачное перекрытие 3 этажа.",
    },
    {
        type: 1,
        address: { street: "Столярный переулок", houseNumber: 5 },
        position: { lat: 59.9280644, lng: 30.3108736 },
        date: new Date(1943, 0, 0),
        description: "Пробито чердачное перекрытие 3 этажа.",
    },
    {
        type: 1,
        address: { street: "Варшавская улица", houseNumber: 62 },
        position: { lat: 59.8592247, lng: 30.314609 },
        date: new Date(1942, 11, 3),
        description: "Пробито чердачное перекрытие 3 этажа.",
    },
    {
        type: 1,
        address: { street: "Брантовская дорога", houseNumber: 3 },
        position: { lat: 59.9397116, lng: 30.4186813 },
        date: new Date(1941, 11, 4),
        description: "Пробито чердачное перекрытие 3 этажа.",
    },
    {
        type: 1,
        address: { street: "Софийская улица", houseNumber: 28 },
        position: { lat: 59.8751565, lng: 30.4029917 },
        date: new Date(1942, 1, 0),
        description: "Пробито чердачное перекрытие 3 этажа.",
    },
    {
        type: 0,
        address: { street: "улица Ломоносова", houseNumber: 2 },
        position: { lat: 59.9325802, lng: 30.3268186 },
        date: new Date(1943, 4, 0),
        description: "Пробито чердачное перекрытие 3 этажа.",
    },
    {
        type: 1,
        address: { street: "улица Восстания", houseNumber: 24 },
        position: { lat: 59.938155, lng: 30.3592998 },
        date: new Date(1942, 0, 2),
        description: "Пробито чердачное перекрытие 3 этажа.",
    },
    {
        type: 2,
        address: { street: "Фермское шоссе", houseNumber: 32 },
        position: { lat: 60.0168366, lng: 30.3104666 },
        date: new Date(1944, 0, 1),
        description: "Пробито чердачное перекрытие 3 этажа.",
    },
    {
        type: 2,
        address: { street: "набережная реки Фонтанки", houseNumber: 81 },
        position: { lat: 59.9255991, lng: 30.3261275 },
        date: new Date(1944, 4, 5),
        description: "Пробито чердачное перекрытие 3 этажа.",
    },
    {
        type: 1,
        address: { street: "Гражданский проспект", houseNumber: 92 },
        position: { lat: 60.0198074, lng: 30.4033961 },
        date: new Date(1943, 3, 4),
        description: "Пробито чердачное перекрытие 3 этажа.",
    },
    {
        type: 0,
        address: { street: "Менделеевская улица", houseNumber: 2 },
        position: { lat: 59.9731849, lng: 30.3515772 },
        date: new Date(1945, 3, 5),
        description: "Пробито чердачное перекрытие 3 этажа.",
    },
    {
        type: 2,
        address: { street: "Румянцевская площадь", houseNumber: 1 },
        position: { lat: 59.9392928, lng: 30.2929048 },
        date: new Date(1942, 1, 4),
        description: "Пробито чердачное перекрытие 3 этажа.",
    },
    {
        type: 2,
        address: { street: "переулок Пирогова", houseNumber: 1 },
        position: { lat: 59.9299513, lng: 30.3079554 },
        date: new Date(1943, 5, 3),
        description: "Пробито чердачное перекрытие 3 этажа.",
    },
    {
        type: 2,
        address: { street: "Москательный переулок", houseNumber: 1 },
        position: { lat: 59.9307232, lng: 30.3222723 },
        date: new Date(1944, 7, 0),
        description: "Пробито чердачное перекрытие 3 этажа.",
    },
    {
        type: 0,
        address: { street: "Галерная улица", houseNumber: 28 },
        position: { lat: 59.9320705, lng: 30.290557 },
        date: new Date(1941, 9, 2),
        description: "Пробито чердачное перекрытие 3 этажа.",
    },
    {
        type: 1,
        address: { street: "Малый проспект В.О.", houseNumber: 80 },
        position: { lat: 59.9377006, lng: 30.2387409 },
        date: new Date(1942, 11, 0),
        description: "Пробито чердачное перекрытие 3 этажа.",
    },
    {
        type: 1,
        address: { street: "Каменноостровский проспект", houseNumber: 31 },
        position: { lat: 59.9650246, lng: 30.3125496 },
        date: new Date(1945, 2, 5),
        description: "Пробито чердачное перекрытие 3 этажа.",
    },
    {
        type: 1,
        address: { street: "Невский проспект", houseNumber: 150 },
        position: { lat: 59.9286445, lng: 30.3737208 },
        date: new Date(1943, 10, 0),
        description: "Пробито чердачное перекрытие 3 этажа.",
    },
    {
        type: 2,
        address: { street: "Митрофаньевское шоссе", houseNumber: 6 },
        position: { lat: 59.9001511, lng: 30.3000536 },
        date: new Date(1942, 5, 0),
        description: "Пробито чердачное перекрытие 3 этажа.",
    },
    {
        type: 0,
        address: { street: "Иностранный переулок", houseNumber: 3 },
        position: { lat: 59.9345104, lng: 30.2756828 },
        date: new Date(1942, 4, 6),
        description: "Пробито чердачное перекрытие 3 этажа.",
    },
    {
        type: 2,
        address: { street: "Загребский бульвар", houseNumber: 9 },
        position: { lat: 59.8452012, lng: 30.3969782 },
        date: new Date(1945, 4, 3),
        description: "Пробито чердачное перекрытие 3 этажа.",
    },
    {
        type: 1,
        address: { street: "улица Беринга", houseNumber: 1 },
        position: { lat: 59.935761, lng: 30.2489721 },
        date: new Date(1944, 3, 4),
        description: "Пробито чердачное перекрытие 3 этажа.",
    },
    {
        type: 1,
        address: { street: "Колтушское шоссе", houseNumber: 276 },
        position: { lat: 60.0005618, lng: 30.6611809 },
        date: new Date(1944, 5, 5),
        description: "Пробито чердачное перекрытие 3 этажа.",
    },
    {
        type: 1,
        address: { street: "улица Радищева", houseNumber: 15 },
        position: { lat: 59.9373893, lng: 30.3630234 },
        date: new Date(1942, 8, 2),
        description: "Пробито чердачное перекрытие 3 этажа.",
    },
    {
        type: 2,
        address: { street: "Итальянская улица", houseNumber: 21 },
        position: { lat: 59.9360584, lng: 30.3357318 },
        date: new Date(1942, 5, 1),
        description: "Пробито чердачное перекрытие 3 этажа.",
    },
    {
        type: 0,
        address: { street: "Большой проспект В.О.", houseNumber: 41 },
        position: { lat: 59.9377815, lng: 30.276624 },
        date: new Date(1945, 0, 1),
        description: "Пробито чердачное перекрытие 3 этажа.",
    },
    {
        type: 0,
        address: { street: "Невский проспект", houseNumber: 102 },
        position: { lat: 59.9318689, lng: 30.3562291 },
        date: new Date(1943, 11, 0),
        description: "Пробито чердачное перекрытие 3 этажа.",
    },
    {
        type: 2,
        address: { street: "Сестрорецкая улица", houseNumber: 6 },
        position: { lat: 59.9866013, lng: 30.2892545 },
        date: new Date(1941, 6, 6),
        description: "Пробито чердачное перекрытие 3 этажа.",
    },
    {
        type: 1,
        address: { street: "улица Смолячкова", houseNumber: 10 },
        position: { lat: 59.9707917, lng: 30.3416847 },
        date: new Date(1943, 0, 0),
        description: "Пробито чердачное перекрытие 3 этажа.",
    },
    {
        type: 2,
        address: { street: "проспект Металлистов", houseNumber: 73 },
        position: { lat: 59.9704098, lng: 30.4039504 },
        date: new Date(1943, 1, 1),
        description: "Пробито чердачное перекрытие 3 этажа.",
    },
    {
        type: 0,
        address: { street: "Большой проспект В.О.", houseNumber: 29 },
        position: { lat: 59.9390755, lng: 30.2811088 },
        date: new Date(1941, 10, 2),
        description: "Пробито чердачное перекрытие 3 этажа.",
    },
    {
        type: 1,
        address: { street: "Шоссейная улица", houseNumber: 10 },
        position: { lat: 59.9461397, lng: 30.5500588 },
        date: new Date(1945, 0, 5),
        description: "Пробито чердачное перекрытие 3 этажа.",
    },
    {
        type: 0,
        address: { street: "1-я Жерновская улица", houseNumber: 5 },
        position: { lat: 59.9647331, lng: 30.483263 },
        date: new Date(1942, 10, 4),
        description: "Пробито чердачное перекрытие 3 этажа.",
    },
    {
        type: 0,
        address: { street: "Большой Сампсониевский проспект", houseNumber: 70 },
        position: { lat: 59.9811198, lng: 30.3363121 },
        date: new Date(1944, 1, 2),
        description: "Пробито чердачное перекрытие 3 этажа.",
    },
    {
        type: 1,
        address: { street: "проспект КИМа", houseNumber: 7 },
        position: { lat: 59.9521122, lng: 30.2460961 },
        date: new Date(1944, 7, 2),
        description: "Пробито чердачное перекрытие 3 этажа.",
    },
    {
        type: 0,
        address: { street: "улица Мира", houseNumber: 1 },
        position: { lat: 59.9588013, lng: 30.3127708 },
        date: new Date(1942, 10, 3),
        description: "Пробито чердачное перекрытие 3 этажа.",
    },
    {
        type: 1,
        address: { street: "улица Жуковского", houseNumber: 1 },
        position: { lat: 59.9358848, lng: 30.3487206 },
        date: new Date(1944, 4, 3),
        description: "Пробито чердачное перекрытие 3 этажа.",
    },
    {
        type: 1,
        address: { street: "Уральская улица", houseNumber: 11 },
        position: { lat: 59.9527087, lng: 30.2647304 },
        date: new Date(1942, 2, 2),
        description: "Пробито чердачное перекрытие 3 этажа.",
    },
    {
        type: 1,
        address: { street: "Комендантский проспект", houseNumber: 58 },
        position: { lat: 60.0337712, lng: 30.2267828 },
        date: new Date(1945, 4, 3),
        description: "Пробито чердачное перекрытие 3 этажа.",
    },
    {
        type: 0,
        address: { street: "Английская набережная", houseNumber: 70 },
        position: { lat: 59.9316142, lng: 30.2842943 },
        date: new Date(1944, 0, 3),
        description: "Пробито чердачное перекрытие 3 этажа.",
    },
    {
        type: 1,
        address: { street: "Итальянская улица", houseNumber: 25 },
        position: { lat: 59.9358721, lng: 30.3371438 },
        date: new Date(1944, 0, 1),
        description: "Пробито чердачное перекрытие 3 этажа.",
    },
    {
        type: 1,
        address: { street: "Невский проспект", houseNumber: 65 },
        position: { lat: 59.9318105, lng: 30.3531961 },
        date: new Date(1944, 11, 2),
        description: "Пробито чердачное перекрытие 3 этажа.",
    },
    {
        type: 1,
        address: { street: "Рижский проспект", houseNumber: 29 },
        position: { lat: 59.9135965, lng: 30.2795331 },
        date: new Date(1942, 4, 0),
        description: "Пробито чердачное перекрытие 3 этажа.",
    },
    {
        type: 1,
        address: { street: "Миллионная улица", houseNumber: 2 },
        position: { lat: 59.9441962, lng: 30.3261686 },
        date: new Date(1942, 2, 0),
        description: "Пробито чердачное перекрытие 3 этажа.",
    },
    {
        type: 1,
        address: { street: "улица Академика Крылова", houseNumber: 4 },
        position: { lat: 59.9858721, lng: 30.3004986 },
        date: new Date(1943, 1, 5),
        description: "Пробито чердачное перекрытие 3 этажа.",
    },
    {
        type: 1,
        address: { street: "Английская набережная", houseNumber: 52 },
        position: { lat: 59.9324776, lng: 30.2879359 },
        date: new Date(1944, 5, 3),
        description: "Пробито чердачное перекрытие 3 этажа.",
    },
    {
        type: 0,
        address: { street: "Садовая улица", houseNumber: 29 },
        position: { lat: 59.9292128, lng: 30.3224727 },
        date: new Date(1943, 11, 5),
        description: "Пробито чердачное перекрытие 3 этажа.",
    },
    {
        type: 0,
        address: { street: "улица Маршала Говорова", houseNumber: 30 },
        position: { lat: 59.8888067, lng: 30.2767496 },
        date: new Date(1944, 1, 1),
        description: "Пробито чердачное перекрытие 3 этажа.",
    },
    {
        type: 1,
        address: { street: "улица Нахимова", houseNumber: 2 },
        position: { lat: 59.9437123, lng: 30.236122 },
        date: new Date(1945, 8, 2),
        description: "Пробито чердачное перекрытие 3 этажа.",
    },
    {
        type: 2,
        address: { street: "Гороховая улица", houseNumber: 13 },
        position: { lat: 59.9338414, lng: 30.3138505 },
        date: new Date(1944, 11, 2),
        description: "Пробито чердачное перекрытие 3 этажа.",
    },
    {
        type: 0,
        address: { street: "Греческий проспект", houseNumber: 13 },
        position: { lat: 59.9353423, lng: 30.3667879 },
        date: new Date(1943, 2, 2),
        description: "Пробито чердачное перекрытие 3 этажа.",
    },
    {
        type: 0,
        address: { street: "Севастопольская улица", houseNumber: 41 },
        position: { lat: 59.8895152, lng: 30.2648508 },
        date: new Date(1942, 3, 2),
        description: "Пробито чердачное перекрытие 3 этажа.",
    },
    {
        type: 0,
        address: { street: "Загородный проспект", houseNumber: 66 },
        position: { lat: 59.9177426, lng: 30.3215499 },
        date: new Date(1945, 2, 0),
        description: "Пробито чердачное перекрытие 3 этажа.",
    },
    {
        type: 1,
        address: { street: "улица Оптиков", houseNumber: 54 },
        position: { lat: 60.0018143, lng: 30.1986052 },
        date: new Date(1944, 4, 6),
        description: "Пробито чердачное перекрытие 3 этажа.",
    },
    {
        type: 2,
        address: { street: "проспект Чернышевского", houseNumber: 11 },
        position: { lat: 59.9460065, lng: 30.3589951 },
        date: new Date(1944, 6, 0),
        description: "Пробито чердачное перекрытие 3 этажа.",
    },
    {
        type: 0,
        address: { street: "улица Рубинштейна", houseNumber: 34 },
        position: { lat: 59.9280635, lng: 30.3435416 },
        date: new Date(1943, 8, 5),
        description: "Пробито чердачное перекрытие 3 этажа.",
    },
    {
        type: 1,
        address: { street: "улица Труда", houseNumber: 8 },
        position: { lat: 59.9299687, lng: 30.2946022 },
        date: new Date(1944, 4, 3),
        description: "Пробито чердачное перекрытие 3 этажа.",
    },
    {
        type: 2,
        address: { street: "Невский проспект", houseNumber: 110 },
        position: { lat: 59.9324369, lng: 30.3584055 },
        date: new Date(1944, 7, 5),
        description: "Пробито чердачное перекрытие 3 этажа.",
    },
    {
        type: 1,
        address: { street: "улица Марата", houseNumber: 14 },
        position: { lat: 59.9294426, lng: 30.354512 },
        date: new Date(1942, 7, 6),
        description: "Пробито чердачное перекрытие 3 этажа.",
    },
    {
        type: 1,
        address: { street: "Расстанная улица", houseNumber: 7 },
        position: { lat: 59.9070613, lng: 30.3472112 },
        date: new Date(1942, 11, 3),
        description: "Пробито чердачное перекрытие 3 этажа.",
    },
    {
        type: 2,
        address: { street: "улица Химиков", houseNumber: 28 },
        position: { lat: 59.9730843, lng: 30.4811054 },
        date: new Date(1942, 3, 6),
        description: "Пробито чердачное перекрытие 3 этажа.",
    },
    {
        type: 2,
        address: { street: "Столярный переулок", houseNumber: 13 },
        position: { lat: 59.9266512, lng: 30.3124784 },
        date: new Date(1942, 4, 6),
        description: "Пробито чердачное перекрытие 3 этажа.",
    },
    {
        type: 1,
        address: { street: "8-я Советская улица", houseNumber: 2 },
        position: { lat: 59.938053, lng: 30.3701496 },
        date: new Date(1942, 3, 5),
        description: "Пробито чердачное перекрытие 3 этажа.",
    },
    {
        type: 1,
        address: { street: "проспект Маршала Блюхера", houseNumber: 4 },
        position: { lat: 59.9859127, lng: 30.3640443 },
        date: new Date(1945, 7, 4),
        description: "Пробито чердачное перекрытие 3 этажа.",
    },
    {
        type: 0,
        address: { street: "Разъезжая улица", houseNumber: 41 },
        position: { lat: 59.921736, lng: 30.3521915 },
        date: new Date(1942, 5, 5),
        description: "Пробито чердачное перекрытие 3 этажа.",
    },
    {
        type: 2,
        address: { street: "Большая Московская улица", houseNumber: 10 },
        position: { lat: 59.9260989, lng: 30.3472282 },
        date: new Date(1945, 7, 5),
        description: "Пробито чердачное перекрытие 3 этажа.",
    },
    {
        type: 2,
        address: { street: "набережная реки Фонтанки", houseNumber: 185 },
        position: { lat: 59.9165785, lng: 30.2871888 },
        date: new Date(1945, 4, 4),
        description: "Пробито чердачное перекрытие 3 этажа.",
    },
    {
        type: 0,
        address: { street: "Севастопольская улица", houseNumber: 13 },
        position: { lat: 59.8941909, lng: 30.2657342 },
        date: new Date(1942, 8, 0),
        description: "Пробито чердачное перекрытие 3 этажа.",
    },
    {
        type: 1,
        address: { street: "Полевая улица", houseNumber: 3 },
        position: { lat: 60.0023138, lng: 30.1495844 },
        date: new Date(1941, 6, 6),
        description: "Пробито чердачное перекрытие 3 этажа.",
    },
    {
        type: 1,
        address: { street: "Большой проспект В.О.", houseNumber: 37 },
        position: { lat: 59.9382579, lng: 30.2780919 },
        date: new Date(1941, 9, 0),
        description: "Пробито чердачное перекрытие 3 этажа.",
    },
    {
        type: 1,
        address: { street: "Большая Конюшенная улица", houseNumber: 31 },
        position: { lat: 59.9361192, lng: 30.321981 },
        date: new Date(1945, 6, 1),
        description: "Пробито чердачное перекрытие 3 этажа.",
    },
    {
        type: 0,
        address: { street: "улица Ильюшина", houseNumber: 8 },
        position: { lat: 60.0070101, lng: 30.2518521 },
        date: new Date(1943, 2, 4),
        description: "Пробито чердачное перекрытие 3 этажа.",
    },
    {
        type: 0,
        address: { street: "проспект Луначарского", houseNumber: 46 },
        position: { lat: 60.0444545, lng: 30.3269756 },
        date: new Date(1942, 8, 1),
        description: "Пробито чердачное перекрытие 3 этажа.",
    },
    {
        type: 2,
        address: { street: "улица Савушкина", houseNumber: 13 },
        position: { lat: 59.9859122, lng: 30.2936553 },
        date: new Date(1944, 11, 0),
        description: "Пробито чердачное перекрытие 3 этажа.",
    },
    {
        type: 0,
        address: { street: "Замшина улица", houseNumber: 28 },
        position: { lat: 59.973565, lng: 30.3988348 },
        date: new Date(1945, 0, 6),
        description: "Пробито чердачное перекрытие 3 этажа.",
    },
    {
        type: 2,
        address: { street: "Тележная улица", houseNumber: 24 },
        position: { lat: 59.9255937, lng: 30.3760862 },
        date: new Date(1944, 6, 3),
        description: "Пробито чердачное перекрытие 3 этажа.",
    },
    {
        type: 1,
        address: { street: "набережная Обводного канала", houseNumber: 181 },
        position: { lat: 59.9094146, lng: 30.2939894 },
        date: new Date(1943, 5, 6),
        description: "Пробито чердачное перекрытие 3 этажа.",
    },
    {
        type: 0,
        address: { street: "Лахтинский проспект", houseNumber: 85 },
        position: { lat: 59.9946866, lng: 30.1470988 },
        date: new Date(1943, 1, 5),
        description: "Пробито чердачное перекрытие 3 этажа.",
    },
    {
        type: 1,
        address: { street: "улица Восстания", houseNumber: 28 },
        position: { lat: 59.939708, lng: 30.3602885 },
        date: new Date(1944, 8, 4),
        description: "Пробито чердачное перекрытие 3 этажа.",
    },
    {
        type: 1,
        address: { street: "улица Фрунзе", houseNumber: 24 },
        position: { lat: 59.8621091, lng: 30.3335351 },
        date: new Date(1945, 1, 5),
        description: "Пробито чердачное перекрытие 3 этажа.",
    },
    {
        type: 1,
        address: { street: "Мошков переулок", houseNumber: 8 },
        position: { lat: 59.9425645, lng: 30.3225609 },
        date: new Date(1944, 1, 6),
        description: "Пробито чердачное перекрытие 3 этажа.",
    },
    {
        type: 2,
        address: { street: "улица Композиторов", houseNumber: 10 },
        position: { lat: 60.0486268, lng: 30.316388 },
        date: new Date(1945, 3, 0),
        description: "Пробито чердачное перекрытие 3 этажа.",
    },
    {
        type: 2,
        address: { street: "улица Барона Корфа", houseNumber: 20 },
        position: { lat: 60.0315646, lng: 30.6735037 },
        date: new Date(1944, 4, 1),
        description: "Пробито чердачное перекрытие 3 этажа.",
    },
    {
        type: 2,
        address: { street: "улица Репина", houseNumber: 25 },
        position: { lat: 59.9422606, lng: 30.2882629 },
        date: new Date(1944, 5, 2),
        description: "Пробито чердачное перекрытие 3 этажа.",
    },
    {
        type: 1,
        address: { street: "улица Бабушкина", houseNumber: 64 },
        position: { lat: 59.8654613, lng: 30.4548928 },
        date: new Date(1944, 3, 3),
        description: "Пробито чердачное перекрытие 3 этажа.",
    },
    {
        type: 1,
        address: { street: "проспект Обуховской Обороны", houseNumber: 86 },
        position: { lat: 59.8938585, lng: 30.4383623 },
        date: new Date(1945, 3, 2),
        description: "Пробито чердачное перекрытие 3 этажа.",
    },
    {
        type: 2,
        address: { street: "Боровая улица", houseNumber: 6 },
        position: { lat: 59.9215412, lng: 30.3498553 },
        date: new Date(1943, 10, 5),
        description: "Пробито чердачное перекрытие 3 этажа.",
    },
    {
        type: 2,
        address: { street: "Лыжный переулок", houseNumber: 6 },
        position: { lat: 59.9990696, lng: 30.1993629 },
        date: new Date(1944, 2, 0),
        description: "Пробито чердачное перекрытие 3 этажа.",
    },
    {
        type: 2,
        address: { street: "проспект Чернышевского", houseNumber: 9 },
        position: { lat: 59.9469939, lng: 30.3591019 },
        date: new Date(1943, 8, 6),
        description: "Пробито чердачное перекрытие 3 этажа.",
    },
    {
        type: 0,
        address: { street: "дорога на Турухтанные острова", houseNumber: 5 },
        position: { lat: 59.873689, lng: 30.2198518 },
        date: new Date(1945, 8, 0),
        description: "Пробито чердачное перекрытие 3 этажа.",
    },
    {
        type: 2,
        address: { street: "Садовая улица", houseNumber: 35 },
        position: { lat: 59.9278604, lng: 30.3199827 },
        date: new Date(1944, 4, 6),
        description: "Пробито чердачное перекрытие 3 этажа.",
    },
    {
        type: 0,
        address: { street: "проспект Непокорённых", houseNumber: 2 },
        position: { lat: 59.9982919, lng: 30.3675647 },
        date: new Date(1945, 5, 2),
        description: "Пробито чердачное перекрытие 3 этажа.",
    },
    {
        type: 0,
        address: { street: "улица Академика Шиманского", houseNumber: 3 },
        position: { lat: 59.9851067, lng: 30.2876385 },
        date: new Date(1943, 6, 5),
        description: "Пробито чердачное перекрытие 3 этажа.",
    },
    {
        type: 0,
        address: { street: "Богатырский проспект", houseNumber: 55 },
        position: { lat: 60.007726, lng: 30.2138692 },
        date: new Date(1943, 9, 4),
        description: "Пробито чердачное перекрытие 3 этажа.",
    },
    {
        type: 0,
        address: { street: "Уральская улица", houseNumber: 4 },
        position: { lat: 59.950154, lng: 30.2663915 },
        date: new Date(1944, 11, 1),
        description: "Пробито чердачное перекрытие 3 этажа.",
    },
    {
        type: 1,
        address: { street: "Садовая улица", houseNumber: 21 },
        position: { lat: 60.0427784, lng: 30.4512987 },
        date: new Date(1942, 6, 6),
        description: "Пробито чердачное перекрытие 3 этажа.",
    },
    {
        type: 1,
        address: { street: "проспект Обуховской Обороны", houseNumber: 93 },
        position: { lat: 59.8986766, lng: 30.4298211 },
        date: new Date(1942, 2, 6),
        description: "Пробито чердачное перекрытие 3 этажа.",
    },
    {
        type: 1,
        address: { street: "улица Сикейроса", houseNumber: 11 },
        position: { lat: 60.0346395, lng: 30.3295693 },
        date: new Date(1943, 2, 2),
        description: "Пробито чердачное перекрытие 3 этажа.",
    },
    {
        type: 0,
        address: { street: "улица Смолячкова", houseNumber: 10 },
        position: { lat: 59.9707917, lng: 30.3416847 },
        date: new Date(1943, 7, 6),
        description: "Пробито чердачное перекрытие 3 этажа.",
    },
    {
        type: 1,
        address: { street: "Большая Конюшенная улица", houseNumber: 4 },
        position: { lat: 59.9389665, lng: 30.3239588 },
        date: new Date(1942, 8, 5),
        description: "Пробито чердачное перекрытие 3 этажа.",
    },
    {
        type: 2,
        address: { street: "Исаакиевская площадь", houseNumber: 4 },
        position: { lat: 59.9321672, lng: 30.3097433 },
        date: new Date(1941, 10, 0),
        description: "Пробито чердачное перекрытие 3 этажа.",
    },
    {
        type: 2,
        address: { street: "улица Барона Корфа", houseNumber: 18 },
        position: { lat: 60.0316031, lng: 30.6724335 },
        date: new Date(1945, 4, 0),
        description: "Пробито чердачное перекрытие 3 этажа.",
    },
    {
        type: 1,
        address: { street: "Загородный проспект", houseNumber: 10 },
        position: { lat: 59.9265952, lng: 30.3456593 },
        date: new Date(1944, 9, 3),
        description: "Пробито чердачное перекрытие 3 этажа.",
    },
    {
        type: 1,
        address: { street: "Большая Пушкарская улица", houseNumber: 2 },
        position: { lat: 59.9541785, lng: 30.2955013 },
        date: new Date(1943, 5, 2),
        description: "Пробито чердачное перекрытие 3 этажа.",
    },
    {
        type: 0,
        address: { street: "Каменноостровский проспект", houseNumber: 42 },
        position: { lat: 59.9669338, lng: 30.3101028 },
        date: new Date(1944, 11, 0),
        description: "Пробито чердачное перекрытие 3 этажа.",
    },
    {
        type: 1,
        address: { street: "проспект Девятого Января", houseNumber: 18 },
        position: { lat: 59.8433517, lng: 30.4538074 },
        date: new Date(1941, 9, 4),
        description: "Пробито чердачное перекрытие 3 этажа.",
    },
    {
        type: 1,
        address: { street: "Казанская улица", houseNumber: 22 },
        position: { lat: 59.93119, lng: 30.3199532 },
        date: new Date(1942, 3, 4),
        description: "Пробито чердачное перекрытие 3 этажа.",
    },
    {
        type: 1,
        address: { street: "Малая Десятинная улица", houseNumber: 11 },
        position: { lat: 60.0330627, lng: 30.2948614 },
        date: new Date(1944, 3, 6),
        description: "Пробито чердачное перекрытие 3 этажа.",
    },
    {
        type: 0,
        address: { street: "Тучков переулок", houseNumber: 16 },
        position: { lat: 59.9452088, lng: 30.287966 },
        date: new Date(1945, 4, 2),
        description: "Пробито чердачное перекрытие 3 этажа.",
    },
    {
        type: 1,
        address: { street: "Пионерская улица", houseNumber: 11 },
        position: { lat: 59.9567132, lng: 30.2931297 },
        date: new Date(1945, 5, 3),
        description: "Пробито чердачное перекрытие 3 этажа.",
    },
    {
        type: 1,
        address: { street: "улица Маршала Тухачевского", houseNumber: 23 },
        position: { lat: 59.9684789, lng: 30.42801 },
        date: new Date(1941, 6, 2),
        description: "Пробито чердачное перекрытие 3 этажа.",
    },
    {
        type: 1,
        address: { street: "улица Трефолева", houseNumber: 4 },
        position: { lat: 59.8874939, lng: 30.280388 },
        date: new Date(1945, 0, 0),
        description: "Пробито чердачное перекрытие 3 этажа.",
    },
    {
        type: 1,
        address: { street: "Будапештская улица", houseNumber: 19 },
        position: { lat: 59.8643864, lng: 30.3722864 },
        date: new Date(1941, 10, 2),
        description: "Пробито чердачное перекрытие 3 этажа.",
    },
    {
        type: 0,
        address: { street: "Липовая аллея", houseNumber: 11 },
        position: { lat: 59.9858592, lng: 30.2567333 },
        date: new Date(1943, 10, 4),
        description: "Пробито чердачное перекрытие 3 этажа.",
    },
    {
        type: 1,
        address: { street: "улица Труда", houseNumber: 8 },
        position: { lat: 59.9299687, lng: 30.2946022 },
        date: new Date(1942, 8, 5),
        description: "Пробито чердачное перекрытие 3 этажа.",
    },
    {
        type: 2,
        address: { street: "Октябрьская набережная", houseNumber: 12 },
        position: { lat: 59.9108682, lng: 30.4242388 },
        date: new Date(1942, 9, 6),
        description: "Пробито чердачное перекрытие 3 этажа.",
    },
    {
        type: 2,
        address: { street: "Лиговский проспект", houseNumber: 166 },
        position: { lat: 59.9115875, lng: 30.3487882 },
        date: new Date(1943, 9, 0),
        description: "Пробито чердачное перекрытие 3 этажа.",
    },
    {
        type: 0,
        address: { street: "3-я Советская улица", houseNumber: 17 },
        position: { lat: 59.9309984, lng: 30.373004 },
        date: new Date(1945, 3, 5),
        description: "Пробито чердачное перекрытие 3 этажа.",
    },
    {
        type: 1,
        address: { street: "Колокольная улица", houseNumber: 16 },
        position: { lat: 59.9285475, lng: 30.3523905 },
        date: new Date(1944, 3, 0),
        description: "Пробито чердачное перекрытие 3 этажа.",
    },
    {
        type: 2,
        address: { street: "переулок Талалихина", houseNumber: 1 },
        position: { lat: 59.9508317, lng: 30.2966589 },
        date: new Date(1943, 10, 6),
        description: "Пробито чердачное перекрытие 3 этажа.",
    },
    {
        type: 1,
        address: { street: "Охтинская аллея", houseNumber: 18 },
        position: { lat: 60.0502309, lng: 30.4253383 },
        date: new Date(1942, 8, 5),
        description: "Пробито чердачное перекрытие 3 этажа.",
    },
    {
        type: 1,
        address: { street: "Кантемировская улица", houseNumber: 20 },
        position: { lat: 59.9852145, lng: 30.3403422 },
        date: new Date(1945, 7, 2),
        description: "Пробито чердачное перекрытие 3 этажа.",
    },
    {
        type: 2,
        address: { street: "Кузнецовская улица", houseNumber: 23 },
        position: { lat: 59.8714873, lng: 30.3184219 },
        date: new Date(1943, 9, 0),
        description: "Пробито чердачное перекрытие 3 этажа.",
    },
    {
        type: 1,
        address: { street: "улица Оптиков", houseNumber: 4 },
        position: { lat: 59.9918709, lng: 30.2527329 },
        date: new Date(1941, 7, 2),
        description: "Пробито чердачное перекрытие 3 этажа.",
    },
    {
        type: 1,
        address: { street: "Удельный проспект", houseNumber: 5 },
        position: { lat: 60.0126433, lng: 30.3169411 },
        date: new Date(1942, 1, 6),
        description: "Пробито чердачное перекрытие 3 этажа.",
    },
    {
        type: 2,
        address: { street: "Разъезжая улица", houseNumber: 13 },
        position: { lat: 59.9248418, lng: 30.3452903 },
        date: new Date(1945, 8, 6),
        description: "Пробито чердачное перекрытие 3 этажа.",
    },
    {
        type: 1,
        address: { street: "Вознесенский проспект", houseNumber: 22 },
        position: { lat: 59.9288777, lng: 30.3083993 },
        date: new Date(1944, 0, 0),
        description: "Пробито чердачное перекрытие 3 этажа.",
    },
    {
        type: 1,
        address: { street: "проспект Художников", houseNumber: 13 },
        position: { lat: 60.0367821, lng: 30.3454484 },
        date: new Date(1943, 3, 1),
        description: "Пробито чердачное перекрытие 3 этажа.",
    },
    {
        type: 2,
        address: { street: "проспект Просвещения", houseNumber: 19 },
        position: { lat: 60.052898, lng: 30.3311489 },
        date: new Date(1945, 6, 1),
        description: "Пробито чердачное перекрытие 3 этажа.",
    },
    {
        type: 2,
        address: { street: "Большая Зеленина улица", houseNumber: 28 },
        position: { lat: 59.9641762, lng: 30.2858887 },
        date: new Date(1945, 6, 3),
        description: "Пробито чердачное перекрытие 3 этажа.",
    },
    {
        type: 1,
        address: { street: "набережная канала Грибоедова", houseNumber: 61 },
        position: { lat: 59.9278048, lng: 30.3149166 },
        date: new Date(1942, 0, 4),
        description: "Пробито чердачное перекрытие 3 этажа.",
    },
    {
        type: 1,
        address: { street: "Моховая улица", houseNumber: 1 },
        position: { lat: 59.9464409, lng: 30.3447595 },
        date: new Date(1943, 4, 4),
        description: "Пробито чердачное перекрытие 3 этажа.",
    },
    {
        type: 1,
        address: { street: "улица Зои Космодемьянской", houseNumber: 1 },
        position: { lat: 59.8932449, lng: 30.2740562 },
        date: new Date(1941, 8, 1),
        description: "Пробито чердачное перекрытие 3 этажа.",
    },
    {
        type: 1,
        address: { street: "3-я Советская улица", houseNumber: 17 },
        position: { lat: 59.9309984, lng: 30.373004 },
        date: new Date(1942, 1, 3),
        description: "Пробито чердачное перекрытие 3 этажа.",
    },
    {
        type: 0,
        address: { street: "Лиговский проспект", houseNumber: 113 },
        position: { lat: 59.9193624, lng: 30.3528077 },
        date: new Date(1944, 4, 4),
        description: "Пробито чердачное перекрытие 3 этажа.",
    },
    {
        type: 0,
        address: { street: "улица Барона Корфа", houseNumber: 18 },
        position: { lat: 60.0316031, lng: 30.6724335 },
        date: new Date(1944, 2, 4),
        description: "Пробито чердачное перекрытие 3 этажа.",
    },
    {
        type: 2,
        address: { street: "Аптекарский проспект", houseNumber: 5 },
        position: { lat: 59.9733978, lng: 30.3209142 },
        date: new Date(1942, 1, 0),
        description: "Пробито чердачное перекрытие 3 этажа.",
    },
    {
        type: 0,
        address: { street: "Московский проспект", houseNumber: 41 },
        position: { lat: 59.9126425, lng: 30.3179945 },
        date: new Date(1944, 2, 4),
        description: "Пробито чердачное перекрытие 3 этажа.",
    },
    {
        type: 0,
        address: { street: "Ленинский проспект", houseNumber: 93 },
        position: { lat: 59.8539869, lng: 30.2100614 },
        date: new Date(1944, 9, 6),
        description: "Пробито чердачное перекрытие 3 этажа.",
    },
    {
        type: 1,
        address: { street: "улица Академика Шиманского", houseNumber: 5 },
        position: { lat: 59.9857388, lng: 30.2873784 },
        date: new Date(1943, 8, 1),
        description: "Пробито чердачное перекрытие 3 этажа.",
    },
    {
        type: 1,
        address: { street: "Софийская улица", houseNumber: 44 },
        position: { lat: 59.8697847, lng: 30.4116833 },
        date: new Date(1942, 9, 0),
        description: "Пробито чердачное перекрытие 3 этажа.",
    },
    {
        type: 1,
        address: { street: "Кирпичный переулок", houseNumber: 2 },
        position: { lat: 59.9359562, lng: 30.315584 },
        date: new Date(1943, 7, 1),
        description: "Пробито чердачное перекрытие 3 этажа.",
    },
    {
        type: 1,
        address: { street: "Сортировочная-Московская улица", houseNumber: 32 },
        position: { lat: 59.8663675, lng: 30.4306349 },
        date: new Date(1944, 10, 4),
        description: "Пробито чердачное перекрытие 3 этажа.",
    },
    {
        type: 1,
        address: { street: "переулок Пирогова", houseNumber: 11 },
        position: { lat: 59.9291973, lng: 30.303565 },
        date: new Date(1941, 7, 3),
        description: "Пробито чердачное перекрытие 3 этажа.",
    },
    {
        type: 0,
        address: { street: "Пушкинская улица", houseNumber: 8 },
        position: { lat: 59.9298969, lng: 30.3579966 },
        date: new Date(1942, 3, 6),
        description: "Пробито чердачное перекрытие 3 этажа.",
    },
    {
        type: 2,
        address: { street: "Всеволожский проспект", houseNumber: 29 },
        position: { lat: 60.0186809, lng: 30.6463154 },
        date: new Date(1943, 9, 6),
        description: "Пробито чердачное перекрытие 3 этажа.",
    },
    {
        type: 0,
        address: { street: "Петроградская набережная", houseNumber: 8 },
        position: { lat: 59.9575166, lng: 30.3350303 },
        date: new Date(1941, 11, 4),
        description: "Пробито чердачное перекрытие 3 этажа.",
    },
    {
        type: 1,
        address: { street: "проспект Художников", houseNumber: 15 },
        position: { lat: 60.0376504, lng: 30.3458653 },
        date: new Date(1942, 0, 6),
        description: "Пробито чердачное перекрытие 3 этажа.",
    },
    {
        type: 1,
        address: { street: "8-я линия В.О.", houseNumber: 55 },
        position: { lat: 59.9436981, lng: 30.2748841 },
        date: new Date(1945, 6, 2),
        description: "Пробито чердачное перекрытие 3 этажа.",
    },
    {
        type: 2,
        address: { street: "улица Нахимова", houseNumber: 1 },
        position: { lat: 59.9441711, lng: 30.2352494 },
        date: new Date(1942, 8, 4),
        description: "Пробито чердачное перекрытие 3 этажа.",
    },
    {
        type: 1,
        address: { street: "Опочинина улица", houseNumber: 4 },
        position: { lat: 59.9301756, lng: 30.2390145 },
        date: new Date(1945, 5, 1),
        description: "Пробито чердачное перекрытие 3 этажа.",
    },
    {
        type: 1,
        address: { street: "Ленинский проспект", houseNumber: 93 },
        position: { lat: 59.8539869, lng: 30.2100614 },
        date: new Date(1944, 5, 6),
        description: "Пробито чердачное перекрытие 3 этажа.",
    },
    {
        type: 0,
        address: { street: "Петроградская набережная", houseNumber: 20 },
        position: { lat: 59.95996, lng: 30.33439 },
        date: new Date(1942, 3, 4),
        description: "Пробито чердачное перекрытие 3 этажа.",
    },
    {
        type: 1,
        address: { street: "Уральская улица", houseNumber: 21 },
        position: { lat: 59.9558361, lng: 30.2543622 },
        date: new Date(1944, 1, 1),
        description: "Пробито чердачное перекрытие 3 этажа.",
    },
    {
        type: 2,
        address: { street: "Уральская улица", houseNumber: 33 },
        position: { lat: 59.9561573, lng: 30.2379996 },
        date: new Date(1944, 5, 0),
        description: "Пробито чердачное перекрытие 3 этажа.",
    },
    {
        type: 0,
        address: { street: "Английская набережная", houseNumber: 24 },
        position: { lat: 59.9343146, lng: 30.2947602 },
        date: new Date(1941, 7, 0),
        description: "Пробито чердачное перекрытие 3 этажа.",
    },
    {
        type: 2,
        address: { street: "Галерная улица", houseNumber: 65 },
        position: { lat: 59.9310888, lng: 30.2864715 },
        date: new Date(1944, 4, 1),
        description: "Пробито чердачное перекрытие 3 этажа.",
    },
    {
        type: 2,
        address: { street: "Российский проспект", houseNumber: 10 },
        position: { lat: 59.9274292, lng: 30.4714915 },
        date: new Date(1945, 0, 4),
        description: "Пробито чердачное перекрытие 3 этажа.",
    },
    {
        type: 1,
        address: { street: "набережная реки Фонтанки", houseNumber: 160 },
        position: { lat: 59.9155326, lng: 30.2777637 },
        date: new Date(1944, 7, 4),
        description: "Пробито чердачное перекрытие 3 этажа.",
    },
    {
        type: 2,
        address: { street: "Большая Морская улица", houseNumber: 15 },
        position: { lat: 59.9349887, lng: 30.3152687 },
        date: new Date(1943, 10, 0),
        description: "Пробито чердачное перекрытие 3 этажа.",
    },
    {
        type: 2,
        address: { street: "площадь Труда", houseNumber: 6 },
        position: { lat: 59.9311518, lng: 30.2939512 },
        date: new Date(1942, 10, 0),
        description: "Пробито чердачное перекрытие 3 этажа.",
    },
    {
        type: 1,
        address: { street: "Лиговский проспект", houseNumber: 166 },
        position: { lat: 59.9115875, lng: 30.3487882 },
        date: new Date(1942, 5, 1),
        description: "Пробито чердачное перекрытие 3 этажа.",
    },
    {
        type: 0,
        address: { street: "Кузнецовская улица", houseNumber: 38 },
        position: { lat: 59.8719795, lng: 30.3253591 },
        date: new Date(1943, 7, 5),
        description: "Пробито чердачное перекрытие 3 этажа.",
    },
    {
        type: 1,
        address: { street: "проспект Художников", houseNumber: 15 },
        position: { lat: 60.0376504, lng: 30.3458653 },
        date: new Date(1944, 0, 4),
        description: "Пробито чердачное перекрытие 3 этажа.",
    },
    {
        type: 1,
        address: { street: "улица Ленина", houseNumber: 8 },
        position: { lat: 59.9596143, lng: 30.3079316 },
        date: new Date(1945, 0, 3),
        description: "Пробито чердачное перекрытие 3 этажа.",
    },
    {
        type: 1,
        address: { street: "Заневский проспект", houseNumber: 36 },
        position: { lat: 59.9338063, lng: 30.4272954 },
        date: new Date(1944, 0, 1),
        description: "Пробито чердачное перекрытие 3 этажа.",
    },
    {
        type: 2,
        address: { street: "Бронницкая улица", houseNumber: 4 },
        position: { lat: 59.9167333, lng: 30.3203895 },
        date: new Date(1942, 5, 1),
        description: "Пробито чердачное перекрытие 3 этажа.",
    },
    {
        type: 0,
        address: { street: "Большая Конюшенная улица", houseNumber: 14 },
        position: { lat: 59.9363118, lng: 30.322702 },
        date: new Date(1942, 8, 3),
        description: "Пробито чердачное перекрытие 3 этажа.",
    },
    {
        type: 0,
        address: { street: "Кондратьевский проспект", houseNumber: 40 },
        position: { lat: 59.968522, lng: 30.3844322 },
        date: new Date(1942, 10, 0),
        description: "Пробито чердачное перекрытие 3 этажа.",
    },
    {
        type: 0,
        address: { street: "Пушкинская улица", houseNumber: 63 },
        position: { lat: 60.0193788, lng: 30.683486 },
        date: new Date(1944, 8, 0),
        description: "Пробито чердачное перекрытие 3 этажа.",
    },
    {
        type: 1,
        address: { street: "Английская набережная", houseNumber: 30 },
        position: { lat: 59.933929, lng: 30.2934893 },
        date: new Date(1941, 9, 0),
        description: "Пробито чердачное перекрытие 3 этажа.",
    },
    {
        type: 2,
        address: { street: "переулок Пирогова", houseNumber: 5 },
        position: { lat: 59.9295903, lng: 30.3058626 },
        date: new Date(1943, 4, 0),
        description: "Пробито чердачное перекрытие 3 этажа.",
    },
    {
        type: 1,
        address: { street: "Московский проспект", houseNumber: 194 },
        position: { lat: 59.863279, lng: 30.3215144 },
        date: new Date(1944, 7, 5),
        description: "Пробито чердачное перекрытие 3 этажа.",
    },
    {
        type: 0,
        address: { street: "улица Степана Разина", houseNumber: 9 },
        position: { lat: 59.9123327, lng: 30.2662164 },
        date: new Date(1942, 3, 2),
        description: "Пробито чердачное перекрытие 3 этажа.",
    },
    {
        type: 1,
        address: { street: "1-я линия В.О.", houseNumber: 58 },
        position: { lat: 59.9471516, lng: 30.2832206 },
        date: new Date(1941, 6, 1),
        description: "Пробито чердачное перекрытие 3 этажа.",
    },
    {
        type: 1,
        address: { street: "Объездное шоссе", houseNumber: 56 },
        position: { lat: 59.9565596, lng: 30.4563576 },
        date: new Date(1943, 6, 3),
        description: "Пробито чердачное перекрытие 3 этажа.",
    },
    {
        type: 1,
        address: { street: "Литейный проспект", houseNumber: 2 },
        position: { lat: 59.9494521, lng: 30.3492341 },
        date: new Date(1945, 0, 3),
        description: "Пробито чердачное перекрытие 3 этажа.",
    },
    {
        type: 1,
        address: { street: "проспект Энгельса", houseNumber: 58 },
        position: { lat: 60.0149338, lng: 30.3226437 },
        date: new Date(1944, 4, 3),
        description: "Пробито чердачное перекрытие 3 этажа.",
    },
    {
        type: 0,
        address: { street: "Свечной переулок", houseNumber: 1 },
        position: { lat: 59.9257497, lng: 30.3466801 },
        date: new Date(1943, 4, 3),
        description: "Пробито чердачное перекрытие 3 этажа.",
    },
    {
        type: 2,
        address: { street: "Гражданский проспект", houseNumber: 119 },
        position: { lat: 60.0341261, lng: 30.4205619 },
        date: new Date(1942, 6, 2),
        description: "Пробито чердачное перекрытие 3 этажа.",
    },
    {
        type: 1,
        address: { street: "Кирочная улица", houseNumber: 40 },
        position: { lat: 59.9440603, lng: 30.3652289 },
        date: new Date(1944, 9, 2),
        description: "Пробито чердачное перекрытие 3 этажа.",
    },
    {
        type: 1,
        address: { street: "набережная реки Мойки", houseNumber: 70 },
        position: { lat: 59.9311851, lng: 30.3080701 },
        date: new Date(1942, 3, 5),
        description: "Пробито чердачное перекрытие 3 этажа.",
    },
    {
        type: 2,
        address: { street: "площадь Островского", houseNumber: 11 },
        position: { lat: 59.9313, lng: 30.3353257 },
        date: new Date(1942, 7, 1),
        description: "Пробито чердачное перекрытие 3 этажа.",
    },
    {
        type: 1,
        address: { street: "улица Кибальчича", houseNumber: 22 },
        position: { lat: 59.8604517, lng: 30.4426217 },
        date: new Date(1943, 11, 3),
        description: "Пробито чердачное перекрытие 3 этажа.",
    },
    {
        type: 2,
        address: { street: "Среднегаванский проспект", houseNumber: 1 },
        position: { lat: 59.9312289, lng: 30.2485647 },
        date: new Date(1943, 0, 3),
        description: "Пробито чердачное перекрытие 3 этажа.",
    },
    {
        type: 0,
        address: { street: "Замшина улица", houseNumber: 17 },
        position: { lat: 59.974144, lng: 30.4016876 },
        date: new Date(1944, 10, 3),
        description: "Пробито чердачное перекрытие 3 этажа.",
    },
    {
        type: 1,
        address: { street: "Железноводская улица", houseNumber: 3 },
        position: { lat: 59.9527744, lng: 30.2574957 },
        date: new Date(1942, 4, 5),
        description: "Пробито чердачное перекрытие 3 этажа.",
    },
    {
        type: 0,
        address: { street: "улица Бабушкина", houseNumber: 9 },
        position: { lat: 59.8968021, lng: 30.4214031 },
        date: new Date(1942, 4, 1),
        description: "Пробито чердачное перекрытие 3 этажа.",
    },
    {
        type: 1,
        address: { street: "Клинский проспект", houseNumber: 11 },
        position: { lat: 59.9156873, lng: 30.3249006 },
        date: new Date(1943, 8, 0),
        description: "Пробито чердачное перекрытие 3 этажа.",
    },
    {
        type: 0,
        address: { street: "улица Шувалова", houseNumber: 5 },
        position: { lat: 60.0528236, lng: 30.4244049 },
        date: new Date(1943, 7, 5),
        description: "Пробито чердачное перекрытие 3 этажа.",
    },
    {
        type: 0,
        address: { street: "улица Седова", houseNumber: 19 },
        position: { lat: 59.8931293, lng: 30.4139785 },
        date: new Date(1942, 10, 4),
        description: "Пробито чердачное перекрытие 3 этажа.",
    },
    {
        type: 2,
        address: { street: "улица Руставели", houseNumber: 13 },
        position: { lat: 60.0014656, lng: 30.4381248 },
        date: new Date(1944, 7, 0),
        description: "Пробито чердачное перекрытие 3 этажа.",
    },
    {
        type: 1,
        address: { street: "улица Комсомола", houseNumber: 1 },
        position: { lat: 59.9567191, lng: 30.3724379 },
        date: new Date(1944, 7, 0),
        description: "Пробито чердачное перекрытие 3 этажа.",
    },
    {
        type: 1,
        address: { street: "Павлоградский переулок", houseNumber: 4 },
        position: { lat: 59.9171403, lng: 30.3537812 },
        date: new Date(1942, 10, 4),
        description: "Пробито чердачное перекрытие 3 этажа.",
    },
    {
        type: 2,
        address: { street: "Невский проспект", houseNumber: 71 },
        position: { lat: 59.9315786, lng: 30.3549641 },
        date: new Date(1943, 11, 4),
        description: "Пробито чердачное перекрытие 3 этажа.",
    },
    {
        type: 2,
        address: { street: "Искровский проспект", houseNumber: 7 },
        position: { lat: 59.9121517, lng: 30.4595274 },
        date: new Date(1944, 10, 1),
        description: "Пробито чердачное перекрытие 3 этажа.",
    },
    {
        type: 0,
        address: { street: "набережная реки Фонтанки", houseNumber: 54 },
        position: { lat: 59.9299221, lng: 30.3403736 },
        date: new Date(1945, 3, 2),
        description: "Пробито чердачное перекрытие 3 этажа.",
    },
    {
        type: 0,
        address: { street: "улица Профессора Попова", houseNumber: 4 },
        position: { lat: 59.9706845, lng: 30.3176226 },
        date: new Date(1945, 1, 5),
        description: "Пробито чердачное перекрытие 3 этажа.",
    },
    {
        type: 1,
        address: { street: "проспект Стачек", houseNumber: 90 },
        position: { lat: 59.867575, lng: 30.2613603 },
        date: new Date(1945, 2, 4),
        description: "Пробито чердачное перекрытие 3 этажа.",
    },
    {
        type: 2,
        address: { street: "улица Савушкина", houseNumber: 85 },
        position: { lat: 59.9866714, lng: 30.2499313 },
        date: new Date(1943, 6, 6),
        description: "Пробито чердачное перекрытие 3 этажа.",
    },
    {
        type: 1,
        address: { street: "Пражская улица", houseNumber: 15 },
        position: { lat: 59.9049179, lng: 30.5201099 },
        date: new Date(1944, 6, 0),
        description: "Пробито чердачное перекрытие 3 этажа.",
    },
    {
        type: 1,
        address: { street: "улица Дыбенко", houseNumber: 16 },
        position: { lat: 59.9045, lng: 30.469615 },
        date: new Date(1942, 2, 6),
        description: "Пробито чердачное перекрытие 3 этажа.",
    },
    {
        type: 2,
        address: { street: "Шпалерная улица", houseNumber: 2 },
        position: { lat: 59.9483046, lng: 30.3428092 },
        date: new Date(1942, 6, 2),
        description: "Пробито чердачное перекрытие 3 этажа.",
    },
    {
        type: 2,
        address: { street: "Малодетскосельский проспект", houseNumber: 3 },
        position: { lat: 59.9145531, lng: 30.3300353 },
        date: new Date(1943, 3, 1),
        description: "Пробито чердачное перекрытие 3 этажа.",
    },
    {
        type: 2,
        address: { street: "набережная реки Фонтанки", houseNumber: 141 },
        position: { lat: 59.9183732, lng: 30.3014772 },
        date: new Date(1941, 6, 5),
        description: "Пробито чердачное перекрытие 3 этажа.",
    },
    {
        type: 0,
        address: { street: "Торговый проспект", houseNumber: 71 },
        position: { lat: 60.0082748, lng: 30.6644672 },
        date: new Date(1941, 7, 3),
        description: "Пробито чердачное перекрытие 3 этажа.",
    },
    {
        type: 0,
        address: { street: "Шведский переулок", houseNumber: 3 },
        position: { lat: 59.9389077, lng: 30.3247755 },
        date: new Date(1944, 2, 6),
        description: "Пробито чердачное перекрытие 3 этажа.",
    },
    {
        type: 1,
        address: { street: "проспект Стачек", houseNumber: 40 },
        position: { lat: 59.8899402, lng: 30.2720549 },
        date: new Date(1942, 10, 6),
        description: "Пробито чердачное перекрытие 3 этажа.",
    },
    {
        type: 0,
        address: { street: "улица Верности", houseNumber: 13 },
        position: { lat: 60.007413, lng: 30.4004026 },
        date: new Date(1943, 4, 6),
        description: "Пробито чердачное перекрытие 3 этажа.",
    },
    {
        type: 1,
        address: { street: "улица Чайковского", houseNumber: 14 },
        position: { lat: 59.9467259, lng: 30.3482618 },
        date: new Date(1945, 5, 2),
        description: "Пробито чердачное перекрытие 3 этажа.",
    },
    {
        type: 0,
        address: { street: "улица Швецова", houseNumber: 41 },
        position: { lat: 59.8973877, lng: 30.2906917 },
        date: new Date(1942, 9, 5),
        description: "Пробито чердачное перекрытие 3 этажа.",
    },
    {
        type: 2,
        address: { street: "Средний проспект В.О.", houseNumber: 100 },
        position: { lat: 59.9316473, lng: 30.2412338 },
        date: new Date(1944, 6, 4),
        description: "Пробито чердачное перекрытие 3 этажа.",
    },
    {
        type: 1,
        address: { street: "Матвеевская улица", houseNumber: 18 },
        position: { lat: 60.0353412, lng: 30.675317 },
        date: new Date(1941, 9, 4),
        description: "Пробито чердачное перекрытие 3 этажа.",
    },
    {
        type: 2,
        address: { street: "Большая Озёрная улица", houseNumber: 40 },
        position: { lat: 60.0343274, lng: 30.310566 },
        date: new Date(1945, 3, 6),
        description: "Пробито чердачное перекрытие 3 этажа.",
    },
    {
        type: 0,
        address: { street: "Лиговский проспект", houseNumber: 153 },
        position: { lat: 59.914782, lng: 30.3497172 },
        date: new Date(1943, 9, 6),
        description: "Пробито чердачное перекрытие 3 этажа.",
    },
    {
        type: 0,
        address: { street: "Невский проспект", houseNumber: 142 },
        position: { lat: 59.929544, lng: 30.3696458 },
        date: new Date(1944, 8, 0),
        description: "Пробито чердачное перекрытие 3 этажа.",
    },
    {
        type: 2,
        address: { street: "Английский проспект", houseNumber: 14 },
        position: { lat: 59.9258591, lng: 30.2831634 },
        date: new Date(1945, 7, 1),
        description: "Пробито чердачное перекрытие 3 этажа.",
    },
    {
        type: 1,
        address: { street: "Октябрьская набережная", houseNumber: 38 },
        position: { lat: 59.9034215, lng: 30.4395331 },
        date: new Date(1942, 0, 1),
        description: "Пробито чердачное перекрытие 3 этажа.",
    },
    {
        type: 1,
        address: { street: "Академический переулок", houseNumber: 6 },
        position: { lat: 59.9370869, lng: 30.287309 },
        date: new Date(1942, 9, 5),
        description: "Пробито чердачное перекрытие 3 этажа.",
    },
    {
        type: 0,
        address: { street: "Тележная улица", houseNumber: 24 },
        position: { lat: 59.9255937, lng: 30.3760862 },
        date: new Date(1942, 6, 5),
        description: "Пробито чердачное перекрытие 3 этажа.",
    },
    {
        type: 1,
        address: { street: "Главная улица", houseNumber: 26 },
        position: { lat: 60.0217476, lng: 30.2942302 },
        date: new Date(1943, 3, 4),
        description: "Пробито чердачное перекрытие 3 этажа.",
    },
    {
        type: 0,
        address: { street: "Румянцевская площадь", houseNumber: 1 },
        position: { lat: 59.9392928, lng: 30.2929048 },
        date: new Date(1943, 6, 1),
        description: "Пробито чердачное перекрытие 3 этажа.",
    },
    {
        type: 1,
        address: { street: "Невский проспект", houseNumber: 150 },
        position: { lat: 59.9286445, lng: 30.3737208 },
        date: new Date(1944, 7, 2),
        description: "Пробито чердачное перекрытие 3 этажа.",
    },
    {
        type: 2,
        address: { street: "Большая Разночинная улица", houseNumber: 24 },
        position: { lat: 59.9605203, lng: 30.2866999 },
        date: new Date(1942, 11, 6),
        description: "Пробито чердачное перекрытие 3 этажа.",
    },
    {
        type: 2,
        address: { street: "Наличная улица", houseNumber: 22 },
        position: { lat: 59.9369559, lng: 30.2332081 },
        date: new Date(1941, 10, 1),
        description: "Пробито чердачное перекрытие 3 этажа.",
    },
    {
        type: 0,
        address: { street: "Полевая Сабировская улица", houseNumber: 49 },
        position: { lat: 59.996521, lng: 30.2718086 },
        date: new Date(1943, 10, 6),
        description: "Пробито чердачное перекрытие 3 этажа.",
    },
    {
        type: 1,
        address: { street: "Владимирский проспект", houseNumber: 18 },
        position: { lat: 59.9291601, lng: 30.3479197 },
        date: new Date(1945, 2, 6),
        description: "Пробито чердачное перекрытие 3 этажа.",
    },
    {
        type: 0,
        address: { street: "улица Репина", houseNumber: 25 },
        position: { lat: 59.9422606, lng: 30.2882629 },
        date: new Date(1945, 0, 1),
        description: "Пробито чердачное перекрытие 3 этажа.",
    },
    {
        type: 2,
        address: { street: "улица Ярослава Гашека", houseNumber: 26 },
        position: { lat: 59.8399711, lng: 30.4161823 },
        date: new Date(1941, 6, 3),
        description: "Пробито чердачное перекрытие 3 этажа.",
    },
    {
        type: 2,
        address: { street: "набережная Кутузова", houseNumber: 4 },
        position: { lat: 59.9494071, lng: 30.3463456 },
        date: new Date(1943, 11, 2),
        description: "Пробито чердачное перекрытие 3 этажа.",
    },
    {
        type: 1,
        address: { street: "Английская набережная", houseNumber: 30 },
        position: { lat: 59.933929, lng: 30.2934893 },
        date: new Date(1942, 8, 0),
        description: "Пробито чердачное перекрытие 3 этажа.",
    },
    {
        type: 1,
        address: { street: "Парфёновская улица", houseNumber: 14 },
        position: { lat: 59.8996753, lng: 30.3127535 },
        date: new Date(1944, 3, 6),
        description: "Пробито чердачное перекрытие 3 этажа.",
    },
    {
        type: 1,
        address: { street: "Пляжевый переулок", houseNumber: 4 },
        position: { lat: 59.9881866, lng: 30.1639638 },
        date: new Date(1942, 3, 5),
        description: "Пробито чердачное перекрытие 3 этажа.",
    },
    {
        type: 0,
        address: { street: "Социалистическая улица", houseNumber: 22 },
        position: { lat: 59.9210619, lng: 30.3455019 },
        date: new Date(1942, 7, 1),
        description: "Пробито чердачное перекрытие 3 этажа.",
    },
    {
        type: 2,
        address: { street: "Красноградский переулок", houseNumber: 5 },
        position: { lat: 59.9263905, lng: 30.3067249 },
        date: new Date(1941, 7, 6),
        description: "Пробито чердачное перекрытие 3 этажа.",
    },
    {
        type: 2,
        address: { street: "улица Якубовича", houseNumber: 5 },
        position: { lat: 59.931704, lng: 30.2959084 },
        date: new Date(1943, 10, 6),
        description: "Пробито чердачное перекрытие 3 этажа.",
    },
    {
        type: 1,
        address: { street: "Новая улица", houseNumber: 15 },
        position: { lat: 59.9939836, lng: 30.1650491 },
        date: new Date(1941, 11, 4),
        description: "Пробито чердачное перекрытие 3 этажа.",
    },
    {
        type: 1,
        address: { street: "набережная канала Грибоедова", houseNumber: 77 },
        position: { lat: 59.9265064, lng: 30.3094474 },
        date: new Date(1943, 8, 4),
        description: "Пробито чердачное перекрытие 3 этажа.",
    },
    {
        type: 1,
        address: { street: "проспект Чернышевского", houseNumber: 15 },
        position: { lat: 59.9455402, lng: 30.3590063 },
        date: new Date(1945, 5, 5),
        description: "Пробито чердачное перекрытие 3 этажа.",
    },
    {
        type: 1,
        address: { street: "улица Радищева", houseNumber: 6 },
        position: { lat: 59.9367201, lng: 30.3622374 },
        date: new Date(1943, 7, 6),
        description: "Пробито чердачное перекрытие 3 этажа.",
    },
    {
        type: 1,
        address: { street: "Среднегаванский проспект", houseNumber: 1 },
        position: { lat: 59.9312289, lng: 30.2485647 },
        date: new Date(1945, 1, 6),
        description: "Пробито чердачное перекрытие 3 этажа.",
    },
    {
        type: 0,
        address: { street: "проспект Строителей", houseNumber: 31 },
        position: { lat: 59.8984463, lng: 30.5228278 },
        date: new Date(1943, 0, 5),
        description: "Пробито чердачное перекрытие 3 этажа.",
    },
    {
        type: 1,
        address: { street: "Захарьевская улица", houseNumber: 22 },
        position: { lat: 59.9478341, lng: 30.3630933 },
        date: new Date(1944, 10, 2),
        description: "Пробито чердачное перекрытие 3 этажа.",
    },
    {
        type: 0,
        address: { street: "площадь Стачек", houseNumber: 9 },
        position: { lat: 59.8997606, lng: 30.2735691 },
        date: new Date(1942, 3, 2),
        description: "Пробито чердачное перекрытие 3 этажа.",
    },
    {
        type: 0,
        address: { street: "проспект Энергетиков", houseNumber: 53 },
        position: { lat: 59.9646696, lng: 30.4442488 },
        date: new Date(1942, 1, 0),
        description: "Пробито чердачное перекрытие 3 этажа.",
    },
    {
        type: 2,
        address: { street: "улица Смолячкова", houseNumber: 10 },
        position: { lat: 59.9707917, lng: 30.3416847 },
        date: new Date(1945, 5, 2),
        description: "Пробито чердачное перекрытие 3 этажа.",
    },
    {
        type: 0,
        address: { street: "Английский проспект", houseNumber: 45 },
        position: { lat: 59.9173474, lng: 30.289897 },
        date: new Date(1943, 4, 0),
        description: "Пробито чердачное перекрытие 3 этажа.",
    },
    {
        type: 1,
        address: { street: "Английская улица", houseNumber: 2 },
        position: { lat: 59.9031845, lng: 30.5200763 },
        date: new Date(1944, 7, 4),
        description: "Пробито чердачное перекрытие 3 этажа.",
    },
    {
        type: 1,
        address: { street: "Пушкинская улица", houseNumber: 5 },
        position: { lat: 59.9304355, lng: 30.3566936 },
        date: new Date(1945, 5, 0),
        description: "Пробито чердачное перекрытие 3 этажа.",
    },
    {
        type: 1,
        address: { street: "набережная реки Фонтанки", houseNumber: 154 },
        position: { lat: 59.9157435, lng: 30.2827944 },
        date: new Date(1943, 2, 6),
        description: "Пробито чердачное перекрытие 3 этажа.",
    },
    {
        type: 1,
        address: { street: "Биржевая линия", houseNumber: 14 },
        position: { lat: 59.9438156, lng: 30.2956703 },
        date: new Date(1941, 7, 6),
        description: "Пробито чердачное перекрытие 3 этажа.",
    },
    {
        type: 1,
        address: { street: "Лермонтовский проспект", houseNumber: 48 },
        position: { lat: 59.9131428, lng: 30.2978427 },
        date: new Date(1941, 10, 4),
        description: "Пробито чердачное перекрытие 3 этажа.",
    },
    {
        type: 1,
        address: { street: "улица Дыбенко", houseNumber: 16 },
        position: { lat: 59.9045, lng: 30.469615 },
        date: new Date(1945, 8, 2),
        description: "Пробито чердачное перекрытие 3 этажа.",
    },
    {
        type: 1,
        address: { street: "улица Академика Шиманского", houseNumber: 11 },
        position: { lat: 59.9883284, lng: 30.2866701 },
        date: new Date(1941, 9, 2),
        description: "Пробито чердачное перекрытие 3 этажа.",
    },
    {
        type: 0,
        address: { street: "проспект Елизарова", houseNumber: 41 },
        position: { lat: 59.8931468, lng: 30.4063244 },
        date: new Date(1945, 4, 1),
        description: "Пробито чердачное перекрытие 3 этажа.",
    },
    {
        type: 1,
        address: { street: "Огородный переулок", houseNumber: 1 },
        position: { lat: 59.8868436, lng: 30.2690772 },
        date: new Date(1944, 0, 2),
        description: "Пробито чердачное перекрытие 3 этажа.",
    },
    {
        type: 0,
        address: { street: "Менделеевская улица", houseNumber: 2 },
        position: { lat: 59.9731849, lng: 30.3515772 },
        date: new Date(1941, 7, 1),
        description: "Пробито чердачное перекрытие 3 этажа.",
    },
    {
        type: 2,
        address: { street: "Опочинина улица", houseNumber: 4 },
        position: { lat: 59.9301756, lng: 30.2390145 },
        date: new Date(1945, 4, 3),
        description: "Пробито чердачное перекрытие 3 этажа.",
    },
    {
        type: 1,
        address: { street: "Кирочная улица", houseNumber: 2 },
        position: { lat: 59.9441452, lng: 30.349542 },
        date: new Date(1944, 1, 0),
        description: "Пробито чердачное перекрытие 3 этажа.",
    },
    {
        type: 0,
        address: { street: "набережная Крюкова канала", houseNumber: 4 },
        position: { lat: 59.9276985, lng: 30.2942912 },
        date: new Date(1943, 4, 6),
        description: "Пробито чердачное перекрытие 3 этажа.",
    },
    {
        type: 0,
        address: { street: "Невский проспект", houseNumber: 142 },
        position: { lat: 59.929544, lng: 30.3696458 },
        date: new Date(1941, 6, 6),
        description: "Пробито чердачное перекрытие 3 этажа.",
    },
    {
        type: 0,
        address: { street: "Колхозная улица", houseNumber: 1 },
        position: { lat: 59.9229383, lng: 30.6273219 },
        date: new Date(1942, 4, 5),
        description: "Пробито чердачное перекрытие 3 этажа.",
    },
    {
        type: 1,
        address: { street: "Менделеевская улица", houseNumber: 6 },
        position: { lat: 59.9768516, lng: 30.3601868 },
        date: new Date(1944, 1, 3),
        description: "Пробито чердачное перекрытие 3 этажа.",
    },
    {
        type: 2,
        address: { street: "Шпалерная улица", houseNumber: 19 },
        position: { lat: 59.9489625, lng: 30.3483821 },
        date: new Date(1942, 9, 2),
        description: "Пробито чердачное перекрытие 3 этажа.",
    },
    {
        type: 1,
        address: { street: "Новоколомяжский проспект", houseNumber: 11 },
        position: { lat: 60.0288712, lng: 30.2942367 },
        date: new Date(1941, 11, 6),
        description: "Пробито чердачное перекрытие 3 этажа.",
    },
    {
        type: 1,
        address: { street: "улица Репина", houseNumber: 8 },
        position: { lat: 59.9398184, lng: 30.2908566 },
        date: new Date(1942, 4, 6),
        description: "Пробито чердачное перекрытие 3 этажа.",
    },
    {
        type: 1,
        address: { street: "площадь Александра Невского", houseNumber: 191167 },
        position: { lat: 59.9245051, lng: 30.3859651 },
        date: new Date(1944, 6, 3),
        description: "Пробито чердачное перекрытие 3 этажа.",
    },
    {
        type: 1,
        address: { street: "8-я линия В.О.", houseNumber: 55 },
        position: { lat: 59.9436981, lng: 30.2748841 },
        date: new Date(1943, 8, 4),
        description: "Пробито чердачное перекрытие 3 этажа.",
    },
    {
        type: 1,
        address: { street: "Большой проспект В.О.", houseNumber: 29 },
        position: { lat: 59.9390755, lng: 30.2811088 },
        date: new Date(1944, 5, 3),
        description: "Пробито чердачное перекрытие 3 этажа.",
    },
    {
        type: 1,
        address: { street: "Дибуновская улица", houseNumber: 65 },
        position: { lat: 59.9854013, lng: 30.258952 },
        date: new Date(1942, 6, 3),
        description: "Пробито чердачное перекрытие 3 этажа.",
    },
    {
        type: 1,
        address: { street: "Исполкомская улица", houseNumber: 1 },
        position: { lat: 59.9261763, lng: 30.3789092 },
        date: new Date(1941, 9, 6),
        description: "Пробито чердачное перекрытие 3 этажа.",
    },
    {
        type: 1,
        address: { street: "Столярный переулок", houseNumber: 13 },
        position: { lat: 59.9266512, lng: 30.3124784 },
        date: new Date(1943, 6, 6),
        description: "Пробито чердачное перекрытие 3 этажа.",
    },
    {
        type: 1,
        address: { street: "улица Рылеева", houseNumber: 13 },
        position: { lat: 59.9424307, lng: 30.3543435 },
        date: new Date(1945, 5, 3),
        description: "Пробито чердачное перекрытие 3 этажа.",
    },
    {
        type: 1,
        address: { street: "набережная реки Фонтанки", houseNumber: 142 },
        position: { lat: 59.9157442, lng: 30.2951635 },
        date: new Date(1944, 0, 6),
        description: "Пробито чердачное перекрытие 3 этажа.",
    },
    {
        type: 2,
        address: { street: "Волоколамский переулок", houseNumber: 3 },
        position: { lat: 59.9201744, lng: 30.3497487 },
        date: new Date(1943, 5, 4),
        description: "Пробито чердачное перекрытие 3 этажа.",
    },
    {
        type: 1,
        address: { street: "Наличная улица", houseNumber: 15 },
        position: { lat: 59.9325125, lng: 30.2365867 },
        date: new Date(1943, 3, 0),
        description: "Пробито чердачное перекрытие 3 этажа.",
    },
    {
        type: 2,
        address: { street: "Бухарестская улица", houseNumber: 72 },
        position: { lat: 59.8721827, lng: 30.3798501 },
        date: new Date(1944, 8, 6),
        description: "Пробито чердачное перекрытие 3 этажа.",
    },
    {
        type: 0,
        address: { street: "Невский проспект", houseNumber: 25 },
        position: { lat: 59.9356126, lng: 30.3229998 },
        date: new Date(1943, 1, 0),
        description: "Пробито чердачное перекрытие 3 этажа.",
    },
    {
        type: 2,
        address: { street: "площадь Ленина", houseNumber: 3 },
        position: { lat: 59.9540138, lng: 30.3569448 },
        date: new Date(1942, 3, 2),
        description: "Пробито чердачное перекрытие 3 этажа.",
    },
    {
        type: 1,
        address: { street: "Новочеркасский проспект", houseNumber: 14 },
        position: { lat: 59.93494, lng: 30.4080817 },
        date: new Date(1943, 11, 6),
        description: "Пробито чердачное перекрытие 3 этажа.",
    },
    {
        type: 1,
        address: { street: "Английская набережная", houseNumber: 58 },
        position: { lat: 59.9321133, lng: 30.2863986 },
        date: new Date(1942, 4, 0),
        description: "Пробито чердачное перекрытие 3 этажа.",
    },
    {
        type: 1,
        address: { street: "улица Льва Толстого", houseNumber: 19 },
        position: { lat: 59.9643646, lng: 30.3215502 },
        date: new Date(1944, 9, 6),
        description: "Пробито чердачное перекрытие 3 этажа.",
    },
    {
        type: 1,
        address: { street: "Малый проспект В.О.", houseNumber: 11 },
        position: { lat: 59.9479381, lng: 30.2767548 },
        date: new Date(1943, 4, 6),
        description: "Пробито чердачное перекрытие 3 этажа.",
    },
    {
        type: 1,
        address: { street: "проспект Просвещения", houseNumber: 85 },
        position: { lat: 60.0370797, lng: 30.4094857 },
        date: new Date(1942, 2, 4),
        description: "Пробито чердачное перекрытие 3 этажа.",
    },
    {
        type: 1,
        address: { street: "улица Шевченко", houseNumber: 16 },
        position: { lat: 59.9315688, lng: 30.2450662 },
        date: new Date(1942, 7, 1),
        description: "Пробито чердачное перекрытие 3 этажа.",
    },
    {
        type: 0,
        address: { street: "Харьковская улица", houseNumber: 4 },
        position: { lat: 59.9272898, lng: 30.3722627 },
        date: new Date(1942, 10, 3),
        description: "Пробито чердачное перекрытие 3 этажа.",
    },
    {
        type: 1,
        address: { street: "набережная канала Грибоедова", houseNumber: 16 },
        position: { lat: 59.9357891, lng: 30.3269839 },
        date: new Date(1944, 0, 6),
        description: "Пробито чердачное перекрытие 3 этажа.",
    },
    {
        type: 1,
        address: { street: "улица Восстания", houseNumber: 40 },
        position: { lat: 59.9430281, lng: 30.3601097 },
        date: new Date(1943, 8, 3),
        description: "Пробито чердачное перекрытие 3 этажа.",
    },
    {
        type: 2,
        address: { street: "Лиговский проспект", houseNumber: 65 },
        position: { lat: 59.9273333, lng: 30.3576853 },
        date: new Date(1945, 2, 4),
        description: "Пробито чердачное перекрытие 3 этажа.",
    },
    {
        type: 1,
        address: { street: "улица Александра Невского", houseNumber: 2 },
        position: { lat: 59.9245872, lng: 30.386116 },
        date: new Date(1944, 7, 5),
        description: "Пробито чердачное перекрытие 3 этажа.",
    },
    {
        type: 1,
        address: { street: "Московский проспект", houseNumber: 216 },
        position: { lat: 59.8490975, lng: 30.3226745 },
        date: new Date(1943, 7, 3),
        description: "Пробито чердачное перекрытие 3 этажа.",
    },
    {
        type: 0,
        address: { street: "Казанская улица", houseNumber: 5 },
        position: { lat: 59.9332766, lng: 30.3222658 },
        date: new Date(1942, 1, 4),
        description: "Пробито чердачное перекрытие 3 этажа.",
    },
    {
        type: 1,
        address: { street: "улица Барона Корфа", houseNumber: 33 },
        position: { lat: 60.0315836, lng: 30.6706992 },
        date: new Date(1943, 3, 5),
        description: "Пробито чердачное перекрытие 3 этажа.",
    },
    {
        type: 1,
        address: { street: "проспект Стачек", houseNumber: 57 },
        position: { lat: 59.8758672, lng: 30.2565364 },
        date: new Date(1944, 0, 5),
        description: "Пробито чердачное перекрытие 3 этажа.",
    },
    {
        type: 1,
        address: { street: "Замшина улица", houseNumber: 28 },
        position: { lat: 59.973565, lng: 30.3988348 },
        date: new Date(1943, 3, 2),
        description: "Пробито чердачное перекрытие 3 этажа.",
    },
    {
        type: 2,
        address: { street: "улица Комсомола", houseNumber: 33 },
        position: { lat: 59.9548289, lng: 30.3591859 },
        date: new Date(1942, 6, 1),
        description: "Пробито чердачное перекрытие 3 этажа.",
    },
    {
        type: 0,
        address: { street: "Мичуринская улица", houseNumber: 6 },
        position: { lat: 59.9547918, lng: 30.3285322 },
        date: new Date(1945, 4, 4),
        description: "Пробито чердачное перекрытие 3 этажа.",
    },
    {
        type: 2,
        address: { street: "Среднегаванский проспект", houseNumber: 1 },
        position: { lat: 59.9312289, lng: 30.2485647 },
        date: new Date(1945, 2, 6),
        description: "Пробито чердачное перекрытие 3 этажа.",
    },
    {
        type: 2,
        address: { street: "улица Губина", houseNumber: 17 },
        position: { lat: 59.893979, lng: 30.263569 },
        date: new Date(1941, 7, 4),
        description: "Пробито чердачное перекрытие 3 этажа.",
    },
    {
        type: 0,
        address: { street: "Большая Конюшенная улица", houseNumber: 29 },
        position: { lat: 59.9368126, lng: 30.3222756 },
        date: new Date(1943, 7, 5),
        description: "Пробито чердачное перекрытие 3 этажа.",
    },
    {
        type: 1,
        address: { street: "Черноморский переулок", houseNumber: 9 },
        position: { lat: 59.9377983, lng: 30.3064381 },
        date: new Date(1943, 5, 3),
        description: "Пробито чердачное перекрытие 3 этажа.",
    },
    {
        type: 2,
        address: { street: "улица Барона Корфа", houseNumber: 15 },
        position: { lat: 60.0335049, lng: 30.6695643 },
        date: new Date(1942, 11, 4),
        description: "Пробито чердачное перекрытие 3 этажа.",
    },
    {
        type: 1,
        address: { street: "Миллионная улица", houseNumber: 16 },
        position: { lat: 59.942904, lng: 30.322785 },
        date: new Date(1945, 6, 5),
        description: "Пробито чердачное перекрытие 3 этажа.",
    },
    {
        type: 1,
        address: { street: "Карташихина улица", houseNumber: 10 },
        position: { lat: 59.9323288, lng: 30.2412965 },
        date: new Date(1943, 3, 6),
        description: "Пробито чердачное перекрытие 3 этажа.",
    },
    {
        type: 0,
        address: { street: "проспект Испытателей", houseNumber: 10 },
        position: { lat: 60.0037423, lng: 30.2874246 },
        date: new Date(1943, 3, 4),
        description: "Пробито чердачное перекрытие 3 этажа.",
    },
    {
        type: 1,
        address: { street: "Английская набережная", houseNumber: 54 },
        position: { lat: 59.9323295, lng: 30.2873102 },
        date: new Date(1942, 11, 1),
        description: "Пробито чердачное перекрытие 3 этажа.",
    },
    {
        type: 1,
        address: { street: "улица Бутлерова", houseNumber: 40 },
        position: { lat: 60.0108878, lng: 30.4050634 },
        date: new Date(1941, 10, 5),
        description: "Пробито чердачное перекрытие 3 этажа.",
    },
    {
        type: 1,
        address: { street: "улица Гастелло", houseNumber: 11 },
        position: { lat: 59.8573457, lng: 30.3256016 },
        date: new Date(1944, 9, 1),
        description: "Пробито чердачное перекрытие 3 этажа.",
    },
    {
        type: 2,
        address: { street: "Политехническая улица", houseNumber: 9 },
        position: { lat: 59.9923895, lng: 30.3566593 },
        date: new Date(1942, 2, 0),
        description: "Пробито чердачное перекрытие 3 этажа.",
    },
    {
        type: 0,
        address: { street: "Садовая улица", houseNumber: 16 },
        position: { lat: 59.9338554, lng: 30.3349458 },
        date: new Date(1942, 1, 3),
        description: "Пробито чердачное перекрытие 3 этажа.",
    },
    {
        type: 1,
        address: { street: "Пражская улица", houseNumber: 48 },
        position: { lat: 59.8631817, lng: 30.4043269 },
        date: new Date(1943, 6, 3),
        description: "Пробито чердачное перекрытие 3 этажа.",
    },
    {
        type: 2,
        address: { street: "Сортировочная-Московская улица", houseNumber: 17 },
        position: { lat: 59.8668388, lng: 30.4291973 },
        date: new Date(1942, 6, 3),
        description: "Пробито чердачное перекрытие 3 этажа.",
    },
    {
        type: 1,
        address: { street: "Кирпичный переулок", houseNumber: 2 },
        position: { lat: 59.9359562, lng: 30.315584 },
        date: new Date(1942, 3, 4),
        description: "Пробито чердачное перекрытие 3 этажа.",
    },
    {
        type: 2,
        address: { street: "Матвеевская улица", houseNumber: 16 },
        position: { lat: 60.0353276, lng: 30.6744913 },
        date: new Date(1943, 10, 5),
        description: "Пробито чердачное перекрытие 3 этажа.",
    },
    {
        type: 0,
        address: { street: "Черноморский переулок", houseNumber: 9 },
        position: { lat: 59.9377983, lng: 30.3064381 },
        date: new Date(1944, 4, 2),
        description: "Пробито чердачное перекрытие 3 этажа.",
    },
    {
        type: 1,
        address: { street: "Апраксин переулок", houseNumber: 11 },
        position: { lat: 59.9277056, lng: 30.3263348 },
        date: new Date(1945, 7, 5),
        description: "Пробито чердачное перекрытие 3 этажа.",
    },
    {
        type: 1,
        address: { street: "Большой проспект П.С.", houseNumber: 18 },
        position: { lat: 59.9553613, lng: 30.2948227 },
        date: new Date(1943, 7, 2),
        description: "Пробито чердачное перекрытие 3 этажа.",
    },
    {
        type: 1,
        address: { street: "площадь Стачек", houseNumber: 5 },
        position: { lat: 59.9014281, lng: 30.2723081 },
        date: new Date(1944, 0, 5),
        description: "Пробито чердачное перекрытие 3 этажа.",
    },
    {
        type: 0,
        address: { street: "улица Косинова", houseNumber: 18 },
        position: { lat: 59.8952997, lng: 30.2728235 },
        date: new Date(1942, 8, 1),
        description: "Пробито чердачное перекрытие 3 этажа.",
    },
    {
        type: 2,
        address: { street: "Серебристый бульвар", houseNumber: 21 },
        position: { lat: 60.0071249, lng: 30.2830869 },
        date: new Date(1942, 6, 3),
        description: "Пробито чердачное перекрытие 3 этажа.",
    },
    {
        type: 1,
        address: { street: "Московский проспект", houseNumber: 111 },
        position: { lat: 59.8890606, lng: 30.3188488 },
        date: new Date(1941, 11, 2),
        description: "Пробито чердачное перекрытие 3 этажа.",
    },
    {
        type: 1,
        address: { street: "переулок Гривцова", houseNumber: 2 },
        position: { lat: 59.9317549, lng: 30.3126618 },
        date: new Date(1944, 10, 4),
        description: "Пробито чердачное перекрытие 3 этажа.",
    },
    {
        type: 1,
        address: { street: "улица Адмирала Трибуца", houseNumber: 7 },
        position: { lat: 59.8517508, lng: 30.1450035 },
        date: new Date(1943, 1, 6),
        description: "Пробито чердачное перекрытие 3 этажа.",
    },
    {
        type: 1,
        address: { street: "Богатырский проспект", houseNumber: 42 },
        position: { lat: 60.0034443, lng: 30.2281019 },
        date: new Date(1945, 2, 6),
        description: "Пробито чердачное перекрытие 3 этажа.",
    },
    {
        type: 0,
        address: { street: "улица Льва Толстого", houseNumber: 19 },
        position: { lat: 59.9643646, lng: 30.3215502 },
        date: new Date(1943, 11, 2),
        description: "Пробито чердачное перекрытие 3 этажа.",
    },
    {
        type: 2,
        address: { street: "набережная канала Грибоедова", houseNumber: 57 },
        position: { lat: 59.9285422, lng: 30.3147592 },
        date: new Date(1943, 4, 0),
        description: "Пробито чердачное перекрытие 3 этажа.",
    },
    {
        type: 1,
        address: { street: "улица Куйбышева", houseNumber: 32 },
        position: { lat: 59.9572158, lng: 30.3318964 },
        date: new Date(1942, 1, 0),
        description: "Пробито чердачное перекрытие 3 этажа.",
    },
    {
        type: 1,
        address: { street: "улица Зодчего Росси", houseNumber: 3 },
        position: { lat: 59.9293503, lng: 30.3349169 },
        date: new Date(1944, 6, 6),
        description: "Пробито чердачное перекрытие 3 этажа.",
    },
    {
        type: 2,
        address: { street: "Моховая улица", houseNumber: 37 },
        position: { lat: 59.9403504, lng: 30.3445418 },
        date: new Date(1945, 5, 4),
        description: "Пробито чердачное перекрытие 3 этажа.",
    },
    {
        type: 1,
        address: { street: "Казанская улица", houseNumber: 11 },
        position: { lat: 59.9313727, lng: 30.31989 },
        date: new Date(1943, 9, 0),
        description: "Пробито чердачное перекрытие 3 этажа.",
    },
    {
        type: 1,
        address: { street: "улица Профессора Попова", houseNumber: 2 },
        position: { lat: 59.9711806, lng: 30.3229412 },
        date: new Date(1943, 2, 4),
        description: "Пробито чердачное перекрытие 3 этажа.",
    },
    {
        type: 1,
        address: { street: "Социалистическая улица", houseNumber: 101 },
        position: { lat: 60.0181214, lng: 30.6475286 },
        date: new Date(1945, 3, 5),
        description: "Пробито чердачное перекрытие 3 этажа.",
    },
    {
        type: 1,
        address: { street: "Краснодонская улица", houseNumber: 4 },
        position: { lat: 59.9557185, lng: 30.4133667 },
        date: new Date(1942, 7, 1),
        description: "Пробито чердачное перекрытие 3 этажа.",
    },
    {
        type: 1,
        address: { street: "улица Ушинского", houseNumber: 5 },
        position: { lat: 60.0286764, lng: 30.4055621 },
        date: new Date(1943, 5, 0),
        description: "Пробито чердачное перекрытие 3 этажа.",
    },
    {
        type: 0,
        address: { street: "улица Васенко", houseNumber: 3 },
        position: { lat: 59.9706002, lng: 30.3897471 },
        date: new Date(1943, 6, 5),
        description: "Пробито чердачное перекрытие 3 этажа.",
    },
    {
        type: 2,
        address: { street: "Большая Конюшенная улица", houseNumber: 14 },
        position: { lat: 59.9363118, lng: 30.322702 },
        date: new Date(1944, 4, 3),
        description: "Пробито чердачное перекрытие 3 этажа.",
    },
    {
        type: 1,
        address: { street: "Софийская улица", houseNumber: 5 },
        position: { lat: 60.0481906, lng: 30.3036026 },
        date: new Date(1943, 5, 2),
        description: "Пробито чердачное перекрытие 3 этажа.",
    },
    {
        type: 1,
        address: { street: "Разъезжая улица", houseNumber: 27 },
        position: { lat: 59.9230386, lng: 30.3497716 },
        date: new Date(1944, 11, 5),
        description: "Пробито чердачное перекрытие 3 этажа.",
    },
    {
        type: 1,
        address: { street: "Малая Посадская улица", houseNumber: 10 },
        position: { lat: 59.9576973, lng: 30.3223839 },
        date: new Date(1945, 5, 3),
        description: "Пробито чердачное перекрытие 3 этажа.",
    },
    {
        type: 0,
        address: { street: "Московский проспект", houseNumber: 192 },
        position: { lat: 59.8642681, lng: 30.3212906 },
        date: new Date(1943, 4, 0),
        description: "Пробито чердачное перекрытие 3 этажа.",
    },
    {
        type: 1,
        address: { street: "проспект Большевиков", houseNumber: 25 },
        position: { lat: 59.9039072, lng: 30.4838774 },
        date: new Date(1942, 8, 3),
        description: "Пробито чердачное перекрытие 3 этажа.",
    },
    {
        type: 0,
        address: { street: "Кондратьевский проспект", houseNumber: 49 },
        position: { lat: 59.9725013, lng: 30.3889132 },
        date: new Date(1944, 1, 2),
        description: "Пробито чердачное перекрытие 3 этажа.",
    },
    {
        type: 2,
        address: { street: "улица Нахимова", houseNumber: 15 },
        position: { lat: 59.9413686, lng: 30.2178837 },
        date: new Date(1944, 0, 3),
        description: "Пробито чердачное перекрытие 3 этажа.",
    },
    {
        type: 1,
        address: { street: "проспект Стачек", houseNumber: 40 },
        position: { lat: 59.8899402, lng: 30.2720549 },
        date: new Date(1945, 0, 5),
        description: "Пробито чердачное перекрытие 3 этажа.",
    },
    {
        type: 1,
        address: { street: "Малый проспект В.О.", houseNumber: 84 },
        position: { lat: 59.9373972, lng: 30.2354793 },
        date: new Date(1943, 8, 2),
        description: "Пробито чердачное перекрытие 3 этажа.",
    },
    {
        type: 1,
        address: { street: "Серпуховская улица", houseNumber: 19 },
        position: { lat: 59.9153579, lng: 30.3230217 },
        date: new Date(1944, 0, 5),
        description: "Пробито чердачное перекрытие 3 этажа.",
    },
    {
        type: 1,
        address: { street: "Ленинский проспект", houseNumber: 137 },
        position: { lat: 59.8514192, lng: 30.2766608 },
        date: new Date(1944, 0, 0),
        description: "Пробито чердачное перекрытие 3 этажа.",
    },
    {
        type: 2,
        address: { street: "Конногвардейский переулок", houseNumber: 2 },
        position: { lat: 59.9318351, lng: 30.2962844 },
        date: new Date(1943, 10, 5),
        description: "Пробито чердачное перекрытие 3 этажа.",
    },
    {
        type: 2,
        address: { street: "улица Профессора Попова", houseNumber: 37 },
        position: { lat: 59.9714306, lng: 30.2985799 },
        date: new Date(1943, 2, 2),
        description: "Пробито чердачное перекрытие 3 этажа.",
    },
    {
        type: 2,
        address: { street: "улица Ленина", houseNumber: 8 },
        position: { lat: 59.9596143, lng: 30.3079316 },
        date: new Date(1945, 1, 0),
        description: "Пробито чердачное перекрытие 3 этажа.",
    },
    {
        type: 1,
        address: { street: "Клинский проспект", houseNumber: 15 },
        position: { lat: 59.9153104, lng: 30.3235888 },
        date: new Date(1943, 2, 0),
        description: "Пробито чердачное перекрытие 3 этажа.",
    },
    {
        type: 1,
        address: { street: "Гаванская улица", houseNumber: 17 },
        position: { lat: 59.9305975, lng: 30.2411029 },
        date: new Date(1942, 9, 4),
        description: "Пробито чердачное перекрытие 3 этажа.",
    },
    {
        type: 1,
        address: { street: "улица Чапаева", houseNumber: 17 },
        position: { lat: 59.9623707, lng: 30.3328612 },
        date: new Date(1945, 0, 3),
        description: "Пробито чердачное перекрытие 3 этажа.",
    },
    {
        type: 0,
        address: { street: "Матвеевская улица", houseNumber: 16 },
        position: { lat: 60.0353276, lng: 30.6744913 },
        date: new Date(1944, 1, 1),
        description: "Пробито чердачное перекрытие 3 этажа.",
    },
    {
        type: 2,
        address: { street: "проспект Стачек", houseNumber: 14 },
        position: { lat: 59.8975735, lng: 30.2771772 },
        date: new Date(1943, 9, 1),
        description: "Пробито чердачное перекрытие 3 этажа.",
    },
    {
        type: 1,
        address: { street: "Индустриальный проспект", houseNumber: 12 },
        position: { lat: 59.940583, lng: 30.475603 },
        date: new Date(1942, 7, 0),
        description: "Пробито чердачное перекрытие 3 этажа.",
    },
    {
        type: 0,
        address: { street: "набережная реки Карповки", houseNumber: 6 },
        position: { lat: 59.9676269, lng: 30.3145035 },
        date: new Date(1941, 9, 0),
        description: "Пробито чердачное перекрытие 3 этажа.",
    },
    {
        type: 1,
        address: { street: "Разъезжая улица", houseNumber: 13 },
        position: { lat: 59.9248418, lng: 30.3452903 },
        date: new Date(1943, 1, 4),
        description: "Пробито чердачное перекрытие 3 этажа.",
    },
    {
        type: 2,
        address: { street: "Полевая Сабировская улица", houseNumber: 54 },
        position: { lat: 59.9972967, lng: 30.2688847 },
        date: new Date(1943, 5, 6),
        description: "Пробито чердачное перекрытие 3 этажа.",
    },
    {
        type: 1,
        address: { street: "улица Некрасова", houseNumber: 11 },
        position: { lat: 59.9388167, lng: 30.3535878 },
        date: new Date(1945, 6, 3),
        description: "Пробито чердачное перекрытие 3 этажа.",
    },
    {
        type: 0,
        address: { street: "Москательный переулок", houseNumber: 1 },
        position: { lat: 59.9307232, lng: 30.3222723 },
        date: new Date(1945, 5, 0),
        description: "Пробито чердачное перекрытие 3 этажа.",
    },
    {
        type: 0,
        address: { street: "Столярный переулок", houseNumber: 8 },
        position: { lat: 59.927833, lng: 30.3114297 },
        date: new Date(1942, 3, 2),
        description: "Пробито чердачное перекрытие 3 этажа.",
    },
    {
        type: 2,
        address: { street: "Вёсельная улица", houseNumber: 2 },
        position: { lat: 59.928357, lng: 30.2449232 },
        date: new Date(1944, 3, 6),
        description: "Пробито чердачное перекрытие 3 этажа.",
    },
    {
        type: 0,
        address: { street: "Коломенская улица", houseNumber: 29 },
        position: { lat: 59.9229177, lng: 30.352757 },
        date: new Date(1941, 11, 0),
        description: "Пробито чердачное перекрытие 3 этажа.",
    },
    {
        type: 0,
        address: { street: "переулок Декабристов", houseNumber: 14 },
        position: { lat: 59.9525537, lng: 30.2484492 },
        date: new Date(1945, 7, 2),
        description: "Пробито чердачное перекрытие 3 этажа.",
    },
    {
        type: 1,
        address: { street: "Галерная улица", houseNumber: 45 },
        position: { lat: 59.9321331, lng: 30.2901713 },
        date: new Date(1943, 1, 3),
        description: "Пробито чердачное перекрытие 3 этажа.",
    },
    {
        type: 1,
        address: { street: "улица Пестеля", houseNumber: 11 },
        position: { lat: 59.9420569, lng: 30.3421625 },
        date: new Date(1942, 4, 6),
        description: "Пробито чердачное перекрытие 3 этажа.",
    },
    {
        type: 1,
        address: { street: "Большая Морская улица", houseNumber: 15 },
        position: { lat: 59.9349887, lng: 30.3152687 },
        date: new Date(1943, 7, 3),
        description: "Пробито чердачное перекрытие 3 этажа.",
    },
    {
        type: 1,
        address: { street: "улица Ушинского", houseNumber: 22 },
        position: { lat: 60.0447195, lng: 30.4162625 },
        date: new Date(1944, 6, 3),
        description: "Пробито чердачное перекрытие 3 этажа.",
    },
    {
        type: 1,
        address: { street: "улица Тельмана", houseNumber: 31 },
        position: { lat: 59.891485, lng: 30.4759862 },
        date: new Date(1941, 9, 5),
        description: "Пробито чердачное перекрытие 3 этажа.",
    },
    {
        type: 0,
        address: { street: "Севастопольская улица", houseNumber: 39 },
        position: { lat: 59.890045, lng: 30.265377 },
        date: new Date(1941, 11, 3),
        description: "Пробито чердачное перекрытие 3 этажа.",
    },
    {
        type: 1,
        address: { street: "Конногвардейский переулок", houseNumber: 4 },
        position: { lat: 59.9316874, lng: 30.29644 },
        date: new Date(1943, 3, 6),
        description: "Пробито чердачное перекрытие 3 этажа.",
    },
    {
        type: 2,
        address: { street: "Фонарный переулок", houseNumber: 8 },
        position: { lat: 59.928726, lng: 30.3051147 },
        date: new Date(1943, 9, 6),
        description: "Пробито чердачное перекрытие 3 этажа.",
    },
    {
        type: 0,
        address: { street: "Малодетскосельский проспект", houseNumber: 8 },
        position: { lat: 59.9137836, lng: 30.3285085 },
        date: new Date(1941, 9, 4),
        description: "Пробито чердачное перекрытие 3 этажа.",
    },
    {
        type: 0,
        address: { street: "улица Союза Печатников", houseNumber: 2 },
        position: { lat: 59.9243573, lng: 30.2953142 },
        date: new Date(1944, 10, 5),
        description: "Пробито чердачное перекрытие 3 этажа.",
    },
    {
        type: 2,
        address: { street: "улица Ушинского", houseNumber: 6 },
        position: { lat: 60.0309477, lng: 30.4042052 },
        date: new Date(1945, 2, 4),
        description: "Пробито чердачное перекрытие 3 этажа.",
    },
    {
        type: 1,
        address: { street: "Московский проспект", houseNumber: 75 },
        position: { lat: 59.903127, lng: 30.3181471 },
        date: new Date(1943, 4, 1),
        description: "Пробито чердачное перекрытие 3 этажа.",
    },
    {
        type: 2,
        address: { street: "Шпалерная улица", houseNumber: 1 },
        position: { lat: 59.9481276, lng: 30.3428806 },
        date: new Date(1944, 7, 0),
        description: "Пробито чердачное перекрытие 3 этажа.",
    },
    {
        type: 2,
        address: { street: "Державинский переулок", houseNumber: 3 },
        position: { lat: 59.9171695, lng: 30.3129805 },
        date: new Date(1941, 11, 2),
        description: "Пробито чердачное перекрытие 3 этажа.",
    },
    {
        type: 2,
        address: { street: "Лахтинский проспект", houseNumber: 85 },
        position: { lat: 59.9946866, lng: 30.1470988 },
        date: new Date(1942, 9, 6),
        description: "Пробито чердачное перекрытие 3 этажа.",
    },
    {
        type: 1,
        address: { street: "набережная реки Фонтанки", houseNumber: 195 },
        position: { lat: 59.9166908, lng: 30.2847838 },
        date: new Date(1945, 7, 3),
        description: "Пробито чердачное перекрытие 3 этажа.",
    },
    {
        type: 2,
        address: { street: "набережная реки Фонтанки", houseNumber: 142 },
        position: { lat: 59.9157442, lng: 30.2951635 },
        date: new Date(1942, 8, 3),
        description: "Пробито чердачное перекрытие 3 этажа.",
    },
    {
        type: 0,
        address: { street: "Невский проспект", houseNumber: 25 },
        position: { lat: 59.9356126, lng: 30.3229998 },
        date: new Date(1944, 10, 1),
        description: "Пробито чердачное перекрытие 3 этажа.",
    },
    {
        type: 1,
        address: { street: "Заневский проспект", houseNumber: 20 },
        position: { lat: 59.9298642, lng: 30.4150914 },
        date: new Date(1942, 6, 1),
        description: "Пробито чердачное перекрытие 3 этажа.",
    },
    {
        type: 1,
        address: { street: "Ковенский переулок", houseNumber: 1 },
        position: { lat: 59.9368022, lng: 30.3555536 },
        date: new Date(1944, 3, 1),
        description: "Пробито чердачное перекрытие 3 этажа.",
    },
    {
        type: 1,
        address: { street: "улица Гастелло", houseNumber: 22 },
        position: { lat: 59.8584184, lng: 30.3274593 },
        date: new Date(1943, 7, 2),
        description: "Пробито чердачное перекрытие 3 этажа.",
    },
    {
        type: 1,
        address: { street: "улица Адмирала Трибуца", houseNumber: 7 },
        position: { lat: 59.8517508, lng: 30.1450035 },
        date: new Date(1942, 7, 0),
        description: "Пробито чердачное перекрытие 3 этажа.",
    },
    {
        type: 1,
        address: { street: "Разъезжая улица", houseNumber: 27 },
        position: { lat: 59.9230386, lng: 30.3497716 },
        date: new Date(1945, 5, 5),
        description: "Пробито чердачное перекрытие 3 этажа.",
    },
    {
        type: 1,
        address: { street: "проспект Пархоменко", houseNumber: 8 },
        position: { lat: 60.0008161, lng: 30.3341283 },
        date: new Date(1944, 1, 4),
        description: "Пробито чердачное перекрытие 3 этажа.",
    },
    {
        type: 2,
        address: { street: "Боровая улица", houseNumber: 15 },
        position: { lat: 59.9205512, lng: 30.3472747 },
        date: new Date(1943, 1, 6),
        description: "Пробито чердачное перекрытие 3 этажа.",
    },
    {
        type: 2,
        address: { street: "Конная улица", houseNumber: 2 },
        position: { lat: 59.9297361, lng: 30.3732011 },
        date: new Date(1944, 0, 1),
        description: "Пробито чердачное перекрытие 3 этажа.",
    },
    {
        type: 1,
        address: { street: "проспект Юрия Гагарина", houseNumber: 15 },
        position: { lat: 59.8636153, lng: 30.3350122 },
        date: new Date(1942, 9, 4),
        description: "Пробито чердачное перекрытие 3 этажа.",
    },
    {
        type: 1,
        address: { street: "набережная Обводного канала", houseNumber: 118 },
        position: { lat: 59.9062872, lng: 30.3071185 },
        date: new Date(1944, 1, 4),
        description: "Пробито чердачное перекрытие 3 этажа.",
    },
    {
        type: 1,
        address: { street: "Конногвардейский переулок", houseNumber: 5 },
        position: { lat: 59.930182, lng: 30.2976456 },
        date: new Date(1944, 11, 6),
        description: "Пробито чердачное перекрытие 3 этажа.",
    },
    {
        type: 1,
        address: { street: "Балтийская улица", houseNumber: 2 },
        position: { lat: 59.8971467, lng: 30.27762 },
        date: new Date(1943, 1, 2),
        description: "Пробито чердачное перекрытие 3 этажа.",
    },
    {
        type: 1,
        address: { street: "проспект Металлистов", houseNumber: 64 },
        position: { lat: 59.9576693, lng: 30.4218683 },
        date: new Date(1943, 5, 2),
        description: "Пробито чердачное перекрытие 3 этажа.",
    },
    {
        type: 1,
        address: { street: "1-й проезд", houseNumber: 15 },
        position: { lat: 59.8441963, lng: 30.7045078 },
        date: new Date(1943, 9, 6),
        description: "Пробито чердачное перекрытие 3 этажа.",
    },
    {
        type: 1,
        address: { street: "Большая Разночинная улица", houseNumber: 24 },
        position: { lat: 59.9605203, lng: 30.2866999 },
        date: new Date(1943, 2, 2),
        description: "Пробито чердачное перекрытие 3 этажа.",
    },
    {
        type: 2,
        address: { street: "6-я Советская улица", houseNumber: 18 },
        position: { lat: 59.9351626, lng: 30.3731337 },
        date: new Date(1941, 10, 3),
        description: "Пробито чердачное перекрытие 3 этажа.",
    },
    {
        type: 1,
        address: { street: "улица Ленсовета", houseNumber: 42 },
        position: { lat: 59.8453023, lng: 30.3306917 },
        date: new Date(1945, 5, 1),
        description: "Пробито чердачное перекрытие 3 этажа.",
    },
    {
        type: 1,
        address: { street: "Старо-Петергофский проспект", houseNumber: 41 },
        position: { lat: 59.902396, lng: 30.2755094 },
        date: new Date(1941, 9, 5),
        description: "Пробито чердачное перекрытие 3 этажа.",
    },
    {
        type: 0,
        address: { street: "Новоовсянниковская улица", houseNumber: 7 },
        position: { lat: 59.8880523, lng: 30.2652979 },
        date: new Date(1944, 11, 6),
        description: "Пробито чердачное перекрытие 3 этажа.",
    },
    {
        type: 0,
        address: { street: "Заставская улица", houseNumber: 30 },
        position: { lat: 59.8886385, lng: 30.3232004 },
        date: new Date(1942, 9, 1),
        description: "Пробито чердачное перекрытие 3 этажа.",
    },
    {
        type: 2,
        address: { street: "бульвар Новаторов", houseNumber: 71 },
        position: { lat: 59.8420283, lng: 30.2533411 },
        date: new Date(1943, 4, 5),
        description: "Пробито чердачное перекрытие 3 этажа.",
    },
    {
        type: 1,
        address: { street: "Загородный проспект", houseNumber: 21 },
        position: { lat: 59.9255743, lng: 30.3377469 },
        date: new Date(1944, 7, 1),
        description: "Пробито чердачное перекрытие 3 этажа.",
    },
    {
        type: 2,
        address: { street: "Гончарная улица", houseNumber: 8 },
        position: { lat: 59.9296511, lng: 30.3652775 },
        date: new Date(1944, 11, 1),
        description: "Пробито чердачное перекрытие 3 этажа.",
    },
    {
        type: 2,
        address: { street: "Кронверкский проспект", houseNumber: 29 },
        position: { lat: 59.9574202, lng: 30.3169356 },
        date: new Date(1943, 7, 5),
        description: "Пробито чердачное перекрытие 3 этажа.",
    },
    {
        type: 1,
        address: { street: "Садовая улица", houseNumber: 26 },
        position: { lat: 59.9326241, lng: 30.3326752 },
        date: new Date(1943, 2, 4),
        description: "Пробито чердачное перекрытие 3 этажа.",
    },
    {
        type: 1,
        address: { street: "Павлоградский переулок", houseNumber: 6 },
        position: { lat: 59.917077, lng: 30.3542092 },
        date: new Date(1945, 1, 3),
        description: "Пробито чердачное перекрытие 3 этажа.",
    },
    {
        type: 2,
        address: { street: "Лесная улица", houseNumber: 22 },
        position: { lat: 60.03475, lng: 30.4683115 },
        date: new Date(1945, 6, 4),
        description: "Пробито чердачное перекрытие 3 этажа.",
    },
    {
        type: 1,
        address: { street: "Сестрорецкая улица", houseNumber: 8 },
        position: { lat: 59.9864816, lng: 30.2881863 },
        date: new Date(1943, 11, 2),
        description: "Пробито чердачное перекрытие 3 этажа.",
    },
    {
        type: 1,
        address: { street: "Столярный переулок", houseNumber: 8 },
        position: { lat: 59.927833, lng: 30.3114297 },
        date: new Date(1943, 3, 0),
        description: "Пробито чердачное перекрытие 3 этажа.",
    },
    {
        type: 1,
        address: { street: "Варшавская улица", houseNumber: 108 },
        position: { lat: 59.8492394, lng: 30.3154662 },
        date: new Date(1942, 8, 3),
        description: "Пробито чердачное перекрытие 3 этажа.",
    },
    {
        type: 1,
        address: { street: "набережная Обводного канала", houseNumber: 58 },
        position: { lat: 59.9155393, lng: 30.3455362 },
        date: new Date(1942, 0, 0),
        description: "Пробито чердачное перекрытие 3 этажа.",
    },
    {
        type: 1,
        address: { street: "5-я Советская улица", houseNumber: 24 },
        position: { lat: 59.9343459, lng: 30.3712162 },
        date: new Date(1944, 0, 5),
        description: "Пробито чердачное перекрытие 3 этажа.",
    },
    {
        type: 1,
        address: { street: "набережная реки Фонтанки", houseNumber: 169 },
        position: { lat: 59.9163893, lng: 30.2926616 },
        date: new Date(1941, 11, 5),
        description: "Пробито чердачное перекрытие 3 этажа.",
    },
    {
        type: 1,
        address: { street: "Кузнечный переулок", houseNumber: 3 },
        position: { lat: 59.9272226, lng: 30.3502243 },
        date: new Date(1945, 0, 6),
        description: "Пробито чердачное перекрытие 3 этажа.",
    },
    {
        type: 2,
        address: { street: "Севастопольская улица", houseNumber: 24 },
        position: { lat: 59.8925935, lng: 30.2669582 },
        date: new Date(1944, 7, 1),
        description: "Пробито чердачное перекрытие 3 этажа.",
    },
    {
        type: 1,
        address: { street: "Невская улица", houseNumber: 1 },
        position: { lat: 59.9909842, lng: 30.6542262 },
        date: new Date(1942, 9, 5),
        description: "Пробито чердачное перекрытие 3 этажа.",
    },
    {
        type: 0,
        address: { street: "Канонерская улица", houseNumber: 18 },
        position: { lat: 59.9195007, lng: 30.2896878 },
        date: new Date(1943, 6, 6),
        description: "Пробито чердачное перекрытие 3 этажа.",
    },
    {
        type: 1,
        address: { street: "шоссе Революции", houseNumber: 65 },
        position: { lat: 59.961463, lng: 30.458954 },
        date: new Date(1945, 1, 6),
        description: "Пробито чердачное перекрытие 3 этажа.",
    },
    {
        type: 1,
        address: { street: "Кронверкский проспект", houseNumber: 23 },
        position: { lat: 59.9569182, lng: 30.3190598 },
        date: new Date(1945, 8, 6),
        description: "Пробито чердачное перекрытие 3 этажа.",
    },
    {
        type: 1,
        address: { street: "Охтинская аллея", houseNumber: 12 },
        position: { lat: 60.0491409, lng: 30.4307994 },
        date: new Date(1942, 9, 6),
        description: "Пробито чердачное перекрытие 3 этажа.",
    },
    {
        type: 2,
        address: { street: "улица Нахимова", houseNumber: 2 },
        position: { lat: 59.9437123, lng: 30.236122 },
        date: new Date(1941, 6, 0),
        description: "Пробито чердачное перекрытие 3 этажа.",
    },
    {
        type: 1,
        address: { street: "улица Марата", houseNumber: 3 },
        position: { lat: 59.930921, lng: 30.354927 },
        date: new Date(1942, 4, 2),
        description: "Пробито чердачное перекрытие 3 этажа.",
    },
    {
        type: 0,
        address: { street: "Конногвардейский переулок", houseNumber: 4 },
        position: { lat: 59.9316874, lng: 30.29644 },
        date: new Date(1944, 10, 6),
        description: "Пробито чердачное перекрытие 3 этажа.",
    },
    {
        type: 1,
        address: { street: "улица Жуковского", houseNumber: 12 },
        position: { lat: 59.9360841, lng: 30.3531286 },
        date: new Date(1943, 3, 3),
        description: "Пробито чердачное перекрытие 3 этажа.",
    },
    {
        type: 2,
        address: { street: "Каменноостровский проспект", houseNumber: 10 },
        position: { lat: 59.9584021, lng: 30.3184001 },
        date: new Date(1943, 8, 1),
        description: "Пробито чердачное перекрытие 3 этажа.",
    },
    {
        type: 2,
        address: { street: "Наличная улица", houseNumber: 3 },
        position: { lat: 59.9298015, lng: 30.2378595 },
        date: new Date(1943, 4, 6),
        description: "Пробито чердачное перекрытие 3 этажа.",
    },
    {
        type: 0,
        address: { street: "улица Аккуратова", houseNumber: 13 },
        position: { lat: 60.0161064, lng: 30.3109936 },
        date: new Date(1941, 7, 1),
        description: "Пробито чердачное перекрытие 3 этажа.",
    },
    {
        type: 2,
        address: { street: "Невский проспект", houseNumber: 3 },
        position: { lat: 59.936668, lng: 30.3126363 },
        date: new Date(1942, 11, 6),
        description: "Пробито чердачное перекрытие 3 этажа.",
    },
    {
        type: 2,
        address: { street: "улица Корякова", houseNumber: 40 },
        position: { lat: 60.0511193, lng: 30.3063766 },
        date: new Date(1942, 2, 3),
        description: "Пробито чердачное перекрытие 3 этажа.",
    },
    {
        type: 1,
        address: { street: "Варшавская улица", houseNumber: 62 },
        position: { lat: 59.8592247, lng: 30.314609 },
        date: new Date(1942, 1, 0),
        description: "Пробито чердачное перекрытие 3 этажа.",
    },
    {
        type: 2,
        address: { street: "Индустриальный проспект", houseNumber: 31 },
        position: { lat: 59.9510965, lng: 30.4731476 },
        date: new Date(1943, 3, 4),
        description: "Пробито чердачное перекрытие 3 этажа.",
    },
    {
        type: 1,
        address: { street: "Народная улица", houseNumber: 33 },
        position: { lat: 59.881116, lng: 30.4685655 },
        date: new Date(1944, 4, 1),
        description: "Пробито чердачное перекрытие 3 этажа.",
    },
    {
        type: 1,
        address: { street: "Гагаринская улица", houseNumber: 26 },
        position: { lat: 59.9441677, lng: 30.3431842 },
        date: new Date(1943, 0, 3),
        description: "Пробито чердачное перекрытие 3 этажа.",
    },
    {
        type: 1,
        address: { street: "Коломяжский проспект", houseNumber: 28 },
        position: { lat: 60.0070994, lng: 30.2948893 },
        date: new Date(1942, 8, 4),
        description: "Пробито чердачное перекрытие 3 этажа.",
    },
    {
        type: 0,
        address: { street: "улица Нахимова", houseNumber: 20 },
        position: { lat: 59.9401899, lng: 30.2223745 },
        date: new Date(1943, 1, 0),
        description: "Пробито чердачное перекрытие 3 этажа.",
    },
    {
        type: 2,
        address: { street: "Большая Пушкарская улица", houseNumber: 52 },
        position: { lat: 59.9627686, lng: 30.3099365 },
        date: new Date(1944, 7, 5),
        description: "Пробито чердачное перекрытие 3 этажа.",
    },
    {
        type: 2,
        address: { street: "Бассейная улица", houseNumber: 39 },
        position: { lat: 59.8646726, lng: 30.3194785 },
        date: new Date(1942, 6, 4),
        description: "Пробито чердачное перекрытие 3 этажа.",
    },
    {
        type: 0,
        address: { street: "улица Кораблестроителей", houseNumber: 39 },
        position: { lat: 59.9549277, lng: 30.2316183 },
        date: new Date(1942, 6, 2),
        description: "Пробито чердачное перекрытие 3 этажа.",
    },
    {
        type: 2,
        address: { street: "Литейный проспект", houseNumber: 27 },
        position: { lat: 59.9423995, lng: 30.3476897 },
        date: new Date(1943, 3, 2),
        description: "Пробито чердачное перекрытие 3 этажа.",
    },
    {
        type: 0,
        address: { street: "Коломяжский проспект", houseNumber: 28 },
        position: { lat: 60.0070994, lng: 30.2948893 },
        date: new Date(1944, 3, 0),
        description: "Пробито чердачное перекрытие 3 этажа.",
    },
    {
        type: 1,
        address: { street: "Казанская улица", houseNumber: 7 },
        position: { lat: 59.9324074, lng: 30.3214261 },
        date: new Date(1944, 0, 6),
        description: "Пробито чердачное перекрытие 3 этажа.",
    },
    {
        type: 1,
        address: { street: "улица Печатника Григорьева", houseNumber: 6 },
        position: { lat: 59.9196528, lng: 30.3515834 },
        date: new Date(1942, 7, 3),
        description: "Пробито чердачное перекрытие 3 этажа.",
    },
    {
        type: 2,
        address: { street: "улица Ленсовета", houseNumber: 38 },
        position: { lat: 59.8466547, lng: 30.3305832 },
        date: new Date(1945, 1, 4),
        description: "Пробито чердачное перекрытие 3 этажа.",
    },
    {
        type: 2,
        address: { street: "Среднеохтинский проспект", houseNumber: 22 },
        position: { lat: 59.9510746, lng: 30.4144196 },
        date: new Date(1942, 0, 4),
        description: "Пробито чердачное перекрытие 3 этажа.",
    },
    {
        type: 1,
        address: { street: "Павлоградский переулок", houseNumber: 4 },
        position: { lat: 59.9171403, lng: 30.3537812 },
        date: new Date(1943, 4, 6),
        description: "Пробито чердачное перекрытие 3 этажа.",
    },
    {
        type: 1,
        address: { street: "улица Трефолева", houseNumber: 22 },
        position: { lat: 59.8907178, lng: 30.2699292 },
        date: new Date(1943, 0, 0),
        description: "Пробито чердачное перекрытие 3 этажа.",
    },
    {
        type: 1,
        address: { street: "улица Ленсовета", houseNumber: 37 },
        position: { lat: 59.8449738, lng: 30.3298013 },
        date: new Date(1943, 6, 4),
        description: "Пробито чердачное перекрытие 3 этажа.",
    },
    {
        type: 1,
        address: { street: "Садовая улица", houseNumber: 38 },
        position: { lat: 59.9278113, lng: 30.3205988 },
        date: new Date(1943, 11, 0),
        description: "Пробито чердачное перекрытие 3 этажа.",
    },
    {
        type: 1,
        address: { street: "Фонарный переулок", houseNumber: 10 },
        position: { lat: 59.9281704, lng: 30.3053676 },
        date: new Date(1941, 10, 3),
        description: "Пробито чердачное перекрытие 3 этажа.",
    },
    {
        type: 0,
        address: { street: "Малая Московская улица", houseNumber: 2 },
        position: { lat: 59.9263405, lng: 30.3482549 },
        date: new Date(1942, 10, 3),
        description: "Пробито чердачное перекрытие 3 этажа.",
    },
    {
        type: 1,
        address: { street: "Восточный проезд", houseNumber: 4 },
        position: { lat: 59.9461171, lng: 30.5956826 },
        date: new Date(1942, 10, 3),
        description: "Пробито чердачное перекрытие 3 этажа.",
    },
    {
        type: 0,
        address: { street: "Комендантская площадь", houseNumber: 1 },
        position: { lat: 60.0076232, lng: 30.2596122 },
        date: new Date(1944, 1, 4),
        description: "Пробито чердачное перекрытие 3 этажа.",
    },
    {
        type: 1,
        address: { street: "проспект Энгельса", houseNumber: 137 },
        position: { lat: 60.0504169, lng: 30.3345815 },
        date: new Date(1944, 2, 1),
        description: "Пробито чердачное перекрытие 3 этажа.",
    },
    {
        type: 0,
        address: { street: "проспект Просвещения", houseNumber: 78 },
        position: { lat: 60.0390001, lng: 30.4046563 },
        date: new Date(1942, 0, 3),
        description: "Пробито чердачное перекрытие 3 этажа.",
    },
    {
        type: 1,
        address: { street: "Марсово поле", houseNumber: 7 },
        position: { lat: 59.9422335, lng: 30.3298106 },
        date: new Date(1945, 0, 4),
        description: "Пробито чердачное перекрытие 3 этажа.",
    },
    {
        type: 1,
        address: { street: "Английская набережная", houseNumber: 20 },
        position: { lat: 59.934688, lng: 30.2959082 },
        date: new Date(1944, 7, 4),
        description: "Пробито чердачное перекрытие 3 этажа.",
    },
    {
        type: 0,
        address: { street: "улица Седова", houseNumber: 85 },
        position: { lat: 59.8692568, lng: 30.4404349 },
        date: new Date(1943, 5, 1),
        description: "Пробито чердачное перекрытие 3 этажа.",
    },
    {
        type: 1,
        address: { street: "улица Ленсовета", houseNumber: 37 },
        position: { lat: 59.8449738, lng: 30.3298013 },
        date: new Date(1941, 11, 2),
        description: "Пробито чердачное перекрытие 3 этажа.",
    },
    {
        type: 0,
        address: { street: "проспект КИМа", houseNumber: 1 },
        position: { lat: 59.9492846, lng: 30.2491194 },
        date: new Date(1941, 9, 0),
        description: "Пробито чердачное перекрытие 3 этажа.",
    },
    {
        type: 1,
        address: { street: "Фурштатская улица", houseNumber: 48 },
        position: { lat: 59.9453011, lng: 30.3633022 },
        date: new Date(1942, 8, 1),
        description: "Пробито чердачное перекрытие 3 этажа.",
    },
    {
        type: 2,
        address: { street: "улица Чайковского", houseNumber: 55 },
        position: { lat: 59.9463162, lng: 30.3577025 },
        date: new Date(1944, 11, 3),
        description: "Пробито чердачное перекрытие 3 этажа.",
    },
    {
        type: 1,
        address: { street: "Невский проспект", houseNumber: 148 },
        position: { lat: 59.9285793, lng: 30.3719707 },
        date: new Date(1943, 1, 3),
        description: "Пробито чердачное перекрытие 3 этажа.",
    },
    {
        type: 0,
        address: { street: "улица Фокина", houseNumber: 2 },
        position: { lat: 59.9661792, lng: 30.3388075 },
        date: new Date(1944, 9, 3),
        description: "Пробито чердачное перекрытие 3 этажа.",
    },
    {
        type: 0,
        address: { street: "проспект Чернышевского", houseNumber: 12 },
        position: { lat: 59.9466273, lng: 30.3596003 },
        date: new Date(1942, 2, 0),
        description: "Пробито чердачное перекрытие 3 этажа.",
    },
    {
        type: 1,
        address: { street: "Матвеевская улица", houseNumber: 28 },
        position: { lat: 60.033274, lng: 30.6766159 },
        date: new Date(1945, 6, 5),
        description: "Пробито чердачное перекрытие 3 этажа.",
    },
    {
        type: 1,
        address: { street: "проспект Авиаконструкторов", houseNumber: 6 },
        position: { lat: 60.0111674, lng: 30.2435948 },
        date: new Date(1943, 6, 4),
        description: "Пробито чердачное перекрытие 3 этажа.",
    },
    {
        type: 2,
        address: { street: "Днепровский переулок", houseNumber: 1 },
        position: { lat: 59.937838, lng: 30.2832098 },
        date: new Date(1945, 3, 0),
        description: "Пробито чердачное перекрытие 3 этажа.",
    },
    {
        type: 0,
        address: { street: "Волоколамский переулок", houseNumber: 3 },
        position: { lat: 59.9201744, lng: 30.3497487 },
        date: new Date(1943, 1, 6),
        description: "Пробито чердачное перекрытие 3 этажа.",
    },
    {
        type: 0,
        address: { street: "Оборонная улица", houseNumber: 23 },
        position: { lat: 59.8937668, lng: 30.2631675 },
        date: new Date(1942, 8, 2),
        description: "Пробито чердачное перекрытие 3 этажа.",
    },
    {
        type: 1,
        address: { street: "улица Орбели", houseNumber: 17 },
        position: { lat: 60.0022417, lng: 30.3421905 },
        date: new Date(1943, 3, 2),
        description: "Пробито чердачное перекрытие 3 этажа.",
    },
    {
        type: 1,
        address: { street: "улица Есенина", houseNumber: 19 },
        position: { lat: 60.0473404, lng: 30.3391072 },
        date: new Date(1944, 11, 0),
        description: "Пробито чердачное перекрытие 3 этажа.",
    },
    {
        type: 2,
        address: { street: "Свердловская набережная", houseNumber: 62 },
        position: { lat: 59.9515419, lng: 30.4081599 },
        date: new Date(1942, 2, 4),
        description: "Пробито чердачное перекрытие 3 этажа.",
    },
    {
        type: 0,
        address: { street: "набережная Кутузова", houseNumber: 4 },
        position: { lat: 59.9494071, lng: 30.3463456 },
        date: new Date(1944, 9, 5),
        description: "Пробито чердачное перекрытие 3 этажа.",
    },
    {
        type: 2,
        address: { street: "Ярославский проспект", houseNumber: 31 },
        position: { lat: 60.0144067, lng: 30.3213514 },
        date: new Date(1944, 8, 0),
        description: "Пробито чердачное перекрытие 3 этажа.",
    },
    {
        type: 1,
        address: { street: "Курляндская улица", houseNumber: 35 },
        position: { lat: 59.9116909, lng: 30.274814 },
        date: new Date(1942, 11, 2),
        description: "Пробито чердачное перекрытие 3 этажа.",
    },
    {
        type: 2,
        address: { street: "Рыбацкая улица", houseNumber: 4 },
        position: { lat: 59.9582249, lng: 30.2975943 },
        date: new Date(1942, 1, 5),
        description: "Пробито чердачное перекрытие 3 этажа.",
    },
    {
        type: 1,
        address: { street: "Средний проспект В.О.", houseNumber: 104 },
        position: { lat: 59.9313703, lng: 30.2383839 },
        date: new Date(1943, 10, 5),
        description: "Пробито чердачное перекрытие 3 этажа.",
    },
    {
        type: 1,
        address: { street: "Большой проспект П.С.", houseNumber: 83 },
        position: { lat: 59.9674439, lng: 30.3141715 },
        date: new Date(1942, 4, 1),
        description: "Пробито чердачное перекрытие 3 этажа.",
    },
    {
        type: 1,
        address: { street: "Большой проспект В.О.", houseNumber: 103 },
        position: { lat: 59.9268411, lng: 30.2401039 },
        date: new Date(1942, 0, 0),
        description: "Пробито чердачное перекрытие 3 этажа.",
    },
    {
        type: 2,
        address: { street: "Промышленная улица", houseNumber: 6 },
        position: { lat: 59.899013, lng: 30.2732395 },
        date: new Date(1942, 7, 3),
        description: "Пробито чердачное перекрытие 3 этажа.",
    },
    {
        type: 1,
        address: { street: "проспект Обуховской Обороны", houseNumber: 93 },
        position: { lat: 59.8986766, lng: 30.4298211 },
        date: new Date(1942, 2, 5),
        description: "Пробито чердачное перекрытие 3 этажа.",
    },
    {
        type: 2,
        address: { street: "Кронверкская улица", houseNumber: 7 },
        position: { lat: 59.9585526, lng: 30.3128766 },
        date: new Date(1945, 5, 3),
        description: "Пробито чердачное перекрытие 3 этажа.",
    },
    {
        type: 2,
        address: { street: "Большая Подьяческая улица", houseNumber: 35 },
        position: { lat: 59.9211164, lng: 30.3050881 },
        date: new Date(1945, 4, 0),
        description: "Пробито чердачное перекрытие 3 этажа.",
    },
    {
        type: 1,
        address: { street: "улица Мира", houseNumber: 1 },
        position: { lat: 59.9588013, lng: 30.3127708 },
        date: new Date(1943, 0, 4),
        description: "Пробито чердачное перекрытие 3 этажа.",
    },
    {
        type: 2,
        address: { street: "Кронверкский проспект", houseNumber: 29 },
        position: { lat: 59.9574202, lng: 30.3169356 },
        date: new Date(1942, 8, 5),
        description: "Пробито чердачное перекрытие 3 этажа.",
    },
    {
        type: 1,
        address: { street: "Шведский переулок", houseNumber: 3 },
        position: { lat: 59.9389077, lng: 30.3247755 },
        date: new Date(1944, 7, 3),
        description: "Пробито чердачное перекрытие 3 этажа.",
    },
    {
        type: 1,
        address: { street: "Заневский проспект", houseNumber: 36 },
        position: { lat: 59.9338063, lng: 30.4272954 },
        date: new Date(1943, 6, 1),
        description: "Пробито чердачное перекрытие 3 этажа.",
    },
    {
        type: 1,
        address: { street: "Колтушское шоссе", houseNumber: 40 },
        position: { lat: 60.0333701, lng: 30.6360702 },
        date: new Date(1945, 1, 6),
        description: "Пробито чердачное перекрытие 3 этажа.",
    },
    {
        type: 2,
        address: { street: "Липовая аллея", houseNumber: 11 },
        position: { lat: 59.9858592, lng: 30.2567333 },
        date: new Date(1943, 2, 6),
        description: "Пробито чердачное перекрытие 3 этажа.",
    },
    {
        type: 0,
        address: { street: "улица Пестеля", houseNumber: 2 },
        position: { lat: 59.9423396, lng: 30.3391851 },
        date: new Date(1942, 7, 0),
        description: "Пробито чердачное перекрытие 3 этажа.",
    },
    {
        type: 1,
        address: { street: "Стремянная улица", houseNumber: 16 },
        position: { lat: 59.9309642, lng: 30.3522835 },
        date: new Date(1943, 0, 0),
        description: "Пробито чердачное перекрытие 3 этажа.",
    },
    {
        type: 1,
        address: { street: "Невский проспект", houseNumber: 90 },
        position: { lat: 59.9324989, lng: 30.3521592 },
        date: new Date(1943, 2, 3),
        description: "Пробито чердачное перекрытие 3 этажа.",
    },
    {
        type: 1,
        address: { street: "проспект Народного Ополчения", houseNumber: 22 },
        position: { lat: 59.8452145, lng: 30.2806135 },
        date: new Date(1941, 11, 6),
        description: "Пробито чердачное перекрытие 3 этажа.",
    },
    {
        type: 0,
        address: { street: "Ивановская улица", houseNumber: 26 },
        position: { lat: 59.8731892, lng: 30.437934 },
        date: new Date(1943, 7, 2),
        description: "Пробито чердачное перекрытие 3 этажа.",
    },
    {
        type: 1,
        address: { street: "проспект Елизарова", houseNumber: 15 },
        position: { lat: 59.8960689, lng: 30.4217493 },
        date: new Date(1943, 10, 4),
        description: "Пробито чердачное перекрытие 3 этажа.",
    },
    {
        type: 1,
        address: { street: "Витебский проспект", houseNumber: 12 },
        position: { lat: 59.8740707, lng: 30.3535501 },
        date: new Date(1945, 2, 0),
        description: "Пробито чердачное перекрытие 3 этажа.",
    },
    {
        type: 2,
        address: { street: "Московский проспект", houseNumber: 205 },
        position: { lat: 59.847538, lng: 30.3209718 },
        date: new Date(1944, 7, 2),
        description: "Пробито чердачное перекрытие 3 этажа.",
    },
    {
        type: 1,
        address: { street: "Матвеевская улица", houseNumber: 24 },
        position: { lat: 60.0344015, lng: 30.6763936 },
        date: new Date(1943, 0, 6),
        description: "Пробито чердачное перекрытие 3 этажа.",
    },
    {
        type: 0,
        address: { street: "Большой проспект П.С.", houseNumber: 30 },
        position: { lat: 59.9571379, lng: 30.2976752 },
        date: new Date(1942, 9, 2),
        description: "Пробито чердачное перекрытие 3 этажа.",
    },
    {
        type: 2,
        address: { street: "Большой проспект П.С.", houseNumber: 4 },
        position: { lat: 59.9530556, lng: 30.2908629 },
        date: new Date(1944, 6, 6),
        description: "Пробито чердачное перекрытие 3 этажа.",
    },
    {
        type: 2,
        address: { street: "улица Типанова", houseNumber: 4 },
        position: { lat: 59.8506664, lng: 30.3263141 },
        date: new Date(1945, 2, 3),
        description: "Пробито чердачное перекрытие 3 этажа.",
    },
    {
        type: 1,
        address: { street: "улица Рубинштейна", houseNumber: 1 },
        position: { lat: 59.9327334, lng: 30.3458604 },
        date: new Date(1943, 3, 5),
        description: "Пробито чердачное перекрытие 3 этажа.",
    },
    {
        type: 1,
        address: { street: "Гагаринская улица", houseNumber: 36 },
        position: { lat: 59.9429791, lng: 30.3433706 },
        date: new Date(1943, 6, 6),
        description: "Пробито чердачное перекрытие 3 этажа.",
    },
    {
        type: 1,
        address: { street: "Трудовой переулок", houseNumber: 11 },
        position: { lat: 60.0134509, lng: 30.0273561 },
        date: new Date(1941, 8, 0),
        description: "Пробито чердачное перекрытие 3 этажа.",
    },
    {
        type: 2,
        address: { street: "Чкаловский проспект", houseNumber: 31 },
        position: { lat: 59.9670797, lng: 30.300946 },
        date: new Date(1945, 3, 3),
        description: "Пробито чердачное перекрытие 3 этажа.",
    },
    {
        type: 1,
        address: { street: "набережная реки Мойки", houseNumber: 101 },
        position: { lat: 59.9309248, lng: 30.3040682 },
        date: new Date(1943, 6, 1),
        description: "Пробито чердачное перекрытие 3 этажа.",
    },
    {
        type: 1,
        address: { street: "Свердловская набережная", houseNumber: 60 },
        position: { lat: 59.9555369, lng: 30.4098438 },
        date: new Date(1941, 5, 0),
        description: "Пробито чердачное перекрытие 3 этажа.",
    },
    {
        type: 0,
        address: { street: "Лифляндская улица", houseNumber: 10 },
        position: { lat: 59.9058509, lng: 30.2633803 },
        date: new Date(1944, 5, 0),
        description: "Пробито чердачное перекрытие 3 этажа.",
    },
    {
        type: 1,
        address: { street: "Английская набережная", houseNumber: 18 },
        position: { lat: 59.9347436, lng: 30.2960733 },
        date: new Date(1942, 2, 0),
        description: "Пробито чердачное перекрытие 3 этажа.",
    },
    {
        type: 0,
        address: { street: "Охтинская аллея", houseNumber: 12 },
        position: { lat: 60.0491409, lng: 30.4307994 },
        date: new Date(1944, 8, 6),
        description: "Пробито чердачное перекрытие 3 этажа.",
    },
    {
        type: 1,
        address: { street: "Лермонтовский проспект", houseNumber: 50 },
        position: { lat: 59.9126071, lng: 30.297818 },
        date: new Date(1944, 3, 4),
        description: "Пробито чердачное перекрытие 3 этажа.",
    },
    {
        type: 1,
        address: { street: "улица Пестеля", houseNumber: 27 },
        position: { lat: 59.9427648, lng: 30.3489612 },
        date: new Date(1945, 3, 5),
        description: "Пробито чердачное перекрытие 3 этажа.",
    },
    {
        type: 2,
        address: { street: "Капитанская улица", houseNumber: 4 },
        position: { lat: 59.955085, lng: 30.2169916 },
        date: new Date(1942, 7, 1),
        description: "Пробито чердачное перекрытие 3 этажа.",
    },
    {
        type: 2,
        address: { street: "Галерная улица", houseNumber: 71 },
        position: { lat: 59.9307426, lng: 30.2852459 },
        date: new Date(1942, 2, 4),
        description: "Пробито чердачное перекрытие 3 этажа.",
    },
    {
        type: 2,
        address: { street: "Гагаринская улица", houseNumber: 2 },
        position: { lat: 59.948587, lng: 30.3416222 },
        date: new Date(1945, 7, 5),
        description: "Пробито чердачное перекрытие 3 этажа.",
    },
    {
        type: 0,
        address: { street: "улица Маршала Говорова", houseNumber: 16 },
        position: { lat: 59.8819352, lng: 30.2694775 },
        date: new Date(1941, 9, 1),
        description: "Пробито чердачное перекрытие 3 этажа.",
    },
    {
        type: 0,
        address: { street: "улица Крупской", houseNumber: 32 },
        position: { lat: 59.8873072, lng: 30.4177502 },
        date: new Date(1944, 10, 0),
        description: "Пробито чердачное перекрытие 3 этажа.",
    },
    {
        type: 2,
        address: { street: "Графский переулок", houseNumber: 3 },
        position: { lat: 59.9308588, lng: 30.3440274 },
        date: new Date(1942, 10, 3),
        description: "Пробито чердачное перекрытие 3 этажа.",
    },
    {
        type: 2,
        address: { street: "Литейный проспект", houseNumber: 60 },
        position: { lat: 59.9338114, lng: 30.3483929 },
        date: new Date(1944, 5, 6),
        description: "Пробито чердачное перекрытие 3 этажа.",
    },
    {
        type: 1,
        address: { street: "Ириновский проспект", houseNumber: 32 },
        position: { lat: 59.9600083, lng: 30.4811348 },
        date: new Date(1945, 7, 6),
        description: "Пробито чердачное перекрытие 3 этажа.",
    },
    {
        type: 1,
        address: { street: "Заозёрная улица", houseNumber: 8 },
        position: { lat: 59.90728, lng: 30.3233275 },
        date: new Date(1945, 2, 0),
        description: "Пробито чердачное перекрытие 3 этажа.",
    },
    {
        type: 0,
        address: { street: "Аптекарский проспект", houseNumber: 8 },
        position: { lat: 59.9710211, lng: 30.3191873 },
        date: new Date(1941, 8, 1),
        description: "Пробито чердачное перекрытие 3 этажа.",
    },
    {
        type: 1,
        address: { street: "Клинский проспект", houseNumber: 11 },
        position: { lat: 59.9156873, lng: 30.3249006 },
        date: new Date(1944, 3, 0),
        description: "Пробито чердачное перекрытие 3 этажа.",
    },
    {
        type: 0,
        address: { street: "улица Чапаева", houseNumber: 17 },
        position: { lat: 59.9623707, lng: 30.3328612 },
        date: new Date(1941, 8, 2),
        description: "Пробито чердачное перекрытие 3 этажа.",
    },
    {
        type: 0,
        address: { street: "улица Смолячкова", houseNumber: 10 },
        position: { lat: 59.9707917, lng: 30.3416847 },
        date: new Date(1944, 2, 4),
        description: "Пробито чердачное перекрытие 3 этажа.",
    },
    {
        type: 0,
        address: { street: "улица Нахимова", houseNumber: 5 },
        position: { lat: 59.9418278, lng: 30.2245287 },
        date: new Date(1943, 6, 2),
        description: "Пробито чердачное перекрытие 3 этажа.",
    },
    {
        type: 2,
        address: { street: "Прачечный переулок", houseNumber: 10 },
        position: { lat: 59.9285524, lng: 30.3018836 },
        date: new Date(1944, 6, 5),
        description: "Пробито чердачное перекрытие 3 этажа.",
    },
    {
        type: 2,
        address: { street: "Гагаринская улица", houseNumber: 32 },
        position: { lat: 59.9433886, lng: 30.343319 },
        date: new Date(1942, 6, 4),
        description: "Пробито чердачное перекрытие 3 этажа.",
    },
    {
        type: 1,
        address: { street: "Петергофское шоссе", houseNumber: 57 },
        position: { lat: 59.8493079, lng: 30.1363943 },
        date: new Date(1944, 9, 2),
        description: "Пробито чердачное перекрытие 3 этажа.",
    },
    {
        type: 2,
        address: { street: "Петергофское шоссе", houseNumber: 3 },
        position: { lat: 59.8468514, lng: 30.2055302 },
        date: new Date(1942, 8, 3),
        description: "Пробито чердачное перекрытие 3 этажа.",
    },
    {
        type: 1,
        address: { street: "Гаванская улица", houseNumber: 30 },
        position: { lat: 59.9349177, lng: 30.238374 },
        date: new Date(1943, 0, 0),
        description: "Пробито чердачное перекрытие 3 этажа.",
    },
    {
        type: 0,
        address: { street: "Светлановский проспект", houseNumber: 75 },
        position: { lat: 60.0223171, lng: 30.3771508 },
        date: new Date(1944, 7, 2),
        description: "Пробито чердачное перекрытие 3 этажа.",
    },
    {
        type: 2,
        address: { street: "Ключевой проспект", houseNumber: 16 },
        position: { lat: 59.9991069, lng: 30.1450626 },
        date: new Date(1945, 4, 4),
        description: "Пробито чердачное перекрытие 3 этажа.",
    },
    {
        type: 0,
        address: { street: "проспект Космонавтов", houseNumber: 45 },
        position: { lat: 59.8516399, lng: 30.3506508 },
        date: new Date(1945, 5, 6),
        description: "Пробито чердачное перекрытие 3 этажа.",
    },
    {
        type: 2,
        address: { street: "улица Михайлова", houseNumber: 17 },
        position: { lat: 59.9567976, lng: 30.3623385 },
        date: new Date(1945, 7, 2),
        description: "Пробито чердачное перекрытие 3 этажа.",
    },
    {
        type: 0,
        address: { street: "улица Марата", houseNumber: 48 },
        position: { lat: 59.9240872, lng: 30.3510805 },
        date: new Date(1942, 4, 6),
        description: "Пробито чердачное перекрытие 3 этажа.",
    },
    {
        type: 2,
        address: { street: "набережная реки Мойки", houseNumber: 3 },
        position: { lat: 59.9427302, lng: 30.3269261 },
        date: new Date(1942, 4, 4),
        description: "Пробито чердачное перекрытие 3 этажа.",
    },
    {
        type: 1,
        address: { street: "Большая Морская улица", houseNumber: 41 },
        position: { lat: 59.9321334, lng: 30.3063172 },
        date: new Date(1941, 11, 5),
        description: "Пробито чердачное перекрытие 3 этажа.",
    },
    {
        type: 1,
        address: { street: "Пражская улица", houseNumber: 48 },
        position: { lat: 59.8631817, lng: 30.4043269 },
        date: new Date(1942, 3, 4),
        description: "Пробито чердачное перекрытие 3 этажа.",
    },
    {
        type: 1,
        address: { street: "Карельский переулок", houseNumber: 2 },
        position: { lat: 59.986062, lng: 30.2950264 },
        date: new Date(1942, 3, 0),
        description: "Пробито чердачное перекрытие 3 этажа.",
    },
    {
        type: 2,
        address: { street: "Английский проспект", houseNumber: 45 },
        position: { lat: 59.9173474, lng: 30.289897 },
        date: new Date(1943, 0, 6),
        description: "Пробито чердачное перекрытие 3 этажа.",
    },
    {
        type: 0,
        address: { street: "улица Якубовича", houseNumber: 12 },
        position: { lat: 59.9327061, lng: 30.2998395 },
        date: new Date(1943, 11, 5),
        description: "Пробито чердачное перекрытие 3 этажа.",
    },
    {
        type: 2,
        address: { street: "Железноводская улица", houseNumber: 19 },
        position: { lat: 59.9521646, lng: 30.2470501 },
        date: new Date(1944, 7, 5),
        description: "Пробито чердачное перекрытие 3 этажа.",
    },
    {
        type: 0,
        address: { street: "проспект Юрия Гагарина", houseNumber: 71 },
        position: { lat: 59.8400704, lng: 30.3369552 },
        date: new Date(1945, 1, 1),
        description: "Пробито чердачное перекрытие 3 этажа.",
    },
    {
        type: 1,
        address: { street: "Калинкин переулок", houseNumber: 1 },
        position: { lat: 59.9166168, lng: 30.2885518 },
        date: new Date(1944, 8, 1),
        description: "Пробито чердачное перекрытие 3 этажа.",
    },
    {
        type: 1,
        address: { street: "Невский проспект", houseNumber: 71 },
        position: { lat: 59.9315786, lng: 30.3549641 },
        date: new Date(1943, 5, 3),
        description: "Пробито чердачное перекрытие 3 этажа.",
    },
    {
        type: 1,
        address: { street: "Большой Сампсониевский проспект", houseNumber: 77 },
        position: { lat: 59.9876928, lng: 30.334469 },
        date: new Date(1943, 3, 3),
        description: "Пробито чердачное перекрытие 3 этажа.",
    },
    {
        type: 1,
        address: { street: "Европейский проспект", houseNumber: 8 },
        position: { lat: 59.8998354, lng: 30.5124891 },
        date: new Date(1945, 1, 6),
        description: "Пробито чердачное перекрытие 3 этажа.",
    },
    {
        type: 1,
        address: { street: "Малый проспект В.О.", houseNumber: 19 },
        position: { lat: 59.9467844, lng: 30.2729939 },
        date: new Date(1943, 2, 1),
        description: "Пробито чердачное перекрытие 3 этажа.",
    },
    {
        type: 1,
        address: { street: "Дальневосточный проспект", houseNumber: 46 },
        position: { lat: 59.8918494, lng: 30.4642505 },
        date: new Date(1942, 7, 4),
        description: "Пробито чердачное перекрытие 3 этажа.",
    },
    {
        type: 2,
        address: { street: "Фурштатская улица", houseNumber: 12 },
        position: { lat: 59.9454311, lng: 30.3518989 },
        date: new Date(1945, 1, 2),
        description: "Пробито чердачное перекрытие 3 этажа.",
    },
    {
        type: 2,
        address: { street: "Павлоградский переулок", houseNumber: 6 },
        position: { lat: 59.917077, lng: 30.3542092 },
        date: new Date(1941, 7, 2),
        description: "Пробито чердачное перекрытие 3 этажа.",
    },
    {
        type: 2,
        address: { street: "Невский проспект", houseNumber: 16 },
        position: { lat: 59.9366012, lng: 30.317261 },
        date: new Date(1944, 1, 2),
        description: "Пробито чердачное перекрытие 3 этажа.",
    },
    {
        type: 0,
        address: { street: "шоссе в Лаврики", houseNumber: 38 },
        position: { lat: 60.0525866, lng: 30.4546705 },
        date: new Date(1944, 8, 3),
        description: "Пробито чердачное перекрытие 3 этажа.",
    },
    {
        type: 1,
        address: { street: "проспект Королёва", houseNumber: 65 },
        position: { lat: 60.0332197, lng: 30.2417176 },
        date: new Date(1945, 1, 5),
        description: "Пробито чердачное перекрытие 3 этажа.",
    },
    {
        type: 2,
        address: { street: "улица Шувалова", houseNumber: 3 },
        position: { lat: 60.0522088, lng: 30.4238905 },
        date: new Date(1943, 5, 2),
        description: "Пробито чердачное перекрытие 3 этажа.",
    },
    {
        type: 1,
        address: { street: "Каменноостровский проспект", houseNumber: 16 },
        position: { lat: 59.9592457, lng: 30.3173065 },
        date: new Date(1943, 1, 6),
        description: "Пробито чердачное перекрытие 3 этажа.",
    },
    {
        type: 0,
        address: { street: "улица Коммуны", houseNumber: 59 },
        position: { lat: 59.9629293, lng: 30.4883812 },
        date: new Date(1944, 1, 2),
        description: "Пробито чердачное перекрытие 3 этажа.",
    },
    {
        type: 0,
        address: { street: "набережная реки Мойки", houseNumber: 17 },
        position: { lat: 59.9422569, lng: 30.3229748 },
        date: new Date(1941, 7, 5),
        description: "Пробито чердачное перекрытие 3 этажа.",
    },
    {
        type: 0,
        address: { street: "Малый проспект В.О.", houseNumber: 7 },
        position: { lat: 59.9481017, lng: 30.2775097 },
        date: new Date(1943, 0, 1),
        description: "Пробито чердачное перекрытие 3 этажа.",
    },
    {
        type: 0,
        address: { street: "Петергофское шоссе", houseNumber: 3 },
        position: { lat: 59.8468514, lng: 30.2055302 },
        date: new Date(1945, 1, 4),
        description: "Пробито чердачное перекрытие 3 этажа.",
    },
    {
        type: 1,
        address: { street: "Невский проспект", houseNumber: 50 },
        position: { lat: 59.9345622, lng: 30.334971 },
        date: new Date(1944, 6, 4),
        description: "Пробито чердачное перекрытие 3 этажа.",
    },
    {
        type: 1,
        address: { street: "Средний проспект В.О.", houseNumber: 104 },
        position: { lat: 59.9313703, lng: 30.2383839 },
        date: new Date(1942, 11, 5),
        description: "Пробито чердачное перекрытие 3 этажа.",
    },
    {
        type: 1,
        address: { street: "Большая Пушкарская улица", houseNumber: 52 },
        position: { lat: 59.9627686, lng: 30.3099365 },
        date: new Date(1945, 3, 3),
        description: "Пробито чердачное перекрытие 3 этажа.",
    },
    {
        type: 2,
        address: { street: "улица Якубовича", houseNumber: 5 },
        position: { lat: 59.931704, lng: 30.2959084 },
        date: new Date(1945, 4, 1),
        description: "Пробито чердачное перекрытие 3 этажа.",
    },
    {
        type: 0,
        address: { street: "Рыбацкий проспект", houseNumber: 10 },
        position: { lat: 59.8425099, lng: 30.4998029 },
        date: new Date(1944, 0, 4),
        description: "Пробито чердачное перекрытие 3 этажа.",
    },
    {
        type: 0,
        address: { street: "Английская набережная", houseNumber: 54 },
        position: { lat: 59.9323295, lng: 30.2873102 },
        date: new Date(1942, 6, 6),
        description: "Пробито чердачное перекрытие 3 этажа.",
    },
    {
        type: 1,
        address: { street: "Прачечный переулок", houseNumber: 12 },
        position: { lat: 59.9282568, lng: 30.302056 },
        date: new Date(1941, 7, 2),
        description: "Пробито чердачное перекрытие 3 этажа.",
    },
    {
        type: 1,
        address: { street: "улица Маяковского", houseNumber: 56 },
        position: { lat: 59.9435434, lng: 30.3552314 },
        date: new Date(1944, 6, 1),
        description: "Пробито чердачное перекрытие 3 этажа.",
    },
    {
        type: 0,
        address: { street: "Марсово поле", houseNumber: 3 },
        position: { lat: 59.9429243, lng: 30.3292828 },
        date: new Date(1945, 5, 0),
        description: "Пробито чердачное перекрытие 3 этажа.",
    },
    {
        type: 2,
        address: { street: "Колокольная улица", houseNumber: 16 },
        position: { lat: 59.9285475, lng: 30.3523905 },
        date: new Date(1942, 6, 5),
        description: "Пробито чердачное перекрытие 3 этажа.",
    },
    {
        type: 2,
        address: { street: "проспект Авиаторов Балтики", houseNumber: 7 },
        position: { lat: 60.0524676, lng: 30.4388165 },
        date: new Date(1945, 4, 0),
        description: "Пробито чердачное перекрытие 3 этажа.",
    },
    {
        type: 0,
        address: { street: "Садовая улица", houseNumber: 28 },
        position: { lat: 59.9312999, lng: 30.3290963 },
        date: new Date(1942, 3, 5),
        description: "Пробито чердачное перекрытие 3 этажа.",
    },
    {
        type: 1,
        address: { street: "Гороховая улица", houseNumber: 32 },
        position: { lat: 59.9298191, lng: 30.3213075 },
        date: new Date(1942, 7, 2),
        description: "Пробито чердачное перекрытие 3 этажа.",
    },
    {
        type: 1,
        address: { street: "проспект Ленина", houseNumber: 10 },
        position: { lat: 59.9979101, lng: 30.1407494 },
        date: new Date(1941, 7, 3),
        description: "Пробито чердачное перекрытие 3 этажа.",
    },
    {
        type: 1,
        address: { street: "улица Репина", houseNumber: 10 },
        position: { lat: 59.9399072, lng: 30.290508 },
        date: new Date(1943, 1, 6),
        description: "Пробито чердачное перекрытие 3 этажа.",
    },
    {
        type: 0,
        address: { street: "улица Маяковского", houseNumber: 39 },
        position: { lat: 59.9420924, lng: 30.3556624 },
        date: new Date(1942, 4, 1),
        description: "Пробито чердачное перекрытие 3 этажа.",
    },
    {
        type: 2,
        address: { street: "Байконурская улица", houseNumber: 15 },
        position: { lat: 60.0029461, lng: 30.2752606 },
        date: new Date(1942, 1, 1),
        description: "Пробито чердачное перекрытие 3 этажа.",
    },
    {
        type: 0,
        address: { street: "Моховая улица", houseNumber: 24 },
        position: { lat: 59.9424034, lng: 30.345503 },
        date: new Date(1942, 11, 1),
        description: "Пробито чердачное перекрытие 3 этажа.",
    },
    {
        type: 1,
        address: { street: "Шафировский проспект", houseNumber: 2 },
        position: { lat: 59.9919087, lng: 30.4348873 },
        date: new Date(1943, 2, 3),
        description: "Пробито чердачное перекрытие 3 этажа.",
    },
    {
        type: 1,
        address: { street: "улица Марата", houseNumber: 2 },
        position: { lat: 59.9311346, lng: 30.3555538 },
        date: new Date(1945, 6, 4),
        description: "Пробито чердачное перекрытие 3 этажа.",
    },
    {
        type: 2,
        address: { street: "набережная реки Мойки", houseNumber: 101 },
        position: { lat: 59.9309248, lng: 30.3040682 },
        date: new Date(1944, 2, 0),
        description: "Пробито чердачное перекрытие 3 этажа.",
    },
    {
        type: 1,
        address: { street: "улица Марата", houseNumber: 3 },
        position: { lat: 59.930921, lng: 30.354927 },
        date: new Date(1941, 11, 6),
        description: "Пробито чердачное перекрытие 3 этажа.",
    },
    {
        type: 1,
        address: { street: "улица Гастелло", houseNumber: 11 },
        position: { lat: 59.8573457, lng: 30.3256016 },
        date: new Date(1945, 4, 0),
        description: "Пробито чердачное перекрытие 3 этажа.",
    },
    {
        type: 0,
        address: { street: "набережная Обводного канала", houseNumber: 58 },
        position: { lat: 59.9155393, lng: 30.3455362 },
        date: new Date(1944, 1, 5),
        description: "Пробито чердачное перекрытие 3 этажа.",
    },
    {
        type: 2,
        address: { street: "Парашютная улица", houseNumber: 60 },
        position: { lat: 60.0388203, lng: 30.2393449 },
        date: new Date(1942, 11, 2),
        description: "Пробито чердачное перекрытие 3 этажа.",
    },
    {
        type: 0,
        address: { street: "Большая Конюшенная улица", houseNumber: 4 },
        position: { lat: 59.9389665, lng: 30.3239588 },
        date: new Date(1945, 3, 2),
        description: "Пробито чердачное перекрытие 3 этажа.",
    },
    {
        type: 2,
        address: { street: "Московский проспект", houseNumber: 97 },
        position: { lat: 59.8932803, lng: 30.3178883 },
        date: new Date(1942, 9, 0),
        description: "Пробито чердачное перекрытие 3 этажа.",
    },
    {
        type: 0,
        address: { street: "Приморский проспект", houseNumber: 72 },
        position: { lat: 59.9825035, lng: 30.2108266 },
        date: new Date(1943, 7, 5),
        description: "Пробито чердачное перекрытие 3 этажа.",
    },
    {
        type: 0,
        address: { street: "Английская набережная", houseNumber: 52 },
        position: { lat: 59.9324776, lng: 30.2879359 },
        date: new Date(1944, 11, 1),
        description: "Пробито чердачное перекрытие 3 этажа.",
    },
    {
        type: 1,
        address: { street: "Казанская улица", houseNumber: 28 },
        position: { lat: 59.9303335, lng: 30.3168173 },
        date: new Date(1943, 6, 3),
        description: "Пробито чердачное перекрытие 3 этажа.",
    },
    {
        type: 2,
        address: { street: "Шпалерная улица", houseNumber: 19 },
        position: { lat: 59.9489625, lng: 30.3483821 },
        date: new Date(1943, 6, 5),
        description: "Пробито чердачное перекрытие 3 этажа.",
    },
    {
        type: 1,
        address: { street: "Волковский проспект", houseNumber: 32 },
        position: { lat: 59.8961805, lng: 30.3578691 },
        date: new Date(1944, 2, 5),
        description: "Пробито чердачное перекрытие 3 этажа.",
    },
    {
        type: 2,
        address: { street: "Кронверкский проспект", houseNumber: 23 },
        position: { lat: 59.9569182, lng: 30.3190598 },
        date: new Date(1945, 6, 6),
        description: "Пробито чердачное перекрытие 3 этажа.",
    },
    {
        type: 2,
        address: { street: "проспект Строителей", houseNumber: 31 },
        position: { lat: 59.8984463, lng: 30.5228278 },
        date: new Date(1943, 6, 5),
        description: "Пробито чердачное перекрытие 3 этажа.",
    },
    {
        type: 1,
        address: { street: "аллея Поликарпова", houseNumber: 1 },
        position: { lat: 60.0072857, lng: 30.2937456 },
        date: new Date(1944, 3, 5),
        description: "Пробито чердачное перекрытие 3 этажа.",
    },
    {
        type: 1,
        address: { street: "улица Нахимова", houseNumber: 1 },
        position: { lat: 59.9441711, lng: 30.2352494 },
        date: new Date(1944, 11, 2),
        description: "Пробито чердачное перекрытие 3 этажа.",
    },
    {
        type: 2,
        address: { street: "Староорловская улица", houseNumber: 17 },
        position: { lat: 60.0511479, lng: 30.2967936 },
        date: new Date(1941, 6, 1),
        description: "Пробито чердачное перекрытие 3 этажа.",
    },
    {
        type: 1,
        address: { street: "Железноводская улица", houseNumber: 7 },
        position: { lat: 59.9525995, lng: 30.2546989 },
        date: new Date(1942, 5, 5),
        description: "Пробито чердачное перекрытие 3 этажа.",
    },
    {
        type: 0,
        address: { street: "Разъезжая улица", houseNumber: 39 },
        position: { lat: 59.9220238, lng: 30.3514733 },
        date: new Date(1945, 0, 2),
        description: "Пробито чердачное перекрытие 3 этажа.",
    },
    {
        type: 0,
        address: { street: "набережная Обводного канала", houseNumber: 135 },
        position: { lat: 59.9093722, lng: 30.3166421 },
        date: new Date(1944, 5, 2),
        description: "Пробито чердачное перекрытие 3 этажа.",
    },
    {
        type: 0,
        address: { street: "Гражданский проспект", houseNumber: 36 },
        position: { lat: 60.0113861, lng: 30.3945728 },
        date: new Date(1942, 0, 3),
        description: "Пробито чердачное перекрытие 3 этажа.",
    },
    {
        type: 0,
        address: { street: "площадь Островского", houseNumber: 3 },
        position: { lat: 59.9324658, lng: 30.3353895 },
        date: new Date(1944, 1, 5),
        description: "Пробито чердачное перекрытие 3 этажа.",
    },
    {
        type: 0,
        address: { street: "Свечной переулок", houseNumber: 12 },
        position: { lat: 59.9245501, lng: 30.3505091 },
        date: new Date(1943, 7, 3),
        description: "Пробито чердачное перекрытие 3 этажа.",
    },
    {
        type: 2,
        address: { street: "набережная Чёрной речки", houseNumber: 6 },
        position: { lat: 59.9877488, lng: 30.3003615 },
        date: new Date(1944, 8, 3),
        description: "Пробито чердачное перекрытие 3 этажа.",
    },
    {
        type: 2,
        address: { street: "Карташихина улица", houseNumber: 10 },
        position: { lat: 59.9323288, lng: 30.2412965 },
        date: new Date(1942, 2, 2),
        description: "Пробито чердачное перекрытие 3 этажа.",
    },
    {
        type: 2,
        address: { street: "Дунайский проспект", houseNumber: 44 },
        position: { lat: 59.8393168, lng: 30.3952173 },
        date: new Date(1941, 6, 3),
        description: "Пробито чердачное перекрытие 3 этажа.",
    },
    {
        type: 1,
        address: { street: "Расстанная улица", houseNumber: 7 },
        position: { lat: 59.9070613, lng: 30.3472112 },
        date: new Date(1944, 5, 3),
        description: "Пробито чердачное перекрытие 3 этажа.",
    },
    {
        type: 2,
        address: { street: "проспект Художников", houseNumber: 15 },
        position: { lat: 60.0376504, lng: 30.3458653 },
        date: new Date(1942, 10, 6),
        description: "Пробито чердачное перекрытие 3 этажа.",
    },
    {
        type: 2,
        address: { street: "улица Шевченко", houseNumber: 16 },
        position: { lat: 59.9315688, lng: 30.2450662 },
        date: new Date(1943, 11, 2),
        description: "Пробито чердачное перекрытие 3 этажа.",
    },
    {
        type: 2,
        address: { street: "набережная канала Грибоедова", houseNumber: 11 },
        position: { lat: 59.9375291, lng: 30.3268611 },
        date: new Date(1943, 0, 3),
        description: "Пробито чердачное перекрытие 3 этажа.",
    },
    {
        type: 1,
        address: { street: "Калинкин переулок", houseNumber: 1 },
        position: { lat: 59.9166168, lng: 30.2885518 },
        date: new Date(1943, 8, 6),
        description: "Пробито чердачное перекрытие 3 этажа.",
    },
    {
        type: 1,
        address: { street: "Никольская улица", houseNumber: 16 },
        position: { lat: 60.0446353, lng: 30.3034878 },
        date: new Date(1943, 1, 3),
        description: "Пробито чердачное перекрытие 3 этажа.",
    },
    {
        type: 2,
        address: { street: "набережная реки Мойки", houseNumber: 39 },
        position: { lat: 59.9396744, lng: 30.3189489 },
        date: new Date(1944, 11, 5),
        description: "Пробито чердачное перекрытие 3 этажа.",
    },
    {
        type: 1,
        address: { street: "улица Зодчего Росси", houseNumber: 3 },
        position: { lat: 59.9293503, lng: 30.3349169 },
        date: new Date(1945, 4, 3),
        description: "Пробито чердачное перекрытие 3 этажа.",
    },
    {
        type: 1,
        address: { street: "Галерная улица", houseNumber: 30 },
        position: { lat: 59.9319111, lng: 30.2899301 },
        date: new Date(1941, 7, 1),
        description: "Пробито чердачное перекрытие 3 этажа.",
    },
    {
        type: 1,
        address: { street: "проспект Обуховской Обороны", houseNumber: 151 },
        position: { lat: 59.8798045, lng: 30.4467183 },
        date: new Date(1942, 2, 2),
        description: "Пробито чердачное перекрытие 3 этажа.",
    },
    {
        type: 0,
        address: { street: "набережная канала Грибоедова", houseNumber: 71 },
        position: { lat: 59.926069, lng: 30.3130003 },
        date: new Date(1943, 1, 4),
        description: "Пробито чердачное перекрытие 3 этажа.",
    },
    {
        type: 1,
        address: { street: "Большой Сампсониевский проспект", houseNumber: 33 },
        position: { lat: 59.9665802, lng: 30.3431405 },
        date: new Date(1942, 10, 3),
        description: "Пробито чердачное перекрытие 3 этажа.",
    },
    {
        type: 1,
        address: { street: "улица Блохина", houseNumber: 23 },
        position: { lat: 59.9524327, lng: 30.2969484 },
        date: new Date(1944, 4, 4),
        description: "Пробито чердачное перекрытие 3 этажа.",
    },
    {
        type: 2,
        address: { street: "улица Академика Павлова", houseNumber: 5 },
        position: { lat: 59.9775354, lng: 30.3180385 },
        date: new Date(1942, 3, 0),
        description: "Пробито чердачное перекрытие 3 этажа.",
    },
    {
        type: 0,
        address: { street: "улица Кораблестроителей", houseNumber: 14 },
        position: { lat: 59.938293, lng: 30.2145147 },
        date: new Date(1944, 9, 4),
        description: "Пробито чердачное перекрытие 3 этажа.",
    },
    {
        type: 1,
        address: { street: "Менделеевская улица", houseNumber: 6 },
        position: { lat: 59.9768516, lng: 30.3601868 },
        date: new Date(1943, 1, 1),
        description: "Пробито чердачное перекрытие 3 этажа.",
    },
    {
        type: 1,
        address: { street: "улица Правды", houseNumber: 11 },
        position: { lat: 59.9225786, lng: 30.3407593 },
        date: new Date(1944, 8, 3),
        description: "Пробито чердачное перекрытие 3 этажа.",
    },
    {
        type: 2,
        address: { street: "Большая Московская улица", houseNumber: 10 },
        position: { lat: 59.9260989, lng: 30.3472282 },
        date: new Date(1942, 0, 1),
        description: "Пробито чердачное перекрытие 3 этажа.",
    },
    {
        type: 2,
        address: { street: "Большой проспект В.О.", houseNumber: 61 },
        position: { lat: 59.93561, lng: 30.2690489 },
        date: new Date(1942, 4, 0),
        description: "Пробито чердачное перекрытие 3 этажа.",
    },
    {
        type: 1,
        address: { street: "Железноводская улица", houseNumber: 38 },
        position: { lat: 59.9510469, lng: 30.2448695 },
        date: new Date(1944, 8, 0),
        description: "Пробито чердачное перекрытие 3 этажа.",
    },
    {
        type: 1,
        address: { street: "улица Кораблестроителей", houseNumber: 14 },
        position: { lat: 59.938293, lng: 30.2145147 },
        date: new Date(1942, 0, 6),
        description: "Пробито чердачное перекрытие 3 этажа.",
    },
    {
        type: 2,
        address: { street: "Оборонная улица", houseNumber: 14 },
        position: { lat: 60.0446509, lng: 30.4635927 },
        date: new Date(1945, 4, 4),
        description: "Пробито чердачное перекрытие 3 этажа.",
    },
    {
        type: 0,
        address: { street: "Загородный проспект", houseNumber: 30 },
        position: { lat: 59.9247123, lng: 30.3390493 },
        date: new Date(1943, 2, 5),
        description: "Пробито чердачное перекрытие 3 этажа.",
    },
    {
        type: 1,
        address: { street: "Кузнецовская улица", houseNumber: 23 },
        position: { lat: 59.8714873, lng: 30.3184219 },
        date: new Date(1945, 1, 2),
        description: "Пробито чердачное перекрытие 3 этажа.",
    },
    {
        type: 2,
        address: { street: "набережная реки Фонтанки", houseNumber: 195 },
        position: { lat: 59.9166908, lng: 30.2847838 },
        date: new Date(1943, 1, 2),
        description: "Пробито чердачное перекрытие 3 этажа.",
    },
    {
        type: 0,
        address: { street: "переулок Пирогова", houseNumber: 2 },
        position: { lat: 59.9298306, lng: 30.307856 },
        date: new Date(1944, 5, 2),
        description: "Пробито чердачное перекрытие 3 этажа.",
    },
    {
        type: 1,
        address: { street: "Большая Пушкарская улица", houseNumber: 52 },
        position: { lat: 59.9627686, lng: 30.3099365 },
        date: new Date(1945, 1, 0),
        description: "Пробито чердачное перекрытие 3 этажа.",
    },
    {
        type: 0,
        address: { street: "улица Профессора Качалова", houseNumber: 11 },
        position: { lat: 59.911323, lng: 30.3903635 },
        date: new Date(1944, 7, 2),
        description: "Пробито чердачное перекрытие 3 этажа.",
    },
    {
        type: 1,
        address: { street: "Садовая улица", houseNumber: 1 },
        position: { lat: 60.0411505, lng: 30.4530838 },
        date: new Date(1943, 4, 0),
        description: "Пробито чердачное перекрытие 3 этажа.",
    },
];
exports.default = hits;
